<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-client-page-heading">
                    <h3 class="fw-bold">{{ Garantidora.garId ? 'Alterar garantidora' : 'Nova garantidora' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Garantidoras</a></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ Garantidora.garId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                    <v-tab value="dados" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Dados Garantidora</v-tab>
                                    <div v-if="Garantidora.garId != 0">
                                        <v-tab value="plano" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Plano</v-tab>
                                    </div>
                                    <div v-if="Garantidora.garId != 0 && User.tusid != 3">
                                        <v-tab value="configuracoes" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Configurações</v-tab>
                                    </div>
                                    <div v-if="Garantidora.garId != 0 && User.tusid != 3">
                                        <v-tab value="pagamento" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Pagamento</v-tab>
                                    </div>
                                    <div v-if="Garantidora.garId != 0">
                                        <v-tab value="contrato" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Contrato</v-tab>
                                    </div>
                                     <div v-if="Garantidora.garId != 0 && User.garid == 0 && User.tusid != 3">
                                        <v-tab value="fatura" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Faturamento</v-tab>
                                    </div>
                                    <div v-if="User.garid == 0 && Garantidora.garId != 0 && Garantidora .garEmiteNota && User.tipo != 3">
                                        <v-tab value="nota" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Dados Nota</v-tab>
                                    </div>
                                     <div v-if="Garantidora.garId != 0">
                                        <v-tab value="sinistro" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Sinistros</v-tab>
                                    </div>
                                     <div v-if="Garantidora.garId != 0 && User.garid == 0 && User.tusid != 3">
                                        <v-tab value="cancelamento" class="tabinfo" style="font-size: 13px;text-transform: none !important;">Bloqueios</v-tab>
                                    </div>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <div class="gp-admin-form-header gp-guarantor-section-header">
                                            <span><v-icon size="20">mdi-domain</v-icon></span>
                                            <div>
                                                <h4>Dados da garantidora</h4>
                                                <p>Preencha as informações cadastrais, contatos e configurações principais.</p>
                                            </div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Garantidora.garId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2" v-if="User!=''">
                                                        <div class="form-group">
                                                            <label>Tipo Pessoa</label>
                                                            <select  v-model="Garantidora.tpdId" class="form-select form-control" :disabled="User.tpeid == 1">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in TiposDocumentos" :key="optionTipo.tpdId"
                                                                    :value="optionTipo.tpdId">{{ optionTipo.tpdNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="User!=''">
                                                        <div class="form-group">
                                                            <label>Nº {{ Garantidora.tpdId == 1 ? 'CPF' : 'CNPJ'}}</label>
                                                            <input v-model="Garantidora.garDocumento" type="text" v-mask="documentoMask" :disabled="User.tpeid == 1"
                                                                @input="NormalizaDocumentoGarantidora()"
                                                                class="form-control" :placeholder="Garantidora.tpdId == 1 ? 'CPF' : 'CNPJ'" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Nome</label>
                                                            <input v-model="Garantidora.garNomeEmpresa" type="text"
                                                                class="form-control" :placeholder="Garantidora.tpdId == 1 ? 'Nome' : 'Nome Fantasia'" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Garantidora.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>Razão Social</label>
                                                            <input v-model="Garantidora.garRazaoSocial" type="text"
                                                                class="form-control" placeholder="Razão Social" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Garantidora.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>Nome Responsável</label>
                                                            <input v-model="Garantidora.garResponsavel" type="text"
                                                                class="form-control" placeholder="Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Garantidora.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>CPF Responsável</label>
                                                            <input v-model="Garantidora.garCampoExtra1" type="text" v-mask="'###.###.###-##'"
                                                                class="form-control" placeholder="CPF Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Telefone</label>
                                                            <input v-model="Garantidora.garTelefone" v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Whatsapp</label>
                                                            <input v-model="Garantidora.garWhatsapp" v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="User!=''">
                                                        <div class="form-group">
                                                            <label>E-mail</label>
                                                            <input v-model="Garantidora.garEmail" type="text" class="form-control" :disabled="User.tpeid == 1"
                                                                placeholder="E-mail" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Indicação</label>
                                                            <input v-model="Garantidora.garCampoExtra2" type="text" class="form-control" :disabled="User.tpeid == 1"
                                                                placeholder="Indicação" />
                                                        </div>
                                                    </div>
                                                    <div class="col-12" v-if="User.garid == 0 && User.tusid != 3">
                                                        <div class="gp-guarantor-url-config">
                                                            <label for="garUrlParcial">URL personalizada de acesso</label>
                                                            <div class="gp-guarantor-url-input">
                                                                <span>{{ getGuarantorAccessBaseUrl() }}</span>
                                                                <input id="garUrlParcial" v-model.trim="Garantidora.garUrlParcial"
                                                                    type="text" class="form-control" maxlength="100"
                                                                    autocomplete="off" spellcheck="false"
                                                                    placeholder="chave-da-garantidora"
                                                                    @blur="NormalizaUrlParcial()" />
                                                            </div>
                                                            <small>Informe somente a parte final da URL. Use letras, números, hífen ou sublinhado.</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                      <div class="gp-guarantor-settings">
                                                        <div class="gp-guarantor-setting" v-if="User.garid == 0 && User.tusid != 3">
                                                            <v-switch
                                                                v-model="Garantidora.garEmiteNota"
                                                                label="Emite Nota"
                                                                color="#e77900"
                                                                hide-details
                                                                :disabled="User.tpeid === 1"
                                                            ></v-switch>
                                                        </div>
                                                        <div class="gp-guarantor-setting" v-if="User.garid == 0 && User.tusid != 3">
                                                            <v-switch
                                                                v-model="Garantidora.garCampoExtra5"
                                                                label="Controlar Contratações por data vigência"
                                                                color="#e77900"
                                                                hide-details
                                                                true-value="1"
                                                                false-value="0"
                                                                :disabled="User.tpeid === 1"
                                                            ></v-switch>
                                                        </div>
                                                        <div class="gp-guarantor-logo">
                                                            <label>Logo da garantidora</label>
                                                            <v-file-input v-model="selectedFile" label="Selecionar imagem" variant="outlined"
                                                                density="compact" prepend-inner-icon="mdi-image-outline" prepend-icon="" accept="image/*" hide-details></v-file-input>
                                                        </div>
                                                        <div class="gp-guarantor-logo-preview" v-if="Garantidora.garUrlLogo !== '' && Garantidora.garUrlLogo !== null">
                                                            <img :src="buildFileUrl(Garantidora.garUrlLogo)" alt="Logo da garantidora" />
                                                            <button type="button" class="gp-table-action gp-action-delete" title="Remover logo" @click="DeleteImagem()">
                                                                <v-icon size="17">mdi-trash-can-outline</v-icon>
                                                            </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                     <div class="col-12" v-if="buildGuarantorAccessUrl()">
                                                         <div class="gp-guarantor-access-link"><v-icon size="17">mdi-link-variant</v-icon><span><small>Link de acesso customizado</small><strong>{{ buildGuarantorAccessUrl() }}</strong></span></div>
                                                     </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        <section class="gp-guarantor-address">
                                            <div class="gp-admin-form-header">
                                                <span><v-icon size="20">mdi-map-marker-outline</v-icon></span>
                                                <div>
                                                    <h4>Endereço</h4>
                                                    <p>Informe o CEP e complete os dados de localização da garantidora.</p>
                                                </div>
                                            </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Endereco.gaeId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <input v-model="Endereco.garId" type="text"
                                                                class="form-control" placeholder="Id Garantidora" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CEP</label>
                                                            <input v-model="Endereco.gaeCep" v-mask="'#####-###'" type="text"
                                                                class="form-control" placeholder="CEP" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group gp-cep-action">
                                                            <button type="button" class="btn btn-info" @click.prevent="Buscacep(Endereco.gaeCep)" style="color:#ffffff;">
                                                                Verificar CEP
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-lg-5" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Endereço</label>
                                                            <input v-model="Endereco.gaeEndereco" type="text"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Número</label>
                                                            <input v-model="Endereco.gaeNumero" type="number"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Complemento</label>
                                                            <input v-model="Endereco.gaeComplemento" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1 col-lg-1" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Estado</label>
                                                            <input v-model="Endereco.gaeEstado" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Cidade</label>
                                                            <input v-model="Endereco.gaeCidade" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Bairro</label>
                                                            <input v-model="Endereco.gaeBairro" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Cod. Distrito (IBGE)</label>
                                                                <input v-model="Endereco.gaeCodigoDistrito" type="number"
                                                                    class="form-control" placeholder="Cod. Distrito" />
                                                            </div>
                                                        </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        </section>
                                    </v-window-item>
                                    <!--endereco-->
                                     <!--plano-->
                                     <v-window-item value="plano">
                                        <div class="gp-admin-form-header gp-guarantor-section-header">
                                            <span><v-icon size="20">mdi-card-account-details-outline</v-icon></span>
                                            <div>
                                                <h4>Plano</h4>
                                                <p>Defina o plano, valores, cobrança, vigência e limites da garantidora.</p>
                                            </div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="GarantidoraPlanos.gplId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <input v-model="GarantidoraPlanos.garId" type="text"
                                                                class="form-control" placeholder="Id Garantidora" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Planos</label>
                                                            <select  v-model="GarantidoraPlanos.cpgId" class="form-select form-control" @change="CarregaValoresPlano()">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListaPlanos" :key="optionTipo.cpgId"
                                                                    :value="optionTipo.cpgId">{{ optionTipo.cpgNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Valor Mensal R$</label>
                                                            <input v-model="GarantidoraPlanos.gplValor" v-decimal
                                                                class="form-control" placeholder="Valor Mensal" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Tipo Cobrança</label>
                                                            <select v-model="GarantidoraPlanos.gplTipoCobranca" class="form-select form-control">
                                                                <option value="">Selecione</option>
                                                                <option value="Pré">Pré</option>
                                                                <option value="Pós">Pós</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Vencimento Dia</label>
                                                            <input v-model="GarantidoraPlanos.gplVencimento" type="number"
                                                                class="form-control" placeholder="Vencimento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Vigência Inicial</label>
                                                            <input v-model="GarantidoraPlanos.gplVigenciaInicial" type="date"
                                                                class="form-control" placeholder="Vigência" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Remuneração por Negócio</label>
                                                            <input v-model="GarantidoraPlanos.gplRemuneracaoNegocio" v-decimal
                                                                class="form-control" placeholder="Remuneração" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Valor de Adesão R$</label>
                                                            <input v-model="GarantidoraPlanos.gplValorAdesao" v-decimal
                                                                class="form-control" placeholder="Valor de Adesão" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Qtde Usuários</label>
                                                            <input v-model="GarantidoraPlanos.gplQtdeUsuarios" type="number"
                                                                class="form-control" placeholder="Qtde Usuários" />
                                                        </div>
                                                    </div>
                                                    <div v-for="tipo in ['Residencial', 'Comercial']" :key="tipo" class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Valor Mínimo Setup {{ tipo }} R$</label>
                                                            <input v-model="GarantidoraPlanos['gplValorMinSetup' + tipo]" v-decimal
                                                                class="form-control" :placeholder="'Valor Mínimo Setup ' + tipo + ' R$'" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-10 col-lg-10">
                                                        <div class="form-group">
                                                            <button v-if="GarantidoraPlanos.gplId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                                                                @click="PlanoPut()">
                                                                Alterar Plano
                                                            </button>
                                                            <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="PlanoAdd()">
                                                                Salvar Plano
                                                            </button>
                                                            <a href="#" @click="PlanoCancel()" class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        <section class="gp-guarantor-subsection" v-if="Garantidora.garId != 0">
                                            <div class="gp-admin-form-header">
                                                <span><v-icon size="20">mdi-puzzle-plus-outline</v-icon></span>
                                                <div>
                                                    <h4>Serviços extras</h4>
                                                    <p>{{ User.garid == 0 ? 'Adicione serviços complementares vinculados ao plano da garantidora.' : 'Consulte os serviços complementares vinculados ao seu plano.' }}</p>
                                                </div>
                                            </div>
                                        <v-form><fieldset :disabled="isSubmittingServicoExtra" class="border-0 p-0 w-100">
                                            <v-container>
                                                <div class="row">
                                                    <div v-if="User.garid == 0" class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Servico</label>
                                                            <select v-model="ServicoExtra.lseId" class="form-select form-control" @change="ServicoExtraSeleciona()">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionServico in ListaServicosExtrasCadastro" :key="optionServico.lseId"
                                                                    :value="optionServico.lseId" :disabled="ServicoExtraJaIncluido(optionServico.lseId)">{{ optionServico.lseNome }}{{ ServicoExtraJaIncluido(optionServico.lseId) ? ' (já incluído)' : '' }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div v-if="User.garid == 0" class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Quantidade</label>
                                                            <input v-model="ServicoExtra.gsvQuantidade" type="number"
                                                                class="form-control" placeholder="Quantidade" />
                                                        </div>
                                                    </div>
                                                    <div v-if="User.garid == 0" class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Valor R$</label>
                                                            <input v-model="ServicoExtra.gsvValor" v-decimal
                                                                class="form-control" placeholder="Valor" />
                                                        </div>
                                                    </div>
                                                    <div v-if="User.garid == 0" class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Periodicidade</label>
                                                            <select v-model="ServicoExtra.gsvPeriodicidade" class="form-select form-control">
                                                                <option value="">Selecione</option>
                                                                <option value="Mensal">Mensal</option>
                                                                <option value="Anual">Anual</option>
                                                                <option value="Unica">Unica</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div v-if="User.garid == 0" class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Data Inicio</label>
                                                            <input v-model="ServicoExtra.gsvDataInicio" type="date"
                                                                class="form-control" />
                                                        </div>
                                                    </div>
                                                    <div v-if="User.garid == 0" class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Primeiro vencimento</label>
                                                            <input v-model="ServicoExtra.gsvProximaCobranca" type="date"
                                                                class="form-control" />
                                                        </div>
                                                    </div>
                                                    <div v-if="User.garid == 0 && ModoFinanceiro.enviarAoFinanceiro" class="col-12">
                                                        <div class="gp-billing-policy">
                                                            <h5>Configuração financeira do serviço</h5>
                                                            <div class="gp-billing-policy-grid">
                                                                <template v-if="ModoFinanceiro.enviarAoFinanceiro">
                                                                <label>Tipo de cobrança<input value="Link de pagamento Autra" class="form-control" disabled /></label>
                                                                <label>Multa (%)<input v-model.number="ServicoExtraConfig.collectionPolicy.penaltyPercentage" type="number" min="0" max="100" step="0.000001" class="form-control" /></label>
                                                                <label>Juros por dia (%)<input v-model.number="ServicoExtraConfig.collectionPolicy.dailyInterestPercentage" type="number" min="0" max="100" step="0.000001" class="form-control" /></label>
                                                                <label><input v-model="ServicoExtraConfig.collectionPolicy.allowedPaymentMethodCodes" type="checkbox" value="CC" /> Cartão de crédito</label>
                                                                <label><input v-model="ServicoExtraConfig.collectionPolicy.allowedPaymentMethodCodes" type="checkbox" value="PIX" /> Pix</label>
                                                                <label><input v-model="ServicoExtraConfig.collectionPolicy.allowedPaymentMethodCodes" type="checkbox" value="BB" /> Boleto/Pix (Autra)</label>
                                                                </template>
                                                            </div>
                                                            <v-alert type="info" variant="tonal" density="compact" class="mt-3">Cada serviço mensal ou anual gera uma recorrência independente, sem término, com quantidade e valor fixos. Serviços únicos geram uma cobrança avulsa. O Financeiro define as competências e as datas de geração conforme os dados enviados. A pausa e a reativação das novas recorrências aguardam integração com o Financeiro.</v-alert>
                                                            <small>A geração das cobranças é automática. Antecedência, horários, carência e envio de e-mail seguem a configuração do sistema. O dia de geração enviado é calculado pelo vencimento menos a antecedência menos um dia. A validação do calendário e a geração das cobranças são realizadas pelo Financeiro.</small>
                                                        </div>
                                                    </div>
                                                    <div v-if="User.garid == 0" class="col-md-2 col-lg-2">
                                                        <div class="form-group gp-extra-service-action">
                                                            <button type="button" class="btn btn-info" style="color:#ffffff;" :disabled="isSubmittingServicoExtra" @click="ServicoExtraAdd(false)">
                                                                {{ ServicoExtra.gsvId ? 'Salvar' : 'Incluir' }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div v-if="User.garid == 0" class="col-md-6 gp-extra-service-action">
                                                        <button v-if="ModoFinanceiro.enviarAoFinanceiro" type="button" class="btn btn-warning" :disabled="isSubmittingServicoExtra" @click="ServicoExtraAdd(true)">{{ ServicoExtra.gsvId ? 'Salvar e enviar ao Financeiro' : 'Incluir e enviar ao Financeiro' }}</button>
                                                        <button v-if="ServicoExtra.gsvId" type="button" class="btn btn-link" :disabled="isSubmittingServicoExtra" @click="ServicoExtraReset()">Cancelar edição</button>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th>Servico</th>
                                                                    <th>Quantidade</th>
                                                                    <th>Valor</th>
                                                                    <th>Periodicidade</th>
                                                                    <th>Data Inicio</th>
                                                                    <th>Primeiro vencimento</th><th>Situação</th>
                                                                    <th v-if="User.garid == 0" style="width: 100px;">Ações</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in ListaGarantidoraServicosExtras" :key="item.gsvId">
                                                                    <td>{{ ServicoExtraNome(item.lseId) }}</td>
                                                                    <td>{{ item.gsvQuantidade }}</td>
                                                                    <td>{{ formatCurrency(item.gsvValor) }}</td>
                                                                    <td>{{ item.gsvPeriodicidade }}</td>
                                                                    <td>{{ formatDate(item.gsvDataInicio) }}</td>
                                                                    <td>{{ formatDate(item.gsvProximaCobranca) }}</td>
                                                                    <td><v-chip size="small" :color="item.gsvAtivo === false ? 'grey' : 'success'">{{ item.gsvAtivo === false ? 'Inativo' : 'Ativo' }}</v-chip><div class="small">{{ item.gsvFinanceiroEnviado ? 'Envio financeiro registrado' : 'Não enviado' }}</div></td>
                                                                    <td v-if="User.garid == 0">
                                                                        <div class="d-flex flex-wrap gap-2">
                                                                            <button v-if="!item.gsvFinanceiroEnviado" type="button" class="btn btn-sm btn-outline-primary" :disabled="isSubmittingServicoExtra" @click="ServicoExtraEditar(item)">Configurar</button>
                                                                            <button v-if="ModoFinanceiro.enviarAoFinanceiro && !item.gsvFinanceiroEnviado && item.gsvAtivo !== false" type="button" class="btn btn-sm btn-warning" :disabled="isSubmittingServicoExtra" @click="ServicoExtraEnviar(item)">Sincronizar Financeiro</button>
                                                                            <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="isSubmittingServicoExtra || ServicoExtraRecorrenciaEnviada(item)" :title="ServicoExtraRecorrenciaEnviada(item) ? 'Pausa/reativação da recorrência ainda não integrada' : ''" @click="ServicoExtraInativar(item)">{{ item.gsvAtivo === false ? 'Reativar' : 'Inativar' }}</button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </fieldset></v-form>
                                        </section>
                                    </v-window-item>
                                      <!--servicos extras-->
                                      <!--serasa-->
                                      <v-window-item value="configuracoes">
                                        <section class="gp-guarantor-subsection" v-if="Garantidora.garId != 0 && User.tusid != 3">
                                        <div class="gp-admin-form-header">
                                            <span><v-icon size="20">mdi-chart-line</v-icon></span>
                                            <div><h4>Análise de crédito</h4><p>Configure limites de consultas e o nível de aprovação automática.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-12 col-lg-12" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Defina o nível de aprovação: resultados da análise de crédito com score igual ou superior ao <br/>selecionado serão aprovados automaticamente.
                                                               <br/>Scores inferiores seguirão para a etapa de análise manual da garantidora.</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Serasa.gseId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <input v-model="Serasa.garId" type="text"
                                                                class="form-control" placeholder="Id Garantidora" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Qtde Consultas Mensal</label>
                                                            <input v-model="Serasa.gseQtdeMensal" type="number"
                                                                class="form-control" placeholder="Qtde Consultas" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Custo Consulta Extra R$</label>
                                                            <input v-model="Serasa.gseCustoPesExtra" v-decimal
                                                                class="form-control" placeholder="Custo Extra" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Qtde Grátis Mensal</label>
                                                            <input v-model="Serasa.gseQtdeGratisMensal" type="number"
                                                                class="form-control" placeholder="Qtde Grátis" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Nível de Aprovação</label>
                                                            <v-slider
                                                                v-model="Serasa.gseRangeAprovacao"
                                                                :max="1000"
                                                                :min="0"
                                                                :step="50"
                                                                thumb-label="always"
                                                                style="padding-top: 20px;"
                                                            ></v-slider>
                                                             <small style="color:#d38642">*Indicação de níveis de aprovação: de 0-200 (baixo), 201-400 (mediano), 401-600 (muito bom), acima de 600 (ótimo)</small>
                                                        </div>

                                                    </div>
                                                    <div class="col-md-4">
                                                        <label for="garantiaMin">Valor mínimo da garantia (R$)</label>
                                                        <input id="garantiaMin" v-model.trim="Serasa.gseValorGarantiaMinimo" inputmode="decimal" class="form-control" placeholder="Sem mínimo" />
                                                    </div>
                                                    <div class="col-md-4">
                                                        <label for="garantiaMax">Valor máximo para aprovação automática (R$)</label>
                                                        <input id="garantiaMax" v-model.trim="Serasa.gseValorGarantiaMaximo" inputmode="decimal" class="form-control" placeholder="Sem máximo" />
                                                    </div>
                                                    <div class="col-12"><small>Os limites consideram o pacote mais o setup. Abaixo do mínimo, a contratação é bloqueada; acima do máximo, segue para análise manual.</small></div>
                                                      <div class="col-md-10 col-lg-10">
                                                        <div class="form-group">
                                                            <button v-if="Serasa.gseId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                                                                @click="SerasaPut()">
                                                                Alterar Análise
                                                            </button>
                                                            <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="SerasaAdd()">
                                                                Salvar Análise
                                                            </button>
                                                            <a href="#" @click="SerasaCancel()" class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        </section>
                                      <!--serasa-->
                                        <!--processos-->
                                        <section class="gp-guarantor-subsection" v-if="User.garid == 0 && Garantidora.garId != 0 && User.tusid != 3">
                                        <div class="gp-admin-form-header">
                                            <span><v-icon size="20">mdi-scale-balance</v-icon></span>
                                            <div><h4>Análise jurídica</h4><p>Defina os valores e parâmetros utilizados nas consultas jurídicas.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Processos.gprId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <input v-model="Processos.garId" type="text"
                                                                class="form-control" placeholder="Id Garantidora" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-show="false">
                                                        <div class="form-group">
                                                            <label>Qtde Consultas Mensal</label>
                                                            <input v-model="Processos.gprQtdeMensal" type="number"
                                                                class="form-control" placeholder="Qtde Consultas" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Custo Consulta Extra R$</label>
                                                            <input v-model="Processos.gprCustoPesExtra" v-decimal
                                                                class="form-control" placeholder="Custo Extra" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-show="false">
                                                        <div class="form-group">
                                                            <label>Qtde Grátis Mensal</label>
                                                            <input v-model="Processos.gprQtdeGratisMensal" type="number"
                                                                class="form-control" placeholder="Qtde Grátis" />
                                                        </div>
                                                    </div>
                                                      <div class="col-md-10 col-lg-10">
                                                        <div class="form-group">
                                                            <button v-if="Processos.gprId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                                                                @click="ProcessosPut()">
                                                                Alterar
                                                            </button>
                                                            <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="ProcessosAdd()">
                                                                Salvar
                                                            </button>
                                                            <a href="#" @click="ProcessosCancel()" class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        </section>
                                      <!--serasa-->
                                       <!--Assinatura-->
                                       <section class="gp-guarantor-subsection" v-if="Garantidora.garId != 0 && User.tusid != 3">
                                        <div class="gp-admin-form-header">
                                            <span><v-icon size="20">mdi-file-document-edit-outline</v-icon></span>
                                            <div><h4>Assinatura</h4><p>Configure autenticação, limites e integração da plataforma de assinaturas.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-12 col-lg-12" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Ao salvar, será gerada integração com Asten para preenchimento dos dados de repositório e Token.<br>
                                                                Bem como será disparada notificação para a Garantidora complementar dados de cadastro na plataforma de assinaturas.</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Assinatura.gasId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <input v-model="Assinatura.garId" type="text"
                                                                class="form-control" placeholder="Id Garantidora" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Qtde Envelopes Mensal</label>
                                                            <input v-model="Assinatura.gasQtdeMensal" type="number"
                                                                class="form-control" placeholder="Qtde Envelopes" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Custo Extra R$</label>
                                                            <input v-model="Assinatura.gasCustoPesExtra" v-decimal
                                                                class="form-control" placeholder="Custo Extra" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>CPF para Assinaturas</label>
                                                            <input v-model="Assinatura.gasPropriedade" type="text"
                                                                class="form-control" placeholder="CPF para Assinaturas" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Qtde Grátis Mensal</label>
                                                            <input v-model="Assinatura.gasQtdeGratisMensal" type="number"
                                                                class="form-control" placeholder="Qtde Grátis" />
                                                        </div>
                                                    </div>
                                                     <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Opção de Autenticação</label>
                                                             <select  v-model="Assinatura.gasOpcaoAutenticacao" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListAutenticacoes" :key="optionTipo.Id"
                                                                    :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                     <div class="col-md-3 col-lg-3" v-if="Assinatura.gasOpcaoAutenticacao == 99">
                                                        <div class="form-group">
                                                            <label>Código Fixo</label>
                                                            <input v-model="Assinatura.gasCodigoExigido" type="text" maxlength="5"
                                                                class="form-control" placeholder="Código" />
                                                        </div>
                                                    </div>
                                                     <div class="col-md-2 col-lg-2" v-if="Assinatura.gasOpcaoAutenticacao == 2 || Assinatura.gasOpcaoAutenticacao == 3">
                                                        <div class="form-group">
                                                            <label>Analisar Imagem</label>
                                                           <select  v-model="Assinatura.gasAnalisarFaceImagem" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSimNaoText" :key="optionTipo.Id"
                                                                    :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="(Assinatura.gasOpcaoAutenticacao == 2 || Assinatura.gasOpcaoAutenticacao == 3) && Assinatura.gasAnalisarFaceImagem != null && Assinatura.gasAnalisarFaceImagem == 'S'">
                                                        <div class="form-group">
                                                            <label>Precisão Imagem (10 a 90)</label>
                                                          <input v-model="Assinatura.gasPercentualPrecisaoFace" type="number"
                                                                class="form-control" />
                                                        </div>
                                                    </div>
                                                     <div class="col-md-3 col-lg-3" v-show="false">
                                                        <div class="form-group">
                                                            <label>Link Assinatura via Whatsapp</label>
                                                           <select  v-model="Assinatura.gasEnviarWhatsapp" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSimNaoText" :key="optionTipo.Id"
                                                                    :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12" style="padding-top: 60px;" v-if="User.garid == 0">
                                                        *Somente preencha os campos abaixo se ja estiver configurado na Asten
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Código Repositorio</label>
                                                            <input v-model="Assinatura.gasIdRepositorio" type="text"
                                                                class="form-control" placeholder="Repositorio" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Id Usuário Asten</label>
                                                            <input v-model="Assinatura.gasIdUserAsten" type="text"
                                                                class="form-control" placeholder="Id Usuário Asten" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Token</label>
                                                            <input v-model="Assinatura.gasToken" type="text"
                                                                class="form-control" placeholder="Token" />
                                                        </div>
                                                    </div>
                                                      <div class="col-md-10 col-lg-10">
                                                        <div class="form-group">
                                                            <button v-if="Assinatura.gasId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                                                                @click="AssinaturaPut()">
                                                                Alterar Assinatura
                                                            </button>
                                                            <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="AssinaturaAdd()">
                                                                Salvar Assinatura
                                                            </button>
                                                            <a href="#" @click="AssinaturaCancel()" class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                       </section>
                                       </v-window-item>
                                       <!--Assinatura-->
                                       <!--Pagamentos-->
                                       <v-window-item value="pagamento">
                                        <div class="gp-admin-form-header gp-guarantor-section-header">
                                            <span><v-icon size="20">mdi-credit-card-outline</v-icon></span>
                                            <div>
                                                <h4>Pagamento</h4>
                                                <p>Configure a operadora, cobrança e informações financeiras da garantidora.</p>
                                            </div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Pagamento.gpgId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <input v-model="Pagamento.garId" type="text"
                                                                class="form-control" placeholder="Id Garantidora" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Operadoras</label>
                                                            <select  v-model="Pagamento.topId" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in TipoOperadoras" :key="optionTipo.topId"
                                                                    :value="optionTipo.topId">{{ optionTipo.topNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>E-mail Notificação</label>
                                                            <input v-model="Pagamento.gpgEmailAviso" type="text"
                                                                class="form-control" placeholder="E-mail Notificação" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6" v-if="User.garid == 0 && Pagamento.topId == 1">
                                                        <div class="form-group">
                                                            <label>Chave de identificação</label>
                                                            <input v-model="Pagamento.gpgSplitToken" type="text"
                                                                class="form-control" placeholder="Chave Identificação" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Cód. Banco</label>
                                                            <input v-model="Pagamento.gpgSplitBanco" type="text"
                                                                class="form-control" placeholder="Código" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Nome Banco</label>
                                                            <input v-model="Pagamento.gpgSplitBancoNome" type="text"
                                                                class="form-control" placeholder="Nome Banco" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Agência</label>
                                                            <input v-model="Pagamento.gpgSplitAgencia" type="text"
                                                                class="form-control" placeholder="Agência" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Conta</label>
                                                            <input v-model="Pagamento.gpgSplitConta" type="text"
                                                                class="form-control" placeholder="Conta" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Tipo Conta</label>
                                                            <input v-model="Pagamento.gpgSplitTipoConta" type="text"
                                                                class="form-control" placeholder="Tipo Conta" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Titular</label>
                                                            <input v-model="Pagamento.gpgSplitTitularConta" type="text"
                                                                class="form-control" placeholder="Titular" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Documento</label>
                                                            <input v-model="Pagamento.gpgSplitTitularDocumento" type="text"
                                                                class="form-control" placeholder="Documento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Chave Pix</label>
                                                            <input v-model="Pagamento.gpgSplitChavePix" type="text"
                                                                class="form-control" placeholder="Chave Pix" />
                                                        </div>
                                                    </div>
                                                      <div class="col-md-10 col-lg-10">
                                                        <div class="form-group">
                                                            <button v-if="Pagamento.gpgId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                                                                @click="PagamentoPut()">
                                                                Alterar Pagamento
                                                            </button>
                                                            <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="PagamentoAdd()">
                                                                Salvar Pagamento
                                                            </button>
                                                            <a href="#" @click="PagamentoCancel()" class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                       </v-window-item>
                                       <!--Pagamentos-->
                                        <!--Contratos-->
                                        <v-window-item value="contrato">
                                        <div class="gp-admin-form-header gp-guarantor-section-header">
                                            <span><v-icon size="20">mdi-file-document-edit-outline</v-icon></span>
                                            <div>
                                                <h4>Contrato</h4>
                                                <p>Gerencie os modelos, documentos e assinaturas contratuais da garantidora.</p>
                                            </div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row" v-if="User.garid == 0">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Contrato.gctId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <input v-model="Contrato.garId" type="text"
                                                                class="form-control" placeholder="Id Garantidora" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Modelos de Contrato</label>
                                                            <select  v-model="Contrato.cmcId" class="form-select form-control">
                                                                <option value="">Selecione</option>
                                                                <option v-for="optionTipo in ListaContratos" :key="optionTipo.cmcId"
                                                                    :value="optionTipo.cmcId">{{ optionTipo.cmcNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label></label>
                                                            <div>
                                                                <button type="button" class="btn btn-sm btn-success"
                                                                 style="color:#ffffff;margin-top:12px;" @click="ContratoAdd()">Adicionar</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <v-form>
                                                        <v-container>
                                                            <v-row>
                                                                <v-table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Contrato
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Status
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Data Assinatura
                                                                            </th>
                                                                            <th class="text-center">
                                                                                Actions
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="item in ListaMeusContratos"
                                                                            :key="item.gctId">
                                                                            <td>{{ ListaContratos.filter(x=> x.cmcId == item.cmcId)[0].cmcNome }}</td>
                                                                            <td>{{ item.gctStatusEnvelope == null ? 'Não enviado p/assinatura' :  item.gctDataAss == null ? 'Em Processamento!' : 'Assinado' }}</td>
                                                                            <td>{{ item.gctDataAss }}</td>
                                                                            <td style="text-align:center;">
                                                                                <v-btn icon @click.prevent="VisualizarContrato(item)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-eye</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Visualizar</v-tooltip>
                                                                                </v-btn>
                                                                                <v-btn v-if="item.gctStatusEnvelope == null" class="btn btn-sm btn-info" @click.prevent="EnviarAssinatura(item)" variant="text">
                                                                                     Enviar p/ Assinatura
                                                                                </v-btn>
                                                                                <v-btn  icon @click.prevent="ExcluirContrato(item)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-delete-forever</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Excluir</v-tooltip>
                                                                                </v-btn>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </v-table>
                                                            </v-row>
                                                        </v-container>
                                                    </v-form>
                                                </div>
                                            </v-container>
                                        </v-form>
                                       </v-window-item>
                                         <!--Contratos-->
                                        <!--faturamento-->
                                        <v-window-item value="fatura">
                                        <div class="gp-admin-form-header gp-guarantor-section-header">
                                            <span><v-icon size="20">mdi-cash-multiple</v-icon></span>
                                            <div>
                                                <h4>Faturamento</h4>
                                                <p>Acompanhe os valores, parcelas, vencimentos e pagamentos da garantidora.</p>
                                            </div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row" v-if="User.garid == 0 && ModoFinanceiroCarregado && !ModoFinanceiro.enviarAoFinanceiro && ModoFinanceiro.gravarCobrancasLocais">
                                                  <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Valor Setup</label>
                                                            <input v-model="GarantidoraPlanos.gplValorAdesao" disabled type="text" class="form-control" placeholder="Setup" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Qtde Parcelamento</label>
                                                            <input v-model="ParcelamentoSetup" type="number" class="form-control" placeholder="qtde" />
                                                        </div>
                                                    </div>
                                                     <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Mês Primeiro Vencimento</label>
                                                            <input v-model="MesSetup" type="number" class="form-control" placeholder="Número mês" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label></label>
                                                            <div v-if="ListaFaturas.filter(x=> x.pbgCodigoServicoGarantepay == 1 && x.pbgDataPagamento == null).length == 0">
                                                                <button type="button" class="btn btn-sm btn-success"
                                                                 style="color:#ffffff;margin-top:12px;" :disabled="FaturasLocaisEnviando" @click="FaturasLocaisAdd()">Gerar Faturas</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Valor Mensalidade</label>
                                                            <input v-model="GarantidoraPlanos.gplValor" disabled type="text" class="form-control" placeholder="Mensalidade" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Qtde Parcelamento</label>
                                                            <input v-model="ParcelamentoMensalidade" type="number" class="form-control" placeholder="Qtde" />
                                                        </div>
                                                    </div>
                                                     <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Mês Primeiro Vencimento</label>
                                                            <input v-model="MesMensalidade" type="number" class="form-control" placeholder="Número mês" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label></label>
                                                            <div v-if="ListaFaturas.filter(x=> x.pbgCodigoServicoGarantepay == 4 && x.pbgDataPagamento == null).length == 0">
                                                                <button type="button" class="btn btn-sm btn-success"
                                                                 style="color:#ffffff;margin-top:12px;" :disabled="FaturasLocaisEnviando" @click="FaturasMensaisLocaisAdd()">Gerar Faturas</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

<div v-if="User.garid == 0 && ModoFinanceiroCarregado && ModoFinanceiro.enviarAoFinanceiro" class="gp-billing-cards">
                                                    <section class="gp-billing-card" aria-labelledby="setup-title">
                                                        <header class="gp-billing-card-header"><span class="gp-billing-icon"><v-icon size="22">mdi-rocket-launch-outline</v-icon></span><div><h3 id="setup-title">Setup</h3><p>Adesão ao plano, à vista ou parcelada.</p></div></header>
                                                        <div class="gp-billing-card-body">
                                                            <div class="gp-billing-fields">
                                                                <label>Valor do Setup (R$)<input :value="formatarValor(GarantidoraPlanos.gplValorAdesao)" disabled class="form-control" /></label>
                                                                <label>Quantidade de parcelas<input v-model.number="ParcelamentoSetup" :disabled="SetupBloqueado || SetupFinanceiro?.hasLegacyInstallments" min="1" max="1200" step="1" type="number" class="form-control" /></label>
                                                                <label>Primeiro vencimento<input v-model="DataPrimeiroVencimentoSetup" :disabled="SetupBloqueado || SetupFinanceiro?.hasLegacyInstallments" type="date" class="form-control" /></label>
                                                            </div>
                                                    <div class="gp-billing-policy">
                                                        <fieldset :disabled="SetupBloqueado">
                                                            <legend class="gp-billing-policy-title">Cobrança do Setup</legend>
                                                            <div class="gp-billing-fields">
                                                                <label>Tipo de cobrança<input value="Link de pagamento Autra" readonly class="form-control" /></label>
                                                                <div><label>Métodos permitidos no link</label>
                                                                    <div class="d-flex flex-wrap gap-3 mt-2">
                                                                        <label><input v-model="SetupCollectionPolicy.allowedPaymentMethodCodes" type="checkbox" value="CC" /> Cartão de crédito</label>
                                                                        <label><input v-model="SetupCollectionPolicy.allowedPaymentMethodCodes" type="checkbox" value="PIX" /> Pix</label>
                                                                        <label><input v-model="SetupCollectionPolicy.allowedPaymentMethodCodes" type="checkbox" value="BB" /> Boleto/Pix (Autra)</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <p>Informe os encargos contratados. A emissão dos links é automática conforme a configuração do sistema.</p>
                                                            <div class="gp-billing-policy-grid">
                                                                <div class="gp-billing-policy-field"><label>Multa (%)<input v-model.number="SetupCollectionPolicy.penaltyPercentage" type="number" min="0" max="100" step="0.000001" class="form-control" /></label></div>
                                                                <div class="gp-billing-policy-field"><label>Juros por dia (%)<input v-model.number="SetupCollectionPolicy.dailyInterestPercentage" type="number" min="0" max="100" step="0.000001" class="form-control" /></label></div>
                                                            </div>
                                                            <p class="mt-2">O envio de e-mail depende dos contatos de cobrança e do canal configurados no Financeiro. WhatsApp ainda indisponível.</p>
                                                        </fieldset>
                                                    </div>

                                                            <v-alert v-if="SetupMensagem" :type="SetupTipoMensagem" variant="tonal" density="compact" class="gp-billing-alert" role="status">{{ SetupMensagem }}</v-alert>
                                                        </div>
                                                        <footer class="gp-billing-card-actions">
                                                            <button type="button" class="btn btn-outline-danger" disabled title="Cancelamento de Setup indisponível nesta integração.">Cancelar Setup</button>
                                                            <button v-if="SetupErroConsulta || SetupFinanceiro?.status" type="button" class="btn btn-outline-secondary" :disabled="SetupCarregando || SetupEnviando || SetupCancelando" @click="CarregaSetupFinanceiro(Garantidora.garId)">Atualizar situação</button>
                                                            <button type="button" class="btn btn-success" :disabled="SetupBloqueado || !GarantidoraPlanos.gplId" @click="FaturasAdd()">{{ SetupEnviando ? 'Registrando...' : SetupFinanceiro?.hasLegacyInstallments ? 'Sincronizar Financeiro' : 'Gerar Setup' }}</button>
                                                        </footer>
                                                    </section>
                                                    <section class="gp-billing-card" aria-labelledby="monthly-title">
                                                        <header class="gp-billing-card-header"><span class="gp-billing-icon"><v-icon size="22">mdi-calendar-month-outline</v-icon></span><div><h3 id="monthly-title">Mensalidade</h3><p>Cadastre uma recorrência para gerar uma obrigação com uma parcela a cada mês.</p></div></header>
                                                        <div class="gp-billing-card-body">
                                                            <fieldset :disabled="MensalidadeBloqueada">
                                                                <div class="gp-billing-fields">
                                                                    <label>Início do serviço<input v-model="MensalidadeInicioCiclo" type="date" class="form-control" /></label>
                                                                    <label>Valor mensal (R$)<input v-model.number="MensalidadeValorPadrao" type="number" min="0.01" max="999999999" step="0.01" class="form-control" /></label>
                                                                    <label>Dia do vencimento<input v-model.number="MensalidadeDiaVencimento" type="number" min="1" max="31" step="1" class="form-control" /></label>
                                                                </div>
                                                                <p class="gp-billing-help">A recorrência não tem data final. O início da geração é definido no cadastro, respeitando o início do serviço. Dias inexistentes usam o último dia do mês. Sem reajuste automático do valor.</p>
                                                                <div class="gp-billing-policy">
                                                                    <h4 class="gp-billing-policy-title">Cobrança da mensalidade</h4>
                                                            <div class="gp-billing-fields">
                                                                <label>Tipo de cobrança<input value="Link de pagamento Autra" readonly class="form-control" /></label>
                                                                <div><label>Métodos permitidos no link</label>
                                                                    <div class="d-flex flex-wrap gap-3 mt-2">
                                                                        <label><input v-model="MensalidadeCollectionPolicy.allowedPaymentMethodCodes" type="checkbox" value="CC" /> Cartão de crédito</label>
                                                                        <label><input v-model="MensalidadeCollectionPolicy.allowedPaymentMethodCodes" type="checkbox" value="PIX" /> Pix</label>
                                                                        <label><input v-model="MensalidadeCollectionPolicy.allowedPaymentMethodCodes" type="checkbox" value="BB" /> Boleto/Pix (Autra)</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                                    <p>A emissão dos links é automática. Antecedência, horários e carência seguem a configuração do sistema.</p>
                                                                    <div class="gp-billing-policy-grid">
                                                                        <label>Multa (%)<input v-model.number="MensalidadeCollectionPolicy.penaltyPercentage" type="number" min="0" max="100" step="0.000001" class="form-control" /></label>
                                                                        <label>Juros por dia (%)<input v-model.number="MensalidadeCollectionPolicy.dailyInterestPercentage" type="number" min="0" max="100" step="0.000001" class="form-control" /></label>
                                                                        <label><input v-model="MensalidadeCollectionPolicy.igpmEnabled" type="checkbox" /> Correção por atraso pelo IGP-M</label>
                                                                        <label><input v-model="MensalidadeCollectionPolicy.notifyEmail" type="checkbox" /> Notificar por e-mail</label>
                                                                    </div>
                                                                    <p class="mt-2">O envio de e-mail depende dos contatos e do canal configurados no Financeiro.</p>
                                                                </div>
                                                            </fieldset>
                                                            <v-alert :type="MensalidadeTipoMensagem" variant="tonal" density="compact" class="gp-billing-alert" role="status">{{ MensalidadeMensagem }}</v-alert>
                                                        </div>
                                                        <footer class="gp-billing-card-actions">
                                                            <button type="button" class="btn btn-outline-secondary" :disabled="MensalidadeCarregando || MensalidadeEnviando || !GarantidoraPlanos.gplId" @click="CarregaMensalidadeFinanceiro()">Atualizar situação</button>
                                                            <button type="button" class="btn btn-success" :disabled="MensalidadeBloqueada || !GarantidoraPlanos.gplId" @click="FaturasMensaisAdd()">{{ MensalidadeEnviando ? 'Registrando...' : 'Enviar recorrência ao Financeiro' }}</button>
                                                        </footer>
                                                    </section>
                                                </div>
                                                <div class="row" v-if="ExibirGridFaturas && ListaFaturas.length">
                                                    <v-form>
                                                        <v-container>
                                                            <v-row>
                                                                <v-table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Id Fatura
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Cod. Serviço
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Serviço
                                                                            </th>
                                                                              <th class="text-left">
                                                                                Parcela
                                                                            </th>
                                                                              <th class="text-left">
                                                                                Valor
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Vencimento
                                                                            </th>
                                                                              <th class="text-left">
                                                                                Pagamento
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="item in ListaFaturas"
                                                                            :key="item.pbgId">
                                                                            <td>{{ item.pbgId }}</td>
                                                                            <td>{{ item.pbgCodigoServicoGarantepay }}</td>
                                                                            <td>{{ item.pbgDescricaoServico }}</td>
                                                                            <td>{{ item.pbgParcela }}</td>
                                                                            <td>{{ formatarValor(item.pbgValorGarantepay) }}</td>
                                                                            <td>{{ formattedDate(item.pbgDataVencimento) }}</td>
                                                                             <td>{{ item.pbgDataPagamento != null ? formattedDate(item.pbgDataPagamento) : null }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </v-table>
                                                            </v-row>
                                                        </v-container>
                                                    </v-form>
                                                </div>
                                            </v-container>
                                        </v-form>
                                       </v-window-item>
                                         <!--faturamento-->
                                          <!--nota-->
                                        <v-window-item value="nota">
                                            <section class="gp-guarantor-subsection" v-if="User.garid == 0 && Garantidora.garId != 0 && Garantidora.garEmiteNota && User.tipo != 3">
                                            <div class="gp-admin-form-header">
                                                <span><v-icon size="20">mdi-receipt</v-icon></span>
                                                <div><h4>Dados da nota</h4><p>Configure a emissão, tributação e integração fiscal da garantidora.</p></div>
                                            </div>
                                            <v-form>
                                                <v-container>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                            <div class="form-group">
                                                                <label>Idenficador</label>
                                                                <input v-model="Nota.ggnId" type="text"
                                                                    class="form-control" placeholder="Id" />
                                                            </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Enviar E-mail Tomador</label>
                                                                <select  v-model="Nota.ggnEnviarEmail" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Incentivador Cultural</label>
                                                                <select  v-model="Nota.ggnIncentivadorCultural" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Incentivo Fiscal</label>
                                                                <select  v-model="Nota.ggnIncentivoFiscal" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Simples Nacional</label>
                                                                <select  v-model="Nota.ggnSimplesNacional" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Geração Nota</label>
                                                                <select v-model="Nota.ggnGeracaoNota" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option :value="0">Manual</option>
                                                                    <option :value="1">Automática</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Inscrição Estadual</label>
                                                                <input v-model="Nota.ggnInscricaoEstadual" type="text"
                                                                    class="form-control" placeholder="Inscrição Estadual" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Inscrição Municipal</label>
                                                                <input v-model="Nota.ggnInscricaoMunicipal" type="text"
                                                                    class="form-control" placeholder="Inscrição Municipal" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Regime Tributário</label>
                                                                <select  v-model="Nota.ggnRegimeTributario" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListRegimeTributario" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>Regime Tributário Especial</label>
                                                                <select  v-model="Nota.ggnRegimeTributarioEspecial" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListRegimeTributarioEspecial" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-9 col-lg-9">
                                                            <div class="form-group">
                                                                <label>Token PlugNotas</label>
                                                                <input v-model="Nota.ggnToken" type="text"
                                                                    class="form-control" placeholder="Token PlugNotas" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-10 col-lg-10">
                                                            <div class="form-group">
                                                                <button v-if="Nota.ggnId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                                                                    @click="NotaPut()">
                                                                    Alterar Dados Nota
                                                                </button>
                                                                <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="NotaAdd()">
                                                                    Salvar Dados Nota
                                                                </button>
                                                                <a href="#" @click="NotaCancel()" class="btn btn-link">Cancelar</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-container>
                                            </v-form>
                                            </section>
                                        <!--nota-->
                                         <!--Serviços da nota-->
                                            <section class="gp-guarantor-subsection" v-if="User.garid == 0 && Garantidora.garId != 0 && Garantidora.garEmiteNota && User.tipo != 3">
                                            <div class="gp-admin-form-header">
                                                <span><v-icon size="20">mdi-file-document-multiple-outline</v-icon></span>
                                                <div><h4>Serviços da nota</h4><p>Cadastre os serviços fiscais e suas respectivas alíquotas e retenções.</p></div>
                                            </div>
                                            <v-form>
                                                <v-container>
                                                    <div class="row" v-if="ListProdutos!=''">
                                                        <div class="col-md-8 col-lg-8">
                                                            <div class="form-group">
                                                                <label>Cód. Serviço</label>
                                                            <select  v-model="NotaServico.proId" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListProdutos" :key="optionTipo.proId"
                                                                    :value="optionTipo.proId">{{ optionTipo.proNomeProduto }}</option>
                                                            </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Serviço Fiscal</label>
                                                            <input v-model="NotaServico.ggsCodServicoFiscal" type="text" class="form-control"
                                                                placeholder="99.99" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Tributação</label>
                                                            <input v-model="NotaServico.ggsCodTributacao" type="text" class="form-control"
                                                                placeholder="99.99" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 col-lg-4">
                                                            <div class="form-group">
                                                                <label>ISS Tipo Tributação</label>
                                                                <select  v-model="NotaServico.ggsIssTipoTributacao" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListTipoTributacao" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 col-lg-4">
                                                            <div class="form-group">
                                                                <label>ISS Exigibilidade</label>
                                                                <select  v-model="NotaServico.ggsIssExigibilidade" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListExigibilidade" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 col-lg-4">
                                                             <div class="form-group">
                                                                <label>Iss Retido</label>
                                                                <select  v-model="NotaServico.ggsIssRetido" class="form-select form-control">
                                                                    <option :value=null>Selecione</option>
                                                                    <option v-for="optionTipo in ListSimNao" :key="optionTipo.Id"
                                                                        :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                            <label>Cnae</label>
                                                            <input v-model="NotaServico.ggsCnae" type="text" class="form-control"
                                                                placeholder="Cnae" />
                                                            </div>
                                                        </div>
                                                          <div class="col-md-3 col-lg-3">
                                                            <div class="form-group">
                                                                <label>ISS Aliquota</label>
                                                                <input v-model="NotaServico.ggsAliquota" v-decimal class="form-control"
                                                                    placeholder="Aliquota" />
                                                                </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>PIS Aliquota</label>
                                                            <input v-model="NotaServico.ggsPisAliquota" v-decimal class="form-control"
                                                                placeholder="" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>COFINS Aliquota</label>
                                                            <input v-model="NotaServico.ggsCofinsAliquota" v-decimal class="form-control"
                                                                placeholder="" />
                                                            </div>
                                                        </div>
                                                          <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>CSLL Aliquota</label>
                                                            <input v-model="NotaServico.ggsCsllAliquota" v-decimal class="form-control"
                                                                placeholder="CSLL Aliquota" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>INSS Aliquota</label>
                                                            <input v-model="NotaServico.ggsInssAliquota" v-decimal class="form-control"
                                                                placeholder="INSS Aliquota" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>IRRF Aliquota</label>
                                                            <input v-model="NotaServico.ggsIrrfAliquota" v-decimal class="form-control"
                                                                placeholder="IRRF Aliquota" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Outras Retenções</label>
                                                            <input v-model="NotaServico.ggsOutrasRetencoes" v-decimal class="form-control"
                                                                placeholder="Outras Retenções" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>CPP Aliquota</label>
                                                            <input v-model="NotaServico.ggsCppAliquota" v-decimal class="form-control"
                                                                placeholder="Outras Retenções" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Tributação Federal %</label>
                                                            <input v-model="NotaServico.ggsTributacaoTotalFederal" v-decimal class="form-control"
                                                                placeholder="Tributação Federal %" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Tributação Estadual %</label>
                                                            <input v-model="NotaServico.ggsTributacaoTotalEstadual" v-decimal class="form-control"
                                                                placeholder="Tributação Estadual %" />
                                                            </div>
                                                        </div>
                                                         <div class="col-md-2 col-lg-2">
                                                            <div class="form-group">
                                                            <label>Tributação Municipal %</label>
                                                            <input v-model="NotaServico.ggsTributacaoTotalMunicipal" v-decimal class="form-control"
                                                                placeholder="Tributação Municipal %" />
                                                            </div>
                                                        </div>

                                                        <div class="col-md-3 col-lg-3">
                                                            <button v-if="NotaServico.ggsId == 0"
                                                                type="button" class="btn btn-info"
                                                                @click.prevent="AddNotaServicos()"
                                                                style="color:#ffffff;margin-top: 40px;">
                                                                Inserir
                                                            </button>
                                                            <button v-else
                                                                type="button" class="btn btn-info"
                                                                @click.prevent="PutNotaServicos()"
                                                                style="color:#ffffff;margin-top: 40px;">
                                                                Alterar
                                                            </button>
                                                            <a href="#" @click="EditNotaServicosCancel()" style="margin-top: 40px;" class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                    <div class="row" style="padding-top: 20px;">
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Serviço
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Cód. Fiscal
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Tributação
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Cnae
                                                                    </th>
                                                                    <th class="text-left">
                                                                        ISS Tipo Tributação
                                                                    </th>
                                                                    <th class="text-left">
                                                                        ISS Exigibilidade
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Iss Retido
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Aliquota
                                                                    </th>
                                                                    <th>
                                                                        Ações
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody v-if="ListTipoTributacao!='' && ListProdutos!=''">
                                                                <tr v-for="item in ListGarantidoraNotaServico" :key="item.ggsId">
                                                                    <td>{{ nomeProdutoNota(item.proId) }}</td>
                                                                    <td>{{ item.ggsCodServicoFiscal }}</td>
                                                                    <td>{{ item.ggsCodTributacao }}</td>
                                                                    <td>{{ item.ggsCnae }}</td>
                                                                    <td>{{ ListTipoTributacao.filter(x=> x.Id == item.ggsIssTipoTributacao)[0].Nome }}</td>
                                                                    <td>{{ ListExigibilidade.filter(x=> x.Id == item.ggsIssExigibilidade)[0].Nome }}</td>
                                                                    <td>{{ item.ggsIssRetido ? 'Sim' : 'Não' }}</td>
                                                                    <td>{{ item.ggsAliquota }}</td>
                                                                    <td>
                                                                        <div class="gp-table-actions">
                                                                            <button type="button" class="gp-table-action gp-action-edit" title="Editar"
                                                                                @click.prevent="EditarServico(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
                                                                            <button v-if="User.tpeid != 3" type="button" class="gp-table-action gp-action-delete" title="Excluir"
                                                                                @click.prevent="DeleteServico(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </div>
                                                </v-container>
                                            </v-form>
                                            </section>
                                      </v-window-item>
                                    <!--Serviços da nota-->
                                    <!--Configuraçao Sinistro-->
                                    <v-window-item value="sinistro">
                                        <section class="gp-guarantor-subsection" v-if="Garantidora.garId != 0">
                                        <div class="gp-admin-form-header">
                                            <span><v-icon size="20">mdi-shield-alert-outline</v-icon></span>
                                            <div><h4>Configuração de sinistros</h4><p>Defina contatos, multas, juros e prazos utilizados no processo de sinistro.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="SinistroConfig.garId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>E-mail Aprovação</label>
                                                            <input v-model="SinistroConfig.gscEmailAprovacao" type="text"
                                                                class="form-control" placeholder="E-mail Aprovação" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>E-mail Pagamento</label>
                                                            <input v-model="SinistroConfig.gscEmailPagamento" type="text"
                                                                class="form-control" placeholder="E-mail Pagamento" />
                                                        </div>
                                                    </div>
                                                     <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>E-mail Cobrança</label>
                                                            <input v-model="SinistroConfig.gscEmailCobranca" type="text"
                                                                class="form-control" placeholder="E-mail Cobrança" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>E-mail Financeiro</label>
                                                            <input v-model="SinistroConfig.gscEmailFinanceiro" type="text"
                                                                class="form-control" placeholder="E-mail Financeiro" />
                                                        </div>
                                                    </div>
                                                     <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>E-mail Jurídico</label>
                                                            <input v-model="SinistroConfig.gscEmailJuridico" type="text"
                                                                class="form-control" placeholder="E-mail Jurídico" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Multa %</label>
                                                            <input v-model="SinistroConfig.gscMulta" v-decimal
                                                                class="form-control" placeholder="Multa %" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Juro diario %</label>
                                                            <input v-model="SinistroConfig.gscJuroDiario" v-decimal
                                                                class="form-control" placeholder="Juro diario %" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Dias Exoneração</label>
                                                            <input v-model="SinistroConfig.gscPrazoCancelamentoAcordoDia" type="number"
                                                                class="form-control" placeholder="Dias Notificar Exoneração" />
                                                        </div>
                                                    </div>
                                                     <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Dias Para disparo cobrança via email inquilino</label>
                                                            <v-select
                                                                    v-model="SinistroConfig.gscEmailDiasCobranca"
                                                                    :items="states"
                                                                    item-title="label"
                                                                    item-value="value"
                                                                    label="Selecione"
                                                                    multiple
                                                                    variant="outlined"
                                                                    ></v-select>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-10 col-lg-10" v-if="showend">
                                                        <div class="form-group">
                                                            <button v-if="SinistroConfig.garId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                                                                @click="SinistroPut()">
                                                                Alterar
                                                            </button>
                                                            <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="SinistroAdd()">
                                                                Salvar
                                                            </button>
                                                            <a href="#" @click="EnderecoCancel()" class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        </section>
                                    <!--Configuraçao Sinistro-->
                                    <section class="gp-guarantor-subsection" v-if="Garantidora.garId != 0">
                                        <div class="gp-admin-form-header">
                                            <span><v-icon size="20">mdi-file-check-outline</v-icon></span>
                                            <div><h4>Documentos de sinistros</h4><p>Configure os documentos exigidos para cada tipo de sinistro.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Tipo Sinistro</label>
                                                            <select v-model="DocumentoSinistro.tsnId" class="form-select form-control">
                                                                <option :value=null>Todos</option>
                                                                <option v-for="optionTipo in ListaTiposSinistro" :key="optionTipo.tsnId"
                                                                    :value="optionTipo.tsnId">{{ optionTipo.tsnNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-lg-5">
                                                        <div class="form-group">
                                                            <label>Documento</label>
                                                            <select v-model="DocumentoSinistro.docId" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionDocumento in ListaDocumentosSinistroDisponiveis" :key="optionDocumento.docId"
                                                                    :value="optionDocumento.docId">{{ optionDocumento.docNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group gp-extra-service-action">
                                                            <button type="button" class="btn btn-info" style="color:#ffffff;" @click="SinistroDocumentoIncluir()">
                                                                Incluir
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th>Tipo Sinistro</th>
                                                                    <th>Documento</th>
                                                                    <th style="width: 100px;">Acoes</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, index) in ListaSinistroDocumentos" :key="`${item.tsnId}-${item.docId}`">
                                                                    <td>{{ item.tsnId == null || !item.tsnNome ? 'Todos' : item.tsnNome }}</td>
                                                                    <td>{{ item.docNome }}</td>
                                                                    <td>
                                                                        <button type="button" class="gp-table-action gp-action-delete" title="Excluir"
                                                                            @click="SinistroDocumentoRemover(index)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <button type="button" class="btn btn-success" style="color:#ffffff;" @click="SinistroDocumentosSalvar()">
                                                                Salvar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </section>
                                    <section class="gp-guarantor-subsection" v-if="Garantidora.garId != 0">
                                        <div class="gp-admin-form-header">
                                            <span><v-icon size="20">mdi-file-percent-outline</v-icon></span>
                                            <div><h4>Documentos de débitos de sinistros</h4><p>Defina os documentos de débito e a incidência de juros.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Documento</label>
                                                            <select v-model="DocumentoDebitoSinistro.docId" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionDocumento in ListaDocumentosDebitoSinistroDisponiveis" :key="optionDocumento.docId"
                                                                    :value="optionDocumento.docId">{{ optionDocumento.docNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Possui Juros</label>
                                                            <select v-model="DocumentoDebitoSinistro.possuiJuros" class="form-select form-control">
                                                                <option :value=false>Nao</option>
                                                                <option :value=true>Sim</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group gp-extra-service-action">
                                                            <button type="button" class="btn btn-info" style="color:#ffffff;" @click="SinistroDebitoDocumentoIncluir()">
                                                                Incluir
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th>Documento</th>
                                                                    <th>Possui Juros</th>
                                                                    <th style="width: 100px;">Acoes</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, index) in ListaSinistroDebitoDocumentos" :key="item.docId">
                                                                    <td>{{ item.docNome }}</td>
                                                                    <td>{{ item.possuiJuros ? 'Sim' : 'Nao' }}</td>
                                                                    <td>
                                                                        <button type="button" class="gp-table-action gp-action-delete" title="Excluir"
                                                                            @click="SinistroDebitoDocumentoRemover(index)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <button type="button" class="btn btn-success" style="color:#ffffff;" @click="SinistroDebitoDocumentosSalvar()">
                                                                Salvar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </section>
                                    </v-window-item>
                                       <v-window-item value="cancelamento">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-6 col-lg-6" v-if="User!=''">
                                                        <div class="form-group">
                                                            <label>Motivo</label>
                                                            <select  v-model="Garantidora.garCodCancelamento" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in TiposCancelamento" :key="optionTipo.Cod"
                                                                    :value="optionTipo.Cod">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User!=''">
                                                        <div class="form-group">
                                                            <label>Data Limite Acesso</label>
                                                            <input v-model="Garantidora.garDataLimiteAcesso" type="date"
                                                                class="form-control" placeholder="Data Limite Acesso" />
                                                        </div>
                                                    </div>
                                                     <div class="col-md-3 col-lg-3" v-if="User!='' && Garantidora.garCodCancelamento == 2">
                                                        <div class="form-group">
                                                            <label>Zerar Faturas</label>
                                                            <select  v-model="Garantidora.garZeraFaturas" class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSimNaoInt" :key="optionTipo.Cod"
                                                                    :value="optionTipo.Cod">{{ optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="Garantidora.garZeraFaturas != '' && Garantidora.garCodCancelamento == 2">
                                                        <div class="form-group">
                                                            <label>A partir data: </label>
                                                            <input v-model="Garantidora.garMesZeraFaturas" type="date"
                                                                class="form-control" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-9 col-lg-9">
                                                        <div class="form-group">
                                                            <label>Observação</label>
                                                            <textarea v-model="Garantidora.garObsCancelamento" rows="6" class="form-control" placeholder="Observação" ></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-10 col-lg-10">
                                                         <div class="form-group">
                                                            <button :disabled="isSubmittingPut"
                                                                type="button" class="btn btn-success"
                                                                @click.prevent="Put()"
                                                                style="color:#ffffff;margin-top: 40px;">
                                                                Alterar Bloqueios
                                                            </button>
                                                            <a href="#" @click="EnderecoCancel()" class="btn btn-link" style="margin-top: 40px;">Cancelar</a>
                                                         </div>
                                                     </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--Bloqueios-->
                                </v-window>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions gp-guarantor-actions" v-if="tab=='dados'">
                        <div class="gp-guarantor-actions__left">
                            <button v-if="User != '' && User.garid == 0 && User.tipo != 3 && User.tusid != 3" type="button"
                                class="btn btn-outline-secondary" @click="CriarUsuarioEmail()"><v-icon size="16">mdi-account-plus-outline</v-icon> Criar e notificar usuário de acesso</button>
                        </div>
                        <div class="gp-guarantor-actions__right">
                            <a href="#" @click="EditCancel()" class="btn btn-outline-secondary">Cancelar</a>
                            <button v-if="Garantidora.garId != 0" type="button" class="btn btn-success"
                                @click="Put()" :disabled="isSubmittingPut"><i class="fas fa-save"></i> Alterar</button>
                            <button v-else type="button" class="btn btn-success" @click="Add()" :disabled="isSubmittingAdd">
                                <i class="fas fa-save"></i> Salvar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Cadastro de garantidoras</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item">Garantidoras</li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de garantidoras</h4>
                                    <a v-if="User.garid == 0" href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <adm-data-table :filter-columns="4" :headers="headers" :items="ListGarantidoras"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina"
                                    :row-class="classeLinhaGarantidora"
                                    :filter-options="{ situacaoAcesso: [{ title: 'Ativa', value: 'Ativa' }, { title: 'Inativa', value: 'Inativa' }] }"
                                    :show-export="User.garid == 0" file-name="garantidoras"
>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions">
                                            <button v-if="User.tusid != 3" type="button" class="gp-table-action gp-action-edit"
                                                title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
                                            <button v-if="User!='' && User.garid == 0 && User.tusid != 3" type="button"
                                                class="gp-table-action gp-action-delete" title="Excluir"
                                                @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
                                        </div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<v-dialog v-model="SetupModalCancelamento" max-width="560" :persistent="SetupCancelando">
        <v-card>
            <v-card-title>Cancelar Setup</v-card-title>
            <v-card-text>
                <p>Informe o motivo para solicitar o cancelamento ao Financeiro.
                    Parcelas pagas ou vencidas serão avaliadas pelo Financeiro.</p>
                <v-textarea v-model="SetupMotivoCancelamento" label="Motivo do cancelamento *"
                    :disabled="SetupCancelando" maxlength="500" counter="500" rows="4"
                    auto-grow required :error-messages="SetupCancelamentoErro" />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn :disabled="SetupCancelando" @click="SetupModalCancelamento = false">Voltar</v-btn>
                <v-btn color="error" :loading="SetupCancelando" :disabled="!SetupMotivoCancelamento.trim() || SetupCancelando"
                    @click="CancelarSetupFinanceiro()">Confirmar cancelamento</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { abrirArquivoAutenticado } from '../../utils/authenticatedFiles'
import axios from 'axios'
import { parseSetupAmount } from '../../utils/setupMinimum'
import { personalizarEmailGarantidora } from '../../utils/guarantorEmail'
import EasyDataTable from 'vue3-easy-data-table'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import moment from 'moment'
import { shallowRef } from 'vue'
import * as XLSX from 'xlsx'
import { normalizeGuarantorUrl } from '../../auth/guarantorContext'

function novaPoliticaSetup () {
  return { automaticChargeEnabled: false, leadDays: 5, generationTime: '08:00',
    penaltyPercentage: 0, dailyInterestPercentage: 0, graceDays: 0,
    igpmEnabled: false, notifyEmail: false, notifyWhatsapp: false }
}

export default {
  name: 'GarantidorasView',
  components: {
    EasyDataTable,
    moment
  },
  data: () => ({
    EditView: false,
    User: {
      garid: 0,
      tpeid: 0,
      tusid: 0
    },
    editor: DecoupledEditor,
    tab: null,
    searchValue: '',
    itemsSelected: [],
    NomeTela: 'Garantidoras',
    InfoTela: 'Lista de garantidoras',
    MostraGrid: true,
    headers: [],
    isSubmittingAdd: false,
    isSubmittingPut: false,
    // dados
    Garantidora: {
      garId: 0,
      garVisivel: null,
      garDataCadastro: null,
      garNomeEmpresa: '',
      garRazaoSocial: '',
      tpdId: null,
      garDocumento: '',
      garTelefone: '',
      garWhatsapp: '',
      garResponsavel: '',
      garEmail: '',
      garAtivo: null,
      garDataAniversario: null,
      garCampoExtra1: '',
      garCampoExtra2: '',
      garCampoExtra3: '',
      garCampoExtra4: '',
      garCampoExtra5: '0',
      garTexto1: '',
      garTexto2: '',
      garTexto3: '',
      garData1: null,
      garData2: null,
      garUrlLogo: '',
      garUrlParcial: '',
      garEmiteNota: false,
      garCodCancelamento: null,
      garMotivoCancelamento: '',
      garDataLimiteAcesso: '',
      garZeraFaturas: null,
      garMesZeraFaturas: '',
      garObsCancelamento: ''
    },
    ListGarantidoras: [],
    ListGarantidorasGeral: [],
    TiposDocumentos: [],
    // dados
    // imagens
    selectedFile: null,
    // endereco
    Endereco: {
      gaeId: 0,
      grtId: 0,
      cdtId: 0,
      gaeEndereco: '',
      gaeNumero: 0,
      gaeComplemento: '',
      gaeObsEndereco: '',
      gaeCep: '',
      gaePais: '',
      gaeEstado: '',
      gaeCidade: '',
      gaeBairro: '',
      gaeCodigoDistrito: '',
      garId: null
    },
    ListaEnderecos: [],
    showend: false,
    Retornocep: null,
    // endereco
    // planos
    GarantidoraPlanos: {
      gplId: 0,
      grtId: 0,
      cdtId: 0,
      cpgId: null,
      garId: null,
      gplValor: null,
      gplVencimento: '',
      gplVigenciaInicial: null,
      gplTipoCobranca: '',
      gplRemuneracaoNegocio: null,
      gplQtdeUsuarios: '',
      gplValorAdesao: null,
      gplValorMaxSetup: null,
      gplValorMinSetupResidencial: 0,
      gplValorMinSetupComercial: 0
    },
    ListaPlanos: [],
    // planos
    // servicos extras
    ServicoExtra: {
      gsvId: 0,
      garId: null,
      lseId: null,
      gsvQuantidade: 0,
      gsvValor: null,
      gsvPeriodicidade: '',
      gsvAtivo: true,
      gsvDataInicio: null,
      gsvProximaCobranca: null,
      lseCodigoServicoGarantePay: null
    },
    ListaServicosExtrasCadastro: [],
    ListaGarantidoraServicosExtras: [],
    isSubmittingServicoExtra: false,
    ServicoExtraConfig: { contractVersion: 5, collectionPolicy: { ...novaPoliticaSetup(), chargeTypeCode: 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: ['CC', 'PIX', 'BB'] } },
    // servicos extras
    // serasa
    Serasa: {
      gseValorGarantiaMinimo: null,
      gseValorGarantiaMaximo: null,
      gseId: 0,
      grtId: 0,
      cdtId: 0,
      gsePropriedade: 0,
      gseQtdeMensal: '',
      gseCustoPesExtra: null,
      gseQtdeGratisMensal: 0,
      gseRangeAprovacao: 0,
      garId: 0
    },
    ListaSerasa: [],
    // serasa
    // Processos
    Processos: {
      gprId: 0,
      grtId: 0,
      cdtId: 0,
      gprPropriedade: 0,
      gprQtdeMensal: '',
      gprCustoPesExtra: null,
      gprQtdeGratisMensal: 0,
      garId: 0
    },
    ListaProcesso: [],
    // processos
    // assinatura
    Assinatura: {
      gasId: 0,
      grtId: 0,
      cdtId: 0,
      gasPropriedade: '',
      gasQtdeMensal: '',
      gasCustoPesExtra: 0,
      gasQtdeGratisMensal: 0,
      gasIdRepositorio: '',
      gasToken: '',
      garId: '',
      gasOpcaoAutenticacao: null,
      gasExigirCodigo: '',
      gasCodigoExigido: '',
      gasAnalisarFaceImagem: '',
      gasPercentualPrecisaoFace: 0,
      gasEnviarWhatsapp: 'N'
    },
    ListaAssinaturas: [],
    ListAutenticacoes: [
      { Id: 2, Nome: 'Documento com Foto' },
      { Id: 3, Nome: 'Documento com foto e Selfie' },
      /* {Id: 4, Nome: 'Código SMS'}, */
      { Id: 5, Nome: 'Reconhecimento Facial' },
      /* {Id: 7, Nome: 'Código de verificação via WhatsApp'}, */
      { Id: 99, Nome: 'Código Fixo (deve ser enviado ao assinante)' }
    ],
    ListSimNaoText: [
      { Id: 'S', Nome: 'Sim' },
      { Id: 'N', Nome: 'Não' }
    ],
    // assinatura
    // Pagamentos
    Pagamento: {
      gpgId: 0,
      grtId: 0,
      cdtId: 0,
      garId: null,
      topId: null,
      gpgEmailAviso: '',
      gpgSplitToken: '',
      gpgSplitBanco: '',
      gpgSplitBancoNome: '',
      gpgSplitAgencia: '',
      gpgSplitConta: '',
      gpgSplitTitularConta: '',
      gpgSplitTitularDocumento: '',
      gpgSplitChavePix: '',
      gpgSplitTipoConta: ''
    },
    ListaPagamentos: [],
    TipoOperadoras: [],
    // Pagamentos
    // contrato
    Contrato: {
      gctId: 0,
      grtId: 0,
      cdtId: 0,
      garId: null,
      cmcId: '',
      gctUrlContrato: null,
      gctIp: null,
      gctDataAss: null, // Data inicializada como null
      gctRetornoJson: null,
      gctIdenvelope: null,
      gctStatusEnvelope: null
    },
    ListaContratos: [],
    ListaMeusContratos: [],
    ListUser: [],
    // contrato
    // Nota fiscal
    ListGarantidoraNota: [],
    ListGarantidoraNotaServico: [],
    ListaProdutos: [],
    Nota: {
      ggnId: 0,
      ggnEnviarEmail: null,
      ggnIncentivadorCultural: null,
      ggnIncentivoFiscal: null,
      ggnInscricaoEstadual: '',
      ggnIinscricaoMunicipal: '',
      ggnRegimeTributario: null,
      ggnRegimeTributarioEspecial: null,
      ggnSimplesNacional: null,
      ggnCodigoDistrito: 0,
      ggnGeracaoNota: null,
      ggnToken: '',
      garId: null
    },
    NotaServico: {
      ggsId: 0,
      proId: null,
      ggsCodServicoFiscal: '',
      ggsCodTributacao: '',
      ggsCnae: '',
      ggsIssTipoTributacao: null,
      ggsIssExigibilidade: null,
      ggsIssRetido: null,
      ggsAliquota: '',
      garId: '',
      ggsPisAliquota: null,
      ggsCofinsAliquota: null,
      ggsCsllAliquota: null,
      ggsInssAliquota: null,
      ggsIrrfAliquota: null,
      ggsOutrasRetencoes: null,
      ggsCppAliquota: null,
      ggsTributacaoTotalFederal: null,
      ggsTributacaoTotalEstadual: null,
      ggsTributacaoTotalMunicipal: null
    },
    ListSimNao: [{ Id: true, Nome: 'Sim' }, { Id: false, Nome: 'Não' }],
    ListSimNaoInt: [{ Cod: 1, Nome: 'Sim' }, { Cod: 0, Nome: 'Não' }],
    TiposCancelamento: [{ Cod: 1, Nome: 'Bloqueio por Inadimplência' }, { Cod: 2, Nome: 'Bloqueio por Cancelamento' }],
    ListRegimeTributario: [
      { Id: 0, Nome: 'Nenhum' },
      { Id: 1, Nome: 'Simples Nacional' },
      { Id: 2, Nome: 'Simples Nacional - Excesso' },
      { Id: 3, Nome: 'Regime Normal - Lucro Presumido' },
      { Id: 4, Nome: 'Normal - Lucro Real' },
      { Id: 5, Nome: 'MEI (Microempreendedor individual)' }
    ],
    ListRegimeTributarioEspecial: [
      { Id: 0, Nome: 'Sem Regime Tributário Especial' },
      { Id: 1, Nome: 'Micro Empresa Municipal' },
      { Id: 2, Nome: 'Estimativa' },
      { Id: 3, Nome: 'Sociedade de Profissionais' },
      { Id: 4, Nome: 'Cooperativa' },
      { Id: 5, Nome: 'Microempresário Individual - MEI' },
      { Id: 6, Nome: 'Microempresa ou Pequeno Porte - ME EPP' },
      { Id: 7, Nome: 'Lucro Real' },
      { Id: 8, Nome: 'Lucro Presumido' },
      { Id: 9, Nome: 'Tributação Normal' },
      { Id: 10, Nome: 'Simples nacional com excesso do sublimite' },
      { Id: 11, Nome: 'Empresa de Responsabilidade Limitada' }
    ],
    ListTipoTributacao: [
      { Id: 0, Nome: 'Não definido' },
      { Id: 1, Nome: 'Isento de ISS' },
      { Id: 2, Nome: 'Imune' },
      { Id: 3, Nome: 'Não Incidência no Município' },
      { Id: 4, Nome: 'Não Tributável' },
      { Id: 5, Nome: 'Retido' },
      { Id: 6, Nome: 'Tributável Dentro do Município' },
      { Id: 7, Nome: 'Tributável Fora do Município' },
      { Id: 8, Nome: 'Tributável Dentro do Município pelo tomador' }
    ],
    ListExigibilidade: [
      { Id: 1, Nome: 'Exigível' },
      { Id: 2, Nome: 'Não Incidência' },
      { Id: 3, Nome: 'Isenção' },
      { Id: 4, Nome: 'Exportação' },
      { Id: 5, Nome: 'Imunidade' },
      { Id: 6, Nome: 'Supenso por Ação Judicial' },
      { Id: 7, Nome: 'Suspenso por Ação Administrativa' }
    ],
    // Nota fiscal
    // Faturamento
    ValorSetup: 0,
    ParcelamentoSetup: 0,
    DataPrimeiroVencimentoSetup: '',
ModoFinanceiro: { enviarAoFinanceiro: false, gravarCobrancasLocais: true },
    ModoFinanceiroCarregado: false,
    FaturasLocaisEnviando: false,
    MesMensalidade: 0,
    ParcelamentoMensalidade: 0,
    MesSetup: 0,
    SetupFinanceiro: null,
SetupCollectionPolicy: { ...novaPoliticaSetup(), chargeTypeCode: 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: ['CC', 'PIX', 'BB'] },
SetupCarregando: false,
SetupEnviando: false,
SetupCancelando: false,
SetupModalCancelamento: false,
SetupMotivoCancelamento: '',
SetupCancelamentoErro: '',
SetupErroConsulta: false,
ExibirGridFaturas: false,
    ValorMensalidade: 0,
    MensalidadeRequestVersion: 0,
    MensalidadeMetodos: [],
    MensalidadeValorPadrao: null,
    MensalidadeDiaVencimento: 10,
    MensalidadeInicioCiclo: '',
    MensalidadeFinanceiro: null,
    MensalidadeCarregando: false,
    MensalidadeEnviando: false,
    MensalidadeErro: '',
    MensalidadeCollectionPolicy: { ...novaPoliticaSetup(), chargeTypeCode: 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: ['CC', 'PIX', 'BB'] },
    ListaFaturas: [],
    // Faturamento
    // Sinistro
    SinistroConfig: {
      garId: 0,
      gscMulta: 0,
      gscJuroDiario: 0,
      gscPrazoCancelamentoAcordoDia: 0,
	      gscEmailAprovacao: '',
	      gscEmailPagamento: '',
	      gscEmailCobranca: '',
	      gscEmailFinanceiro: '',
	      gscEmailJuridico: '',
      gscEmailDiasCobranca: []
    },
    states: [
      { label: 'Dia 1', value: 1 },
      { label: 'Dia 5', value: 5 },
      { label: 'Dia 10', value: 10 },
      { label: 'Dia 15', value: 15 },
      { label: 'Dia 20', value: 20 },
      { label: 'Dia 25', value: 25 },
      { label: 'Dia 30', value: 30 }
    ],
    ListaSinistro: [],
    ListaTiposSinistro: [],
    ListaDocumentosSinistroDisponiveis: [],
    ListaDocumentosDebitoSinistroDisponiveis: [],
    DocumentoSinistro: {
      tsnId: null,
      docId: null
    },
    DocumentoDebitoSinistro: {
      docId: null,
      possuiJuros: false
    },
    ListaSinistroDocumentos: [],
    ListaSinistroDebitoDocumentos: []
    // Sinistro
  }),
  methods: {
async CarregaSetupFinanceiro(garId) {
      if (!this.ModoFinanceiroCarregado || !this.ModoFinanceiro.enviarAoFinanceiro) return
            this.SetupCarregando = true;
            this.SetupFinanceiro = null;
            this.SetupErroConsulta = false;
            try {
                const response = await axios.get(`/Telas/Garantidoras/SetupFinanceiro/${garId}`);
                if (Number(this.Garantidora.garId) === Number(garId)) {
                    this.SetupFinanceiro = response.data;
                    this.ParcelamentoSetup = response.data.installmentCount || 0;
                    this.DataPrimeiroVencimentoSetup = response.data.firstDueDate
                        ? moment(response.data.firstDueDate).format('YYYY-MM-DD') : '';
                    if (response.data.collectionPolicy) this.SetupCollectionPolicy = { ...response.data.collectionPolicy, chargeTypeCode: response.data.collectionPolicy.chargeTypeCode ?? 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: response.data.collectionPolicy.allowedPaymentMethodCodes ?? ['CC', 'PIX', 'BB'] };
                }
            } catch (err) {
                if (Number(this.Garantidora.garId) === Number(garId)) this.SetupErroConsulta = true;
            } finally {
                if (Number(this.Garantidora.garId) === Number(garId)) this.SetupCarregando = false;
            }
        },
AbrirCancelamentoSetup () { this.$mensagemAviso('Cancelamento do Setup indisponível nesta integração.') },
CancelarSetupFinanceiro () { this.$mensagemAviso('Cancelamento do Setup indisponível nesta integração.') },

    onReady (editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
    },
    async UploadImg (value) {
      const formData = new FormData()
      formData.append('file', value)
      const uploadResult = await axios.post('/Telas/Garantidoras/upload', formData)
      return uploadResult
    },
    buildFileUrl (path) {
      if (!path) return ''
      const rel = String(path).replace(/\\/g, '/') // normaliza separadores
      const base = this.$imgURL
      return `${base}/Telas/Garantidoras/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`
    },
    getGuarantorAccessBaseUrl () {
      return `${window.location.origin}/`
    },
    NormalizaUrlParcial () {
      const value = String(this.Garantidora.garUrlParcial || '').trim()
      if (!value) {
        this.Garantidora.garUrlParcial = null
        return
      }

      const normalized = normalizeGuarantorUrl(value)
      if (normalized) {
        this.Garantidora.garUrlParcial = normalized
      }
    },
    ValidaUrlParcial () {
      const value = String(this.Garantidora.garUrlParcial || '').trim()
      if (!value) {
        this.Garantidora.garUrlParcial = null
        return true
      }

      const normalized = normalizeGuarantorUrl(value)
      if (!normalized) {
        this.$mensagemAviso('A chave da URL deve possuir até 100 caracteres e conter somente letras, números, hífen ou sublinhado.')
        return false
      }

      this.Garantidora.garUrlParcial = normalized
      return true
    },
    buildGuarantorAccessUrl () {
      const key = normalizeGuarantorUrl(this.Garantidora.garUrlParcial)
      return key ? `${window.location.origin}/${encodeURIComponent(key)}` : ''
    },
    async openInNewTab (path) {
      try {
        await abrirArquivoAutenticado('/Telas/Garantidoras/GetFileByParam', path)
      } catch (error) {
        this.$mensagemErro(error.message)
      }
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formatarValor (valor) {
      if (valor === null || valor === undefined || valor === '') return ''
      const numero = typeof valor === 'number' ? valor : Number(
        String(valor).includes(',') ? String(valor).replace(/\./g, '').replace(',', '.') : valor
      )
      return Number.isFinite(numero)
        ? numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : ''
    },
    isEmailValid (email) {
      if (!email) {
        return false
      }
      // Se houver espaços antes ou depois, rejeita
      if (email !== email.trim()) {
        return false
      }
      // Regex simples: texto + '@' + texto + '.' + texto
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    NormalizaDocumentoGarantidora () {
      if (!this.Garantidora.garDocumento || this.Garantidora.tpdId !== 2) return

      const documento = this.Garantidora.garDocumento.toUpperCase().replace(/[^A-Z0-9./-]/g, '')
      if (documento !== this.Garantidora.garDocumento) {
        this.Garantidora.garDocumento = documento
      }
    },
    NormalizaDocumento (value) {
      return String(value || '').toUpperCase().replace(/[.\-/\s]/g, '')
    },
    ValidaDocumentoGarantidora () {
      if (this.Garantidora.tpdId === 1) {
        return this.ValidaCpf(this.Garantidora.garDocumento)
      }

      if (this.Garantidora.tpdId === 2) {
        return this.ValidaCnpjAlfanumerico(this.Garantidora.garDocumento)
      }

      return false
    },
    ValidaCpf (value) {
      const cpf = this.NormalizaDocumento(value)
      if (!/^\d{11}$/.test(cpf) || /^(\d)\1{10}$/.test(cpf)) return false

      const calcularDigito = (base, pesoInicial) => {
        const soma = base.split('').reduce((total, digito, index) => {
          return total + parseInt(digito, 10) * (pesoInicial - index)
        }, 0)
        const resto = soma % 11
        return resto < 2 ? '0' : String(11 - resto)
      }

      const primeiroDigito = calcularDigito(cpf.substring(0, 9), 10)
      const segundoDigito = calcularDigito(cpf.substring(0, 9) + primeiroDigito, 11)

      return cpf.substring(9) === primeiroDigito + segundoDigito
    },
    ValidaCnpjAlfanumerico (value) {
      const cnpj = this.NormalizaDocumento(value)
      if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj) || /^([A-Z0-9])\1{13}$/.test(cnpj)) return false

      const primeiroDigito = this.CalculaDigitoCnpjAlfanumerico(cnpj.substring(0, 12))
      const segundoDigito = this.CalculaDigitoCnpjAlfanumerico(cnpj.substring(0, 12) + primeiroDigito)

      return cnpj.substring(12) === primeiroDigito + segundoDigito
    },
    CalculaDigitoCnpjAlfanumerico (base) {
      const pesos = base.length === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

      const soma = base.split('').reduce((total, char, index) => {
        return total + (char.charCodeAt(0) - 48) * pesos[index]
      }, 0)
      const resto = soma % 11

      return resto < 2 ? '0' : String(11 - resto)
    },
    CarregaLista () {
      this.ListGarantidoras = this.ListGarantidorasGeral
    },
    CarregaValoresPlano () {
      const _resultPlanos = this.ListaPlanos.filter(x => x.cpgId == this.GarantidoraPlanos.cpgId)[0]
      // console.log('_resultPlanos')
      // console.log(_resultPlanos)
      this.GarantidoraPlanos.gplValor = String(_resultPlanos.cpgValor).replace('.', ',')
      this.GarantidoraPlanos.gplTipoCobranca = _resultPlanos.cpgTipoCobranca
      this.GarantidoraPlanos.gplRemuneracaoNegocio = String(_resultPlanos.cpgRemuneracaoNegocio).replace('.', ',')
      this.GarantidoraPlanos.gplQtdeUsuarios = _resultPlanos.cpgQtdeUsuarios
      this.GarantidoraPlanos.gplValorAdesao = String(_resultPlanos.cpgValorAdesao).replace('.', ',')
      this.Assinatura.gasQtdeMensal = _resultPlanos.cpgAssQtdeMensal
      this.Assinatura.gasCustoPesExtra = String(_resultPlanos.cpgAssCustoExtra).replace('.', ',')
      this.Assinatura.gasQtdeGratisMensal = _resultPlanos.cpgAssQtdeGratisMensal
      this.Serasa.gseQtdeMensal = _resultPlanos.cpgSerasaQtdeMensal
      this.Serasa.gseCustoPesExtra = String(_resultPlanos.cpgSerasaCustoExtra).replace('.', ',')
      this.Serasa.gseQtdeGratisMensal = _resultPlanos.cpgSerasaQtdeGratisMensal
      this.Processos.gprQtdeMensal = _resultPlanos.cpgSerasaQtdeMensal // _resultPlanos.cpgProcessosQtdeMensal;
      this.Processos.gprCustoPesExtra = String(_resultPlanos.cpgProcessosCustoExtra).replace('.', ',')
      this.Processos.gprQtdeGratisMensal = _resultPlanos.cpgSerasaQtdeGratisMensal // resultPlanos.cpgProcessosQtdeGratisMensal;
    },
    // imagens
    NormalizaControleContratacoesVigencia () {
      this.Garantidora.garCampoExtra5 = this.Garantidora.garCampoExtra5 === true || this.Garantidora.garCampoExtra5 === '1' ? '1' : '0'
    },
    // garantidora
    // edit
    EditNew () {
      this.EditView = true
      this.Garantidora.garId = 0
      this.Garantidora.garVisivel = null
      this.Garantidora.garDataCadastro = null
      this.Garantidora.garNomeEmpresa = ''
      this.Garantidora.garRazaoSocial = ''
      this.Garantidora.tpdId = null
      this.Garantidora.garDocumento = ''
      this.Garantidora.garTelefone = ''
      this.Garantidora.garWhatsapp = ''
      this.Garantidora.garResponsavel = ''
      this.Garantidora.garEmail = ''
      this.Garantidora.garAtivo = null
      this.Garantidora.garDataAniversario = null
      this.Garantidora.garCampoExtra1 = ''
      this.Garantidora.garCampoExtra2 = ''
      this.Garantidora.garCampoExtra3 = ''
      this.Garantidora.garCampoExtra4 = ''
      this.Garantidora.garCampoExtra5 = '0'
      this.Garantidora.garTexto1 = ''
      this.Garantidora.garTexto2 = ''
      this.Garantidora.garTexto3 = ''
      this.Garantidora.garData1 = null
      this.Garantidora.garData2 = null
      this.Garantidora.garUrlLogo = ''
      this.Garantidora.garUrlParcial = ''
      this.Garantidora.garEmiteNota = false
      this.Garantidora.garCodCancelamento = null
      this.Garantidora.garMotivoCancelamento = ''
      this.Garantidora.garDataLimiteAcesso = ''
      this.Garantidora.garZeraFaturas = null
      this.Garantidora.garMesZeraFaturas = ''
      this.Garantidora.garObsCancelamento = ''
      // endereco
      this.Endereco.gaeId = 0
      this.Endereco.grtId = 0
      this.Endereco.cdtId = 0
      this.Endereco.gaeEndereco = ''
      this.Endereco.gaeNumero = 0
      this.Endereco.gaeComplemento = ''
      this.Endereco.gaeObsEndereco = ''
      this.Endereco.gaeCep = ''
      this.Endereco.gaePais = ''
      this.Endereco.gaeEstado = ''
      this.Endereco.gaeCidade = ''
      this.Endereco.gaeBairro = ''
      this.Endereco.gaeCodigoDistrito = ''
      this.showend = false
      this.Retornocep = null
      // planos
      this.GarantidoraPlanos.gplId = 0
      this.GarantidoraPlanos.grtId = 0
      this.GarantidoraPlanos.cdtId = 0
      this.GarantidoraPlanos.cpgId = null
      this.GarantidoraPlanos.gplValor = null
      this.GarantidoraPlanos.gplVencimento = ''
      this.GarantidoraPlanos.gplVigenciaInicial = null
      this.GarantidoraPlanos.gplTipoCobranca = ''
      this.GarantidoraPlanos.gplRemuneracaoNegocio = null
      this.GarantidoraPlanos.gplQtdeUsuarios = ''
      this.GarantidoraPlanos.gplValorAdesao = null
      this.GarantidoraPlanos.gplValorMaxSetup = null
      this.GarantidoraPlanos.gplValorMinSetupResidencial = 0
      this.GarantidoraPlanos.gplValorMinSetupComercial = 0
      this.ServicoExtraReset()
      this.ListaGarantidoraServicosExtras = []
      // serasa
      this.Serasa.gseValorGarantiaMinimo = null
      this.Serasa.gseValorGarantiaMaximo = null
      this.Serasa.gseId = 0
      this.Serasa.grtId = 0
      this.Serasa.cdtId = 0
      this.Serasa.gsePropriedade = 0
      this.Serasa.gseQtdeMensal = ''
      this.Serasa.gseCustoPesExtra = null
      this.Serasa.gseQtdeGratisMensal = 0
      this.Serasa.gseRangeAprovacao = 0
      // processos
      this.Processos.gseId = 0
      this.Processos.grtId = 0
      this.Processos.cdtId = 0
      this.Processos.gprPropriedade = 0
      this.Processos.gprQtdeMensal = ''
      this.Processos.gprCustoPesExtra = null
      this.Processos.gprQtdeGratisMensal = 0
      // processos
      this.Assinatura.gasId = 0
      this.Assinatura.grtId = 0
      this.Assinatura.cdtId = 0
      this.Assinatura.gasPropriedade = ''
      this.Assinatura.gasQtdeMensal = ''
      this.Assinatura.gasCustoPesExtra = 0
      this.Assinatura.gasQtdeGratisMensal = 0
      this.Assinatura.gasIdRepositorio = ''
      this.Assinatura.gasToken = ''
      this.Assinatura.gasOpcaoAutenticacao = null
      this.Assinatura.gasExigirCodigo = ''
      this.Assinatura.gasCodigoExigido = ''
      this.Assinatura.gasAnalisarFaceImagem = ''
      this.Assinatura.gasPercentualPrecisaoFace = 0
      this.Assinatura.gasEnviarWhatsapp = ''
      // pagamento
      this.Pagamento.gpgId = 0
      this.Pagamento.grtId = 0
      this.Pagamento.cdtId = 0
      this.Pagamento.topId = null
      this.Pagamento.gpgEmailAviso = ''
      this.Pagamento.gpgSplitToken = ''
      this.Pagamento.gpgSplitBanco = ''
      this.Pagamento.gpgSplitBancoNome = ''
      this.Pagamento.gpgSplitAgencia = ''
      this.Pagamento.gpgSplitConta = ''
      this.Pagamento.gpgSplitTitularConta = ''
      this.Pagamento.gpgSplitTitularDocumento = ''
      this.Pagamento.gpgSplitChavePix = ''
      this.Pagamento.gpgSplitTipoConta = ''
      // contrato
      this.Contrato.gctId = 0
      this.Contrato.grtId = 0
      this.Contrato.cdtId = 0
      this.Contrato.cmcId = ''
      this.Contrato.gctUrlContrato = null
      this.Contrato.gctIp = null
      this.Contrato.gctDataAss = null // Data inicializada como null
      this.Contrato.gctRetornoJson = null
      this.Contrato.gctIdenvelope = null
      this.Contrato.gctStatusEnvelope = null
      this.ListaMeusContratos = []
      // nota
      this.Nota.ggnId = 0
      this.Nota.ggnEnviarEmail = null
      this.Nota.ggnIncentivadorCultural = null
      this.Nota.ggnIncentivoFiscal = null
      this.Nota.ggnGeracaoNota = null
      this.Nota.ggnInscricaoEstadual = ''
      this.Nota.ggnIinscricaoMunicipal = ''
      this.Nota.ggnRegimeTributario = null
      this.Nota.ggnRegimeTributarioEspecial = null
      this.Nota.ggnSimplesNacional = null
      this.Nota.ggnCodigoDistrito = ''
      this.Nota.ggnToken = ''
      // nota servico
      this.NotaServico.ggsId = 0
      this.NotaServico.proId = null
      this.NotaServico.ggsCodServicoFiscal = ''
      this.NotaServico.ggsCodTributacao = ''
      this.NotaServico.ggsCnae = ''
      this.NotaServico.ggsIssTipoTributacao = null
      this.NotaServico.ggsIssExigibilidade = null
      this.NotaServico.ggsIssRetido = null
      this.NotaServico.ggsAliquota = ''
      this.NotaServico.ggsPisAliquota = null
      this.NotaServico.ggsCofinsAliquota = null
      this.NotaServico.ggsCsllAliquota = null
      this.NotaServico.ggsInssAliquota = null
      this.NotaServico.ggsIrrfAliquota = null
      this.NotaServico.ggsOutrasRetencoes = null
      this.NotaServico.ggsCppAliquota = null
      this.NotaServico.ggsTributacaoTotalFederal = null
      this.NotaServico.ggsTributacaoTotalEstadual = null
      this.NotaServico.ggsTributacaoTotalMunicipal = null

      // faturas
      this.pbgId = 0
      this.ValorSetup = 0
      this.ParcelamentoSetup = 0
      this.DataPrimeiroVencimentoSetup = ''
      this.SetupFinanceiro = null
      this.SetupCollectionPolicy = { ...novaPoliticaSetup(), chargeTypeCode: 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: ['CC', 'PIX', 'BB'] }
      this.SetupModalCancelamento = false
      this.SetupMotivoCancelamento = ''
      this.SetupCancelamentoErro = ''
      this.SetupErroConsulta = false
      this.ValorMensalidade = 0
      this.NovoCicloMensalidade()
      this.ListaFaturas = []

      // Sinistros
      this.SinistroConfig.garId = 0
      this.SinistroConfig.gscMulta = 0
      this.SinistroConfig.gscJuroDiario = 0
      this.SinistroConfig.gscPrazoCancelamentoAcordoDia = 0
	      this.SinistroConfig.gscEmailAprovacao = ''
	      this.SinistroConfig.gscEmailPagamento = ''
	      this.SinistroConfig.gscEmailCobranca = ''
	      this.SinistroConfig.gscEmailFinanceiro = ''
	      this.SinistroConfig.gscEmailJuridico = ''
      this.SinistroConfig.gscEmailDiasCobranca = []
      this.DocumentoSinistro.tsnId = null
      this.DocumentoSinistro.docId = null
      this.DocumentoDebitoSinistro.docId = null
      this.DocumentoDebitoSinistro.possuiJuros = false
      this.ListaSinistroDocumentos = []
      this.ListaSinistroDebitoDocumentos = []

      this.tab = 'dados'
    },
    EditCancel () {
      // window.location.reload();
      this.$router.go(0)
    },
    EditGrid (item) {
      this.SetupCollectionPolicy = { ...novaPoliticaSetup(), chargeTypeCode: 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: ['CC', 'PIX', 'BB'] }
      this.NovoCicloMensalidade()
      this.EditView = true
      this.tab = 'dados'
      // console.log('item')
      // console.log(item)
      if (item.garId != '') {
        // Lógica para editar o item
        axios.get('/Telas/Garantidoras/GetById/' + item.garId)
          .then(response => {
            this.Garantidora = response.data
            this.NormalizaControleContratacoesVigencia()
            if (this.Garantidora.garDataLimiteAcesso) {
              this.Garantidora.garDataLimiteAcesso = moment(this.Garantidora.garDataLimiteAcesso).format('YYYY-MM-DD')
            }
            if (this.Garantidora.garMesZeraFaturas) {
              this.Garantidora.garMesZeraFaturas = moment(this.Garantidora.garMesZeraFaturas).format('YYYY-MM-DD')
            }

            // carregar endereços
            this.CarregaEndereco(item.garId)
            // carregar planos
            this.CarregaPlano(item.garId)
            // carregar servicos extras
            this.CarregaServicoExtras(item.garId)
            // carregar serasa
            this.CarregaSerasa(item.garId)
            // carregar processos
            this.CarregaProcessos(item.garId)
            // carregar pagamentos
            this.CarregaPagamentos(item.garId)
            // carregar assinaturas
            this.CarregaAssinatura(item.garId)
            // carregar contratos
            this.CarregaContratos(item.garId)
            // carregar notas
            this.CarregaNota(item.garId)
            // carregar notas servicos
            this.CarregaNotaServico(item.garId)
            // carregar faturas
            this.CarregaFaturas(item.garId)
            // carregar Sinistros
            this.CarregaSinistro(item.garId)
            this.CarregaSinistroDocumentos(item.garId)
            this.CarregaSinistroDebitoDocumentos(item.garId)
          })
      }
    },
    async Add () {
      if (this.isSubmittingAdd) return // Proteção adicional
      this.isSubmittingAdd = true
      this.NormalizaControleContratacoesVigencia()
      if (!this.ValidaUrlParcial()) {
        this.isSubmittingAdd = false
        return
      }
      if (this.Garantidora.tpdId === '' || this.Garantidora.tpdId === null) {
        this.$mensagemAviso('Campo Tipo Pessoa Obrigatório.')
        this.isSubmittingAdd = false
      } else if (this.Garantidora.garDocumento == '' || this.Garantidora.garDocumento == null) {
        this.$mensagemAviso('Campo Nº Documento Obrigatório.')
        this.isSubmittingAdd = false
      } else if (!this.ValidaDocumentoGarantidora()) {
        this.$mensagemAviso(this.Garantidora.tpdId === 1 ? 'CPF invÃ¡lido.' : 'CNPJ invÃ¡lido.')
        this.isSubmittingAdd = false
      } else if (this.Garantidora.garNomeEmpresa == '' || this.Garantidora.garNomeEmpresa == null) {
        this.$mensagemAviso('Campo Nome Obrigatório.')
        this.isSubmittingAdd = false
      } else if ((this.Garantidora.garRazaoSocial === '' || this.Garantidora.garRazaoSocial === null) && this.Garantidora.tpdId == 2) {
        this.$mensagemAviso('Campo Razão Social Obrigatório.')
        this.isSubmittingAdd = false
      } else if (this.Garantidora.garTelefone === '' || this.Garantidora.garTelefone === null) {
        this.$mensagemAviso('Campo Telefone Obrigatório.')
        this.isSubmittingAdd = false
      } else if (this.Garantidora.garWhatsapp === '' || this.Garantidora.garWhatsapp === null) {
        this.$mensagemAviso('Campo Whatsapp Obrigatório.')
        this.isSubmittingAdd = false
      } else if (this.Garantidora.garEmail === '' || this.Garantidora.garEmail === null) {
        this.$mensagemAviso('Campo E-mail Obrigatório.')
        this.isSubmittingAdd = false
      } else if (!this.isEmailValid(this.Garantidora.garEmail)) {
        this.$mensagemAviso('E-mail Inválido.')
        this.isSubmittingAdd = false
      } else if ((this.Garantidora.garResponsavel === '' || this.Garantidora.garResponsavel === null) && this.Garantidora.tpdId === 2) {
        this.$mensagemAviso('Campo Responsável Obrigatório.')
        this.isSubmittingAdd = false
      } else if ((this.Garantidora.garCampoExtra1 === '' || this.Garantidora.garCampoExtra1 === null) && this.Garantidora.tpdId === 2) {
        this.$mensagemAviso('Campo CPF Responsável Obrigatório.')
        this.isSubmittingAdd = false
      } else {
        if (this.Garantidora.garVisivel === '' || this.Garantidora.garVisivel === null) {
          this.Garantidora.garVisivel = true
        }
        if (this.Garantidora.garAtivo === '' || this.Garantidora.garAtivo === null) {
          this.Garantidora.garAtivo = true
        }
        this.Garantidora.garDataCadastro = this.$moment().format('YYYY-MM-DD')
        this.Garantidora.garCodCancelamento = null
        this.Garantidora.garMotivoCancelamento = ''
        this.Garantidora.garDataLimiteAcesso = null
        this.Garantidora.garZeraFaturas = null
        this.Garantidora.garMesZeraFaturas = null

        if (this.selectedFile != '' && this.selectedFile != null) {
          const uploadSuccess = await this.UploadImg(this.selectedFile[0])
          if (uploadSuccess.status == 200) {
            this.Garantidora.garUrlLogo = uploadSuccess.data.nameFile
            axios.post('/Telas/Garantidoras/Add', this.Garantidora)
              .then(async response => {
                if (response.data > 0) {
                  this.Garantidora.garId = response.data
                  if (!(await this.SalvarEnderecoVinculado())) return
                  // carregar endereços
                  this.CarregaEndereco(this.Garantidora.garId)
                  // carregar planos
                  this.CarregaPlano(this.Garantidora.garId)
                  // carregar serasa
                  this.CarregaSerasa(this.Garantidora.garId)
                  // carregar serasa
                  this.CarregaPagamentos(this.Garantidora.garId)
                  // carregar assinaturas
                  this.CarregaAssinatura(this.Garantidora.garId)
                  // carregar contratos
                  this.CarregaContratos(this.Garantidora.garId)
                  this.$mensagemAvisoSucesso('Registro Incluído. abas para informações adicionais liberadas.')
                }
              }).finally(() => {
                this.isSubmittingAdd = false // Libera botão ao final
              })
          } else {
            this.$mensagemErro('Não foi possível carregar imagem.')
          }
        } else {
          this.Garantidora.garUrlLogo = ''
          axios.post('/Telas/Garantidoras/Add', this.Garantidora)
            .then(async response => {
              if (response.data > 0) {
                this.Garantidora.garId = response.data
                if (!(await this.SalvarEnderecoVinculado())) return
                // carregar endereços
                this.CarregaEndereco(this.Garantidora.garId)
                // carregar planos
                this.CarregaPlano(this.Garantidora.garId)
                // carregar serasa
                this.CarregaSerasa(this.Garantidora.garId)
                // carregar serasa
                this.CarregaPagamentos(this.Garantidora.garId)
                // carregar assinaturas
                this.CarregaAssinatura(this.Garantidora.garId)
                // carregar contratos
                this.CarregaContratos(this.Garantidora.garId)
                this.$mensagemAvisoSucesso('Registro Incluído. abas para informações adicionais liberadas.')
              }
            }).finally(() => {
              this.isSubmittingAdd = false // Libera botão ao final
            })
        }
      }
    },
    async Put () {
      if (this.isSubmittingPut) return // Proteção adicional
      this.isSubmittingPut = true
      this.NormalizaControleContratacoesVigencia()
      if (!this.ValidaUrlParcial()) {
        this.isSubmittingPut = false
        return
      }
      const documentoGarantidoraValido = this.ValidaDocumentoGarantidora()
      if (this.Garantidora.tpdId !== '' && this.Garantidora.tpdId !== null &&
                this.Garantidora.garDocumento != '' && this.Garantidora.garDocumento != null &&
                !documentoGarantidoraValido) {
        this.$mensagemAviso(this.Garantidora.tpdId === 1 ? 'CPF invalido.' : 'CNPJ invalido.')
        this.isSubmittingPut = false
        return
      }

      if (this.Garantidora.tpdId === '' || this.Garantidora.tpdId === null) {
        this.$mensagemAviso('Campo Tipo Pessoa Obrigatório.')
        this.isSubmittingPut = false
      } else if (this.Garantidora.garDocumento == '' || this.Garantidora.garDocumento == null) {
        this.$mensagemAviso('Campo Nº Documento Obrigatório.')
        this.isSubmittingPut = false
      } else if (this.Garantidora.garNomeEmpresa == '' || this.Garantidora.garNomeEmpresa == null) {
        this.$mensagemAviso('Campo Nome Obrigatório.')
        this.isSubmittingPut = false
      } else if ((this.Garantidora.garRazaoSocial === '' || this.Garantidora.garRazaoSocial === null) && this.Garantidora.tpdId == 2) {
        this.$mensagemAviso('Campo Razão Social Obrigatório.')
        this.isSubmittingAdd = false
      } else if (this.Garantidora.garTelefone === '' || this.Garantidora.garTelefone === null) {
        this.$mensagemAviso('Campo Telefone Obrigatório.')
        this.isSubmittingPut = false
      } else if (this.Garantidora.garWhatsapp === '' || this.Garantidora.garWhatsapp === null) {
        this.$mensagemAviso('Campo Whatsapp Obrigatório.')
        this.isSubmittingPut = false
      } else if (this.Garantidora.garEmail === '' || this.Garantidora.garEmail === null) {
        this.$mensagemAviso('Campo E-mail Obrigatório.')
        this.isSubmittingPut = false
      } else if (!this.isEmailValid(this.Garantidora.garEmail)) {
        this.$mensagemAviso('E-mail Inválido.')
        this.isSubmittingPut = false
      } else if ((this.Garantidora.garResponsavel === '' || this.Garantidora.garResponsavel === null) && this.Garantidora.tpdId === 2) {
        this.$mensagemAviso('Campo Responsável Obrigatório.')
        this.isSubmittingPut = false
      } else if ((this.Garantidora.garCampoExtra1 === '' || this.Garantidora.garCampoExtra1 === null) && this.Garantidora.tpdId === 2) {
        this.$mensagemAviso('Campo CPF Responsável Obrigatório.')
        this.isSubmittingPut = false
      } else if ((this.Garantidora.garCodCancelamento != '' && this.Garantidora.garCodCancelamento != null) && (this.Garantidora.garDataLimiteAcesso === null || this.Garantidora.garDataLimiteAcesso === '')) {
        this.$mensagemAviso('Campo Data Limite Acesso Obrigatório.')
        this.isSubmittingPut = false
      } else if ((this.Garantidora.garCodCancelamento == '' || this.Garantidora.garCodCancelamento == null) && (this.Garantidora.garDataLimiteAcesso != null && this.Garantidora.garDataLimiteAcesso != '')) {
        this.$mensagemAviso('Campo Motivo Bloqueio Obrigatório.')
        this.isSubmittingPut = false
      } else if ((this.Garantidora.garCodCancelamento != '' && this.Garantidora.garCodCancelamento != null) &&
                         (this.Garantidora.garDataLimiteAcesso != null && this.Garantidora.garDataLimiteAcesso != '') &&
                          (this.Garantidora.garZeraFaturas != null && this.Garantidora.garZeraFaturas != 0) && (this.Garantidora.garMesZeraFaturas == null || this.Garantidora.garMesZeraFaturas == '')
      ) {
        this.$mensagemAviso('Campo Data Zerar Faturas Obrigatório.')
        this.isSubmittingPut = false
      } else {
        if (this.Garantidora.garVisivel === '' || this.Garantidora.garVisivel === null) {
          this.Garantidora.garVisivel = true
        }
        if (this.Garantidora.garAtivo === '' || this.Garantidora.garAtivo === null) {
          this.Garantidora.garAtivo = true
        }

        if (this.Garantidora.garCodCancelamento != null && this.Garantidora.garCodCancelamento != '') {
          this.Garantidora.garMotivoCancelamento = this.TiposCancelamento.filter(x => x.Cod == this.Garantidora.garCodCancelamento)[0].Nome
        }

        if (this.Garantidora.garCodCancelamento == 1) {
          this.Garantidora.garZeraFaturas = null
          this.Garantidora.garMesZeraFaturas = null
        }

        if (this.Garantidora.garZeraFaturas == 0) {
          this.Garantidora.garMesZeraFaturas = null
        }

        if (this.Garantidora.garDataLimiteAcesso != null && this.Garantidora.garDataLimiteAcesso != '') {
          this.Garantidora.garDataLimiteAcesso = this.$moment(this.Garantidora.garDataLimiteAcesso).format('YYYY-MM-DD')

          if (this.tab === 'cancelamento' && this.$moment(this.Garantidora.garDataLimiteAcesso).isAfter(this.$moment().startOf('day'), 'day')) {
            this.Garantidora.garAtivo = true
          }
        }
        if (this.Garantidora.garMesZeraFaturas != null && this.Garantidora.garMesZeraFaturas != '') {
          this.Garantidora.garMesZeraFaturas = this.$moment(this.Garantidora.garMesZeraFaturas).format('YYYY-MM-DD')
        }

        if (this.Garantidora.garCodCancelamento == null || this.Garantidora.garCodCancelamento == '') {
          this.Garantidora.garCodCancelamento = null
          this.Garantidora.garMotivoCancelamento = ''
          this.Garantidora.garDataLimiteAcesso = null
          this.Garantidora.garZeraFaturas = null
          this.Garantidora.garMesZeraFaturas = null
        }
        // console.log('this.Garantidora')
        // console.log(this.Garantidora)

        if (this.selectedFile != '' && this.selectedFile != null) {
          //  console.log(this.selectedFile[0].size)
          const uploadSuccess = await this.UploadImg(this.selectedFile[0])
          if (uploadSuccess.status == 200) {
            this.Garantidora.garUrlLogo = uploadSuccess.data.nameFile
            axios.put('/Telas/Garantidoras/Update', this.Garantidora)
              .then(async response => {
                if (response.status == 200) {
                  if (!(await this.SalvarEnderecoVinculado())) return
                  this.$mensagemAvisoSucesso('Registro Alterado.')
                  this.Get()
                }
              }).finally(() => {
                this.isSubmittingPut = false // Libera botão ao final
              })
          } else {
            this.$mensagemErro('Não foi possível carregar imagem.')
          }
        } else {
          if (this.Garantidora.garUrlLogo != '') {
            this.Garantidora.garUrlLogo = '0'
          }
          axios.put('/Telas/Garantidoras/Update', this.Garantidora)
            .then(async response => {
              if (response.status == 200) {
                if (!(await this.SalvarEnderecoVinculado())) return
                this.$mensagemAvisoSucesso('Registro Alterado.')
                this.Get()
              }
            }).finally(() => {
              this.isSubmittingPut = false // Libera botão ao final
            })
        }
      }
    },
    CriarUsuarioEmail () {
      if (this.GarantidoraPlanos.cpgId === '') {
        this.$mensagemAviso('Campo Plano Assinatura Obrigatório.')
      } else if (this.Serasa.gseRangeAprovacao === '' || this.Serasa.gseRangeAprovacao === '0') {
        this.$mensagemAviso('Campo Serasa - Nível de aprovação Obrigatório.')
      } else if (this.Assinatura.gasIdRepositorio === '') {
        this.$mensagemAviso('Campo Assinaturas - Id Repositório Obrigatório.')
      } else if (this.Pagamento.topId === '') {
        this.$mensagemAviso('Campo Pagamento - Operadora Obrigatório.')
      } else if (this.Pagamento.gpgEmailAviso === '') {
        this.$mensagemAviso('Campo Pagamento - E-mail Notificação Obrigatório.')
      }
      /* else if (this.Pagamento.gpgSplitToken === ''){
                this.$mensagemAviso("Campo Pagamento - Chave de Identificação Obrigatório.")
            } */
      else if (this.ListaMeusContratos.length == 0) {
        this.$mensagemAviso('Campo Contrato - Modelo de contrato Obrigatório ser adicionado.')
      } else if (this.ListaMeusContratos.filter(x => x.gctIdEnvelope === null).length > 0) {
        this.$mensagemAviso('Contrato precisar ser enviado para assinatura.')
      } else {
        axios.get('/Telas/Garantidoras/GetByEmail/' + this.Garantidora.garEmail)
          .then(response => {
            this.ListUser = response.data.filter(x => x.tpeId == 1 && x.garId == this.Garantidora.garId)
            // console.log('this.ListUser')
            // console.log(this.ListUser)
            if (this.ListUser.length == 0) {
              const _usuario = {
                cusId: 0,
                cusNome: this.Garantidora.garNomeEmpresa,
                cusEmail: this.Garantidora.garEmail,
                cusTelefone: this.Garantidora.garTelefone,
                cusWhatsapp: this.Garantidora.garWhatsapp,
                cusSenha: this.Garantidora.garWhatsapp.slice(-4) + this.Garantidora.garDocumento.slice(-2),
                cusDtCadastro: this.$moment(),
                tusId: 5,
                cusAtivo: true,
                cusUrlImagem: '',
                cliId: 0,
                admTipoUsuario: { tusId: 5 },
                tpeId: 1,
                garId: this.Garantidora.garId,
                pesId: this.Garantidora.garId
              }
              axios.post('/Telas/Garantidoras/AddCadastroUsuario', _usuario)
                .then(response => {
                  if (response.data > 0) {
                    _usuario.cusId = response.data
                    this.EnviaEmailCadastro(_usuario)
                    this.$mensagemAviso('Usuário criado e notificado.')
                  }
                })
            } else {
              this.$mensagemAviso('Usuário já possui cadastro ativo.')
            }
          })
      }
    },
    EnviaEmailCadastro (usuariocad) {
      axios.get(`/Telas/Garantidoras/GetByIdMensagemPadrao/4?garId=${this.Garantidora.garId || 0}`)
        .then(async response => {
          this.templateEmail = response.data
          const _dadosEmail = {
            nomeDe: '[NomeSistema]',
            nomePara: usuariocad.cusNome,
            assunto: 'Cadastro Garantidora - Sistema [NomeSistema]',
            destinatario: usuariocad.cusEmail,
            emailResposta: this.$GarantePayEmail,
            textoEmail: this.templateEmail.mpdTexto
              .replace('[NomeGarantidora]', this.Garantidora.garNomeEmpresa)
              .replace('[NomeUsuario]', this.Garantidora.garResponsavel)
              .replace('[LinkAcesso]', this.$GarantePayLinkAcesso + this.Garantidora.garId + '/' + this.Garantidora.garNomeEmpresa.toLowerCase().replaceAll(' ', '-').replaceAll('/', '').replaceAll('&', ''))
              .replace('[UsuarioLogin]', usuariocad.cusEmail)
              .replace('[SenhaAcesso]', usuariocad.cusSenha),
            listAnexos: null // {nomeAnexo: '', anexo: '', tipoAnexo: ''}
          }
          const emailPersonalizado = await personalizarEmailGarantidora(_dadosEmail, this.Garantidora.garId || this.User.garid || 0, this.$imgURL, this.$GarantePayLinkAcesso, this.$GarantePayEmail).catch(error => {
            this.$mensagemErro(error.message || 'Não foi possível carregar a identificação da garantidora para o e-mail.')
            return null
          })
          if (!emailPersonalizado) return
          axios.post('/Telas/Garantidoras/Enviamail', emailPersonalizado)
        })
    },
    // edit
    DeleteGrid (item) {
      this.$mensagemConfirma('Tem certeza que deseja ocultar esta garantidora?')
        .then((result) => {
          if (result.isConfirmed) {
            axios.get(`/Telas/Garantidoras/GetById/${item.garId}`)
              .then(response => axios.put('/Telas/Garantidoras/Update', {
                ...response.data,
                garVisivel: false
              }))
              .then(response => {
                if (response.status == 200) {
                  this.$mensagemAvisoSucesso('Garantidora ocultada com sucesso.')
                  this.Get()
                }
              })
          }
        })
    },
    montaGrid () {
      this.headers = []
      this.headers.push({ text: 'Id', value: 'garId', sortable: true })
      this.headers.push({ text: 'Nome', value: 'garNomeEmpresa', sortable: true })
      this.headers.push({ text: 'Documento', value: 'garDocumento', sortable: true })
      this.headers.push({ text: 'Whatsapp', value: 'garWhatsapp', sortable: true })
      this.headers.push({ text: 'Telefone', value: 'garTelefone', sortable: true, hideFilter: true })
      this.headers.push({ text: 'E-mail', value: 'garEmail', sortable: true })
      this.headers.push({ text: 'Situação', value: 'situacaoAcesso', hideColumn: true, hideExport: true, filterAccessor: item => this.situacaoAcessoGarantidora(item) })
      this.headers.push({ text: 'Ações', value: 'actions' })
    },
    garantidoraInativa (item) {
      if (!item) return false
      if (item.garAtivo === false || item.garAtivo === 0) return true
      if (!item.garDataLimiteAcesso) return false
      const dataLimite = moment(String(item.garDataLimiteAcesso).slice(0, 10), 'YYYY-MM-DD', true)
      return dataLimite.isValid() && dataLimite.isBefore(moment().startOf('day'))
    },
    situacaoAcessoGarantidora (item) {
      return this.garantidoraInativa(item) ? 'Inativa' : 'Ativa'
    },
    classeLinhaGarantidora (item) {
      return this.garantidoraInativa(item) ? 'gp-row-access-blocked' : ''
    },
    // garantidora
    // endereco
    CarregaEndereco (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdGarantidoraEndereco/' + _garId)
        .then(response => {
          if (response.data.length > 0) {
            this.Endereco = response.data[0]
            this.showend = true
          } else {
            this.Endereco.garId = _garId
          }
        })
    },
    Buscacep (value) {
      if (value == '') {
        this.$mensagemAviso('Digite um CEP válido.')
      } else {
        fetch('https://viacep.com.br/ws/' + value + '/json/')
          .then(response => {
            if (!response.ok) {
              throw new Error('CEP inexistente')
            }
            return response.json()
          })
          .then(data => {
            this.Retornocep = data
            if (this.Retornocep != null) {
              this.Endereco.gaeEndereco = this.Retornocep.logradouro
              this.Endereco.gaeNumero = null
              this.Endereco.gaeComplemento = null
              this.Endereco.gaeEstado = this.Retornocep.uf
              this.Endereco.gaeCidade = this.Retornocep.localidade
              this.Endereco.gaeBairro = this.Retornocep.bairro
              this.Endereco.gaeCodigoDistrito = this.Retornocep.ibge
              this.showend = true
            } else {
              this.$mensagemAviso('CEP inexistente')
            }
          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    async SalvarEnderecoVinculado () {
      const possuiEndereco = [this.Endereco.gaeCep, this.Endereco.gaeEndereco, this.Endereco.gaeCidade,
        this.Endereco.gaeBairro, this.Endereco.gaeEstado, this.Endereco.gaeCodigoDistrito]
        .some(valor => valor !== '' && valor !== null && valor !== undefined)
      if (!possuiEndereco) return true

      const obrigatorios = [
        ['gaeCep', 'Campo CEP Obrigatório.'],
        ['gaeEndereco', 'Campo Endereço Obrigatório.'],
        ['gaeNumero', 'Campo Número Obrigatório.'],
        ['gaeEstado', 'Campo Estado Obrigatório.'],
        ['gaeCidade', 'Campo Cidade Obrigatório.'],
        ['gaeBairro', 'Campo Bairro Obrigatório.'],
        ['gaeCodigoDistrito', 'Campo Código Distrito (IBGE) Município Obrigatório.']
      ]
      const pendente = obrigatorios.find(([campo]) => this.Endereco[campo] === '' || this.Endereco[campo] === null || this.Endereco[campo] === undefined)
      if (pendente) {
        this.$mensagemAviso(pendente[1])
        return false
      }

      this.Endereco.garId = this.Garantidora.garId
      this.Endereco.gaeCodigoDistrito = String(this.Endereco.gaeCodigoDistrito)
      if (this.Endereco.gaeId) {
        await axios.put('/Telas/Garantidoras/UpdateGarantidoraEndereco', this.Endereco)
      } else {
        const response = await axios.post('/Telas/Garantidoras/AddGarantidoraEndereco', this.Endereco)
        this.Endereco.gaeId = response.data
      }
      return true
    },
    EnderecoAdd () {
      if (this.Endereco.gaeCep == '') {
        this.$mensagemAviso('Campo CEP Obrigatório.')
      } else if (this.Endereco.gaeEndereco === '') {
        this.$mensagemAviso('Campo Endereço Obrigatório.')
      } else if (this.Endereco.gaeNumero === '') {
        this.$mensagemAviso('Campo Número Obrigatório.')
      } else if (this.Endereco.gaeEstado === '') {
        this.$mensagemAviso('Campo Estado Obrigatório.')
      } else if (this.Endereco.gaeCidade === '') {
        this.$mensagemAviso('Campo Cidade Obrigatório.')
      } else if (this.Endereco.gaeBairro === '') {
        this.$mensagemAviso('Campo Bairro Obrigatório.')
      } else if (this.Endereco.gaeCodigoDistrito === '') {
        this.$mensagemAviso('Campo Codigo Distritro (IBGE) Município Obrigatório.')
      } else {
        this.Endereco.garId = this.Garantidora.garId
        axios.post('/Telas/Garantidoras/AddGarantidoraEndereco', this.Endereco)
          .then(response => {
            if (response.data > 0) {
              this.Endereco.gaeId = response.data
              this.$mensagemAvisoSucesso('Endereço Incluído')
            }
          })
      }
    },
    EnderecoPut () {
      if (this.Endereco.gaeCep == '') {
        this.$mensagemAviso('Campo CEP Obrigatório.')
      } else if (this.Endereco.gaeEndereco === '') {
        this.$mensagemAviso('Campo Endereço Obrigatório.')
      } else if (this.Endereco.gaeNumero === '') {
        this.$mensagemAviso('Campo Número Obrigatório.')
      } else if (this.Endereco.gaeEstado === '') {
        this.$mensagemAviso('Campo Estado Obrigatório.')
      } else if (this.Endereco.gaeCidade === '') {
        this.$mensagemAviso('Campo Cidade Obrigatório.')
      } else if (this.Endereco.gaeBairro === '') {
        this.$mensagemAviso('Campo Bairro Obrigatório.')
      } else if (this.Endereco.gaeCodigoDistrito === '') {
        this.$mensagemAviso('Campo Codigo Distritro (IBGE) Município Obrigatório.')
      } else {
        this.Endereco.gaeCodigoDistrito = String(this.Endereco.gaeCodigoDistrito)
        axios.put('/Telas/Garantidoras/UpdateGarantidoraEndereco', this.Endereco)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Endereço Alterado.')
            }
          })
      }
    },
    EnderecoCancel () {
      /* this.Endereco.grtId = 0;
            this.Endereco.cdtId = 0;
            this.Endereco.gaeEndereco = '';
            this.Endereco.gaeNumero = null;
            this.Endereco.gaeComplemento = '';
            this.Endereco.gaeObsEndereco = '';
            this.Endereco.gaeCep = '';
            this.Endereco.gaePais = '';
            this.Endereco.gaeEstado = '';
            this.Endereco.gaeCidade = '';
            this.Endereco.gaeBairro = '';
            this.showend = false; */
      this.$router.go(0)
    },
    // endereco
    // plano
    CarregaPlano (_garId) {
      return axios.get('/Telas/Garantidoras/GetByGarIdGarantidoraPlanos/' + _garId)
        .then(response => {
          if (response.data.length > 0) {
            this.GarantidoraPlanos = { ...response.data[0] }
            if (!this.MensalidadeFinanceiro?.status) {
              this.MensalidadeValorPadrao = Number(this.GarantidoraPlanos.gplValor) || null
              this.MensalidadeDiaVencimento = Number(this.GarantidoraPlanos.gplVencimento) || 10
            }
            if (Number(this.User.garid) === 0 && this.ModoFinanceiro.enviarAoFinanceiro) this.CarregaMensalidadeFinanceiro()
            this.GarantidoraPlanos.gplValor = String(this.GarantidoraPlanos.gplValor).replace('.', ',')
            this.GarantidoraPlanos.gplRemuneracaoNegocio = String(this.GarantidoraPlanos.gplRemuneracaoNegocio).replace('.', ',')
            this.GarantidoraPlanos.gplValorAdesao = this.GarantidoraPlanos.gplValorAdesao == null
              ? null : String(this.GarantidoraPlanos.gplValorAdesao).replace('.', ',')
            for (const field of ['gplValorMinSetupResidencial', 'gplValorMinSetupComercial']) {
              this.GarantidoraPlanos[field] = this.GarantidoraPlanos[field] == null ? '' : String(this.GarantidoraPlanos[field]).replace('.', ',')
            }

            if (this.GarantidoraPlanos.gplVigenciaInicial) {
              this.GarantidoraPlanos.gplVigenciaInicial = moment(this.GarantidoraPlanos.gplVigenciaInicial).format('YYYY-MM-DD')
            }

            console.log('this.GarantidoraPlanos')
            console.log(this.GarantidoraPlanos)
          } else {
            this.GarantidoraPlanos.garId = _garId
          }
        })
    },
    ValidaMinimosSetup () {
      const values = {}
      for (const tipo of ['Residencial', 'Comercial']) {
        const field = 'gplValorMinSetup' + tipo
        const amount = parseSetupAmount(this.GarantidoraPlanos[field])
        if (!Number.isFinite(amount) || amount < 0 || amount > 99999999.99 || Math.abs(amount * 100 - Math.round(amount * 100)) > 0.000001) {
          this.$mensagemAviso('Informe o Valor Mínimo Setup ' + tipo + ' entre 0 e 99.999.999,99, com até duas casas decimais.')
          return false
        }
        values[field] = amount
      }
      Object.assign(this.GarantidoraPlanos, values)
      return true
    },
    PlanoAdd () {
      if (!this.ValidaMinimosSetup()) return
      if (this.GarantidoraPlanos.cpgId === '' || this.GarantidoraPlanos.cpgId === null) {
        this.$mensagemAviso('Campo Plano Obrigatório.')
      } else if (this.GarantidoraPlanos.gplVencimento === '') {
        this.$mensagemAviso('Campo Vencimento Obrigatório.')
      } else if (this.GarantidoraPlanos.gplVigenciaInicial === '') {
        this.$mensagemAviso('Campo Vigência Obrigatório.')
      } else {
        if (this.GarantidoraPlanos.gplValor !== '' && this.GarantidoraPlanos.gplValor !== null) {
          this.GarantidoraPlanos.gplValor = parseFloat(
            String(this.GarantidoraPlanos.gplValor).replace(',', '.')
          )
        } else {
          this.GarantidoraPlanos.gplValor = 0
        }

        if (this.GarantidoraPlanos.gplRemuneracaoNegocio !== '' && this.GarantidoraPlanos.gplRemuneracaoNegocio !== null) {
          this.GarantidoraPlanos.gplRemuneracaoNegocio = parseFloat(
            String(this.GarantidoraPlanos.gplRemuneracaoNegocio).replace(',', '.')
          )
        } else {
          this.GarantidoraPlanos.gplRemuneracaoNegocio = 0
        }

        if (this.GarantidoraPlanos.gplValorAdesao !== '' && this.GarantidoraPlanos.gplValorAdesao !== null) {
          this.GarantidoraPlanos.gplValorAdesao = parseFloat(
            String(this.GarantidoraPlanos.gplValorAdesao).replace(',', '.')
          )
        } else {
          this.GarantidoraPlanos.gplValorAdesao = 0
        }


        axios.post('/Telas/Garantidoras/AddGarantidoraPlanos', this.GarantidoraPlanos)
          .then(response => {
            if (response.data > 0) {
              this.GarantidoraPlanos.gplId = response.data
              this.$mensagemAvisoSucesso('Plano Incluído')
              this.CarregaPlano(this.Garantidora.garId)
            }
          })
      }
    },
    PlanoPut () {
      if (!this.ValidaMinimosSetup()) return
      if (this.GarantidoraPlanos.cpgId === '' || this.GarantidoraPlanos.cpgId === null) {
        this.$mensagemAviso('Campo Plano Obrigatório.')
      } else if (this.GarantidoraPlanos.gplVencimento === '') {
        this.$mensagemAviso('Campo Vencimento Obrigatório.')
      } else if (this.GarantidoraPlanos.gplVigenciaInicial === '') {
        this.$mensagemAviso('Campo Vigência Obrigatório.')
      } else {
        if (this.GarantidoraPlanos.gplValor !== '' && this.GarantidoraPlanos.gplValor !== null) {
          this.GarantidoraPlanos.gplValor = parseFloat(
            String(this.GarantidoraPlanos.gplValor).replace(',', '.')
          )
        } else {
          this.GarantidoraPlanos.gplValor = 0
        }

        if (this.GarantidoraPlanos.gplRemuneracaoNegocio !== '' && this.GarantidoraPlanos.gplRemuneracaoNegocio !== null) {
          this.GarantidoraPlanos.gplRemuneracaoNegocio = parseFloat(
            String(this.GarantidoraPlanos.gplRemuneracaoNegocio).replace(',', '.')
          )
        } else {
          this.GarantidoraPlanos.gplRemuneracaoNegocio = 0
        }

        if (this.GarantidoraPlanos.gplValorAdesao !== '' && this.GarantidoraPlanos.gplValorAdesao !== null) {
          this.GarantidoraPlanos.gplValorAdesao = parseFloat(
            String(this.GarantidoraPlanos.gplValorAdesao).replace(',', '.')
          )
        } else {
          this.GarantidoraPlanos.gplValorAdesao = 0
        }


        axios.put('/Telas/Garantidoras/UpdateGarantidoraPlanos', this.GarantidoraPlanos)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Plano Alterado.')
              this.CarregaPlano(this.Garantidora.garId)
            }
          })
      }
    },
    PlanoCancel () {
      /* this.GarantidoraPlanos.grtId = 0;
            this.GarantidoraPlanos.cdtId = 0;
            this.GarantidoraPlanos.cpgId = null;
            this.GarantidoraPlanos.gplValor = null;
            this.GarantidoraPlanos.gplVencimento = '';
            this.GarantidoraPlanos.gplVigenciaInicial = null;
            this.GarantidoraPlanos.gplTipoCobranca = '';
            this.GarantidoraPlanos.gplRemuneracaoNegocio = null;
            this.GarantidoraPlanos.gplQtdeUsuarios = '';
            this.GarantidoraPlanos.gplValorAdesao = null; */
      this.$router.go(0)
    },
    // plano
    // servicos extras
    CarregaListaServicoExtra () {
      axios.get('/Telas/Garantidoras/GetListaServicoExtra')
        .then(response => {
          this.ListaServicosExtrasCadastro = response.data || []
        })
    },
    CarregaServicoExtras (_garId) {
      return axios.get('/Telas/Garantidoras/GetByGarIdServicoExtras/' + _garId)
        .then(response => {
          this.ListaGarantidoraServicosExtras = (response.data || [])
            .map(x => ({
              ...x,
              gsvDataInicio: x.gsvDataInicio ? moment(x.gsvDataInicio).format('YYYY-MM-DD') : null,
              gsvProximaCobranca: x.gsvProximaCobranca ? moment(x.gsvProximaCobranca).format('YYYY-MM-DD') : null
            }))
        })
    },
    ServicoExtraReset () {
      this.ServicoExtraConfig = { contractVersion: 5, collectionPolicy: { ...novaPoliticaSetup(), chargeTypeCode: 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: ['CC', 'PIX', 'BB'] } }
      this.ServicoExtra.gsvId = 0
      this.ServicoExtra.garId = this.Garantidora.garId || null
      this.ServicoExtra.lseId = null
      this.ServicoExtra.gsvQuantidade = 0
      this.ServicoExtra.gsvValor = null
      this.ServicoExtra.gsvPeriodicidade = ''
      this.ServicoExtra.gsvAtivo = true
      this.ServicoExtra.gsvDataInicio = null
      this.ServicoExtra.gsvProximaCobranca = null
      this.ServicoExtra.lseCodigoServicoGarantePay = null
    },
    ServicoExtraSeleciona () {
      const servico = this.ListaServicosExtrasCadastro.find(x => x.lseId == this.ServicoExtra.lseId)
      if (!servico) {
        this.ServicoExtra.gsvQuantidade = 0
        this.ServicoExtra.gsvValor = null
        this.ServicoExtra.gsvPeriodicidade = ''
        this.ServicoExtra.lseCodigoServicoGarantePay = null
        return
      }

      this.ServicoExtra.gsvQuantidade = servico.lseQuantidade
      this.ServicoExtra.gsvValor = servico.lseValor
      this.ServicoExtra.gsvPeriodicidade = servico.lsePeriodicidade == 'Única' ? 'Unica' : servico.lsePeriodicidade
      this.ServicoExtra.lseCodigoServicoGarantePay = servico.lseCodigoServicoGarantePay
    },
    ServicoExtraNome (_lseId) {
      const servico = this.ListaServicosExtrasCadastro.find(x => x.lseId == _lseId)
      return servico ? servico.lseNome : ''
    },
    ServicoExtraJaIncluido (_lseId) {
      return this.ListaGarantidoraServicosExtras.some(item => String(item.lseId) === String(_lseId) && item.gsvId !== this.ServicoExtra.gsvId)
    },
    ServicoExtraPayload (item, ativo) {
      return {
        gsvId: item.gsvId || 0,
        garId: this.Garantidora.garId,
        lseId: item.lseId,
        gsvQuantidade: Number(item.gsvQuantidade || 0),
        gsvValor: item.gsvValor !== '' && item.gsvValor !== null
          ? parseFloat(String(item.gsvValor).replace(',', '.'))
          : 0,
        gsvPeriodicidade: item.gsvPeriodicidade,
        gsvAtivo: ativo,
        gsvDataInicio: item.gsvDataInicio || null,
        gsvProximaCobranca: item.gsvProximaCobranca || null,
        gsvFinanceiroJson: item.gsvFinanceiroJson || null
      }
    },
    ServicoExtraEditar (item) {
      if (item.gsvFinanceiroEnviado) return
      this.ServicoExtra = { ...item }
      let config = {}
      try { config = JSON.parse(item.gsvFinanceiroJson || '{}') } catch (_) { /* Legacy record without configuration. */ }
      this.ServicoExtraConfig = {
        contractVersion: 5,
        collectionPolicy: { ...novaPoliticaSetup(), ...(config.collectionPolicy || {}), chargeTypeCode: 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: config.collectionPolicy?.allowedPaymentMethodCodes ?? ['CC', 'PIX', 'BB'] }
      }
    },
    ServicoExtraErro (error) {
      this.$mensagemErro(error.response?.data?.message || error.response?.data?.Message || 'Não foi possível concluir a operação. Atualize a lista antes de tentar novamente.', { timer: undefined, showConfirmButton: true, confirmButtonText: 'OK' })
    },
    async ServicoExtraAdd (enviar = false) {
      if (!this.ModoFinanceiroCarregado || this.isSubmittingServicoExtra) return
      if (!this.ServicoExtra.lseId || this.ServicoExtraJaIncluido(this.ServicoExtra.lseId)) {
        this.$mensagemAviso('Selecione um serviço ainda não cadastrado. Para registros inativos, utilize Reativar.')
        return
      }
      const payload = this.ServicoExtraPayload(this.ServicoExtra, this.ServicoExtra.gsvAtivo !== false)
      const config = this.ServicoExtraConfig
      if (!(payload.gsvQuantidade > 0) || !Number.isInteger(payload.gsvQuantidade) || !(payload.gsvValor > 0) ||
          !payload.gsvPeriodicidade || !payload.gsvDataInicio || !payload.gsvProximaCobranca || (this.ModoFinanceiro.enviarAoFinanceiro && !config.collectionPolicy.allowedPaymentMethodCodes?.length)) {
        this.$mensagemAviso('Informe quantidade, valor unitário, periodicidade, início, primeiro vencimento e ao menos um método de pagamento.')
        return
      }
      payload.gsvFinanceiroJson = JSON.stringify({ contractVersion: 5, collectionPolicy: {
        penaltyPercentage: config.collectionPolicy.penaltyPercentage,
        dailyInterestPercentage: config.collectionPolicy.dailyInterestPercentage,
        chargeTypeCode: 'LINK_PAGAMENTO_AUTRA',
        allowedPaymentMethodCodes: config.collectionPolicy.allowedPaymentMethodCodes
      } })
      this.isSubmittingServicoExtra = true
      const garId = this.Garantidora.garId
      try {
        let id = payload.gsvId
        if (id) await axios.put('/Telas/Garantidoras/UpdateServicoExtra', payload)
        else {
          const response = await axios.post('/Telas/Garantidoras/AddServicoExtra', payload)
          id = response.data
        }
        // Keep the saved identity on send failure, avoiding a second insertion on retry.
        this.ServicoExtra = { ...payload, gsvId: id }
        await this.CarregaServicoExtras(garId)
        if (enviar && this.ModoFinanceiro.enviarAoFinanceiro) {
          const response = await axios.post(`/Telas/Garantidoras/ServicoExtraFinanceiro/${garId}/${id}`)
          this.$mensagemAvisoSucesso(`${response.data.count} registro(s) de recorrência ou cobrança única na fila do Financeiro.`)
          await this.CarregaServicoExtras(garId)
        } else this.$mensagemAvisoSucesso('Serviço extra salvo.')
        this.ServicoExtraReset()
      } catch (error) {
        this.ServicoExtraErro(error)
        await this.CarregaServicoExtras(garId)
      } finally { this.isSubmittingServicoExtra = false }
    },
    async ServicoExtraEnviar (item) {
      if (!this.ModoFinanceiro.enviarAoFinanceiro) return
      if (this.isSubmittingServicoExtra || item.gsvFinanceiroEnviado) return
      let config = {}
      try { config = JSON.parse(item.gsvFinanceiroJson || '{}') } catch (_) { /* Reconfigure legacy records. */ }
      if (config.contractVersion !== 5) {
        this.ServicoExtraEditar(item)
        this.$mensagemAviso('Preencha a configuração financeira deste cadastro e utilize Salvar e enviar.')
        return
      }
      this.isSubmittingServicoExtra = true
      try {
        const response = await axios.post(`/Telas/Garantidoras/ServicoExtraFinanceiro/${this.Garantidora.garId}/${item.gsvId}`)
        this.$mensagemAvisoSucesso(`${response.data.count} registro(s) de recorrência ou cobrança única na fila do Financeiro.`)
      } catch (error) { this.ServicoExtraErro(error) }
      finally {
        await this.CarregaServicoExtras(this.Garantidora.garId)
        this.isSubmittingServicoExtra = false
      }
    },
    ServicoExtraRecorrenciaEnviada (item) {
      if (!item.gsvFinanceiroEnviado || !['Mensal', 'Anual'].includes(item.gsvPeriodicidade)) return false
      try { return JSON.parse(item.gsvFinanceiroJson || '{}').contractVersion === 5 } catch (_) { return false }
    },
    async ServicoExtraInativar (item) {
      if (this.isSubmittingServicoExtra || this.ServicoExtraRecorrenciaEnviada(item)) return
      const active = item.gsvAtivo === false
      const result = await this.$mensagemConfirma(active
        ? 'Reativar este serviço? As cobranças já emitidas permanecem inalteradas.'
        : 'Inativar este serviço? Isso não cancela cobranças já emitidas, inclusive as futuras.')
      if (!result.isConfirmed) return
      this.isSubmittingServicoExtra = true
      try {
        await axios.put('/Telas/Garantidoras/UpdateServicoExtra', this.ServicoExtraPayload(item, active))
        this.$mensagemAvisoSucesso(active ? 'Serviço extra reativado.' : 'Serviço extra inativado.')
        await this.CarregaServicoExtras(this.Garantidora.garId)
      } catch (error) { this.ServicoExtraErro(error) }
      finally { this.isSubmittingServicoExtra = false }
    },
    formatCurrency (value) {
      if (value === null || value === undefined || value === '') return ''
      return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDate (value) {
      return value ? moment(value).format('DD/MM/YYYY') : ''
    },
    // servicos extras
    // serasa
    CarregaSerasa (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdGarantidoraSerasa/' + _garId)
        .then(response => {
          if (response.data.length > 0) {
            this.Serasa = response.data[0]
            this.Serasa.gseCustoPesExtra = String(this.Serasa.gseCustoPesExtra).replace('.', ',')
          } else {
            this.Serasa.gseId = 0
            this.Serasa.gseValorGarantiaMinimo = null
            this.Serasa.gseValorGarantiaMaximo = null
            this.Serasa.garId = _garId
          }
        })
    },
    prepararLimitesGarantia () {
      const parse = valor => {
        if (valor == null || valor === '') return null
        const t = String(valor).trim()
        if (!/^(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d{1,2})?$/.test(t) && !/^\d+\.\d{1,2}$/.test(t)) return NaN
        return Number(t.includes(',') || /\.\d{3}$/.test(t) ? t.replace(/\./g, '').replace(',', '.') : t)
      }
      const min = parse(this.Serasa.gseValorGarantiaMinimo)
      const max = parse(this.Serasa.gseValorGarantiaMaximo)
      if (Number.isNaN(min) || Number.isNaN(max) || (min != null && max != null && min > max)) {
        this.$mensagemAviso('Informe limites válidos em reais. O mínimo não pode superar o máximo.')
        return false
      }
      Object.assign(this.Serasa, { gseValorGarantiaMinimo: min, gseValorGarantiaMaximo: max })
      return true
    },
    SerasaAdd () {
      if (!this.prepararLimitesGarantia()) return
      if (this.Serasa.gseQtdeMensal === '') {
        this.$mensagemAviso('Campo Qtde Mensal Obrigatório.')
      } else if (this.Serasa.gseCustoPesExtra === '') {
        this.$mensagemAviso('Campo Custo Extra Obrigatório.')
      } else if (this.Serasa.gseRangeAprovacao === '') {
        this.$mensagemAviso('Campo Nivel de Aprovação Obrigatório.')
      } else {
        if (this.Serasa.gseCustoPesExtra !== '' && this.Serasa.gseCustoPesExtra !== null) {
          this.Serasa.gseCustoPesExtra = parseFloat(
            String(this.Serasa.gseCustoPesExtra).replace(',', '.')
          )
        } else {
          this.Serasa.gseCustoPesExtra = 0
        }

        if (this.Serasa.gseRangeAprovacao !== '' && this.Serasa.gseRangeAprovacao !== null) {
          this.Serasa.gseRangeAprovacao = parseInt(this.Serasa.gseRangeAprovacao)
        } else {
          this.Serasa.gseRangeAprovacao = 0
        }

        axios.post('/Telas/Garantidoras/AddGarantidoraSerasa', this.Serasa)
          .then(response => {
            if (response.data > 0) {
              this.Serasa.gseId = response.data
              this.$mensagemAvisoSucesso('Análise de Crédito Incluído')
              this.CarregaSerasa(this.Garantidora.garId)
            }
          })
      }
    },
    SerasaPut () {
      if (!this.prepararLimitesGarantia()) return
      if (this.Serasa.gseQtdeMensal === '') {
        this.$mensagemAviso('Campo Qtde Mensal Obrigatório.')
      } else if (this.Serasa.gseCustoPesExtra === '') {
        this.$mensagemAviso('Campo Custo Extra Obrigatório.')
      } else if (this.Serasa.gseRangeAprovacao === '') {
        this.$mensagemAviso('Campo Nivel de Aprovação Obrigatório.')
      } else {
        if (this.Serasa.gseCustoPesExtra !== '' && this.Serasa.gseCustoPesExtra !== null) {
          this.Serasa.gseCustoPesExtra = parseFloat(
            String(this.Serasa.gseCustoPesExtra).replace(',', '.')
          )
        } else {
          this.Serasa.gseCustoPesExtra = 0
        }
        // console.log('this.Serasa')
        // console.log(this.Serasa)

        if (this.Serasa.gseRangeAprovacao !== '' && this.Serasa.gseRangeAprovacao !== null) {
          this.Serasa.gseRangeAprovacao = parseInt(this.Serasa.gseRangeAprovacao)
        } else {
          this.Serasa.gseRangeAprovacao = 0
        }

        axios.put('/Telas/Garantidoras/UpdateGarantidoraSerasa', this.Serasa)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Análise de Crédito Alterada.')
              this.CarregaSerasa(this.Garantidora.garId)
            }
          })
      }
    },
    SerasaCancel () {
      /* this.Serasa.grtId =  0;
            this.Serasa.cdtId = 0;
            this.Serasa.gsePropriedade = '';
            this.Serasa.gseQtdeMensal = '';
            this.Serasa.gseCustoExstra = null;
            this.Serasa.gseQtdeGratisMensal = '';
            this.Serasa.gseRangeAprovacao = ''; */
      this.$router.go(0)
    },
    // serasa
    // procesos
    CarregaProcessos (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdGarantidoraProcessos/' + _garId)
        .then(response => {
          if (response.data.length > 0) {
            this.Processos = response.data[0]
            this.Processos.gprCustoPesExtra = String(this.Processos.gprCustoPesExtra).replace('.', ',')
          } else {
            this.Processos.garId = _garId
          }
        })
    },
    ProcessosAdd () {
      if (this.Processos.gprCustoPesExtra === '') {
        this.$mensagemAviso('Campo Custo Extra Obrigatório.')
      } else {
        if (this.Processos.gprCustoPesExtra !== '' && this.Processos.gprCustoPesExtra !== null) {
          this.Processos.gprCustoPesExtra = parseFloat(
            String(this.Processos.gprCustoPesExtra).replace(',', '.')
          )
        } else {
          this.Processos.gprCustoPesExtra = 0
        }

        if (this.Processos.gprQtdeMensal === '') {
          this.Processos.gprQtdeMensal = this.Serasa.gseQtdeMensal
        }

        axios.post('/Telas/Garantidoras/AddGarantidoraProcessos', this.Processos)
          .then(response => {
            if (response.data > 0) {
              this.Processos.gprId = response.data
              this.$mensagemAvisoSucesso('Análise Jurídica Incluída')
              this.CarregaProcessos(this.Garantidora.garId)
            }
          })
      }
    },
    ProcessosPut () {
      if (this.Processos.gprCustoPesExtra === '') {
        this.$mensagemAviso('Campo Custo Extra Obrigatório.')
      } else {
        if (this.Processos.gprCustoPesExtra !== '' && this.Processos.gprCustoPesExtra !== null) {
          this.Processos.gprCustoPesExtra = parseFloat(
            String(this.Processos.gprCustoPesExtra).replace(',', '.')
          )
        } else {
          this.Processos.gprCustoPesExtra = 0
        }

        if (this.Processos.gprQtdeMensal === '') {
          this.Processos.gprQtdeMensal = this.Serasa.gseQtdeMensal
        }

        axios.put('/Telas/Garantidoras/UpdateGarantidoraProcessos', this.Processos)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Análise Jurídica Alterada.')
              this.CarregaProcessos(this.Garantidora.garId)
            }
          })
      }
    },
    ProcessosCancel () {
      this.$router.go(0)
    },
    // processos
    // assinaturas
    CarregaAssinatura (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdGarantidoraAssinatura/' + _garId)
        .then(response => {
          if (response.data.length > 0) {
            this.Assinatura = response.data[0]
            this.Assinatura.gasCustoPesExtra = String(this.Assinatura.gasCustoPesExtra).replace('.', ',')
          } else {
            this.Assinatura.garId = _garId
          }
        })
    },
    AssinaturaAdd () {
      if (this.Assinatura.gasPropriedade === '') {
        this.$mensagemAviso('Campo CPF Obrigatório.')
      } else if (this.Assinatura.gasQtdeMensal === '') {
        this.$mensagemAviso('Campo Qtde Mensal Obrigatório.')
      } else if (this.Assinatura.gasCustoPesExtra === '') {
        this.$mensagemAviso('Campo Custo Extra Obrigatório.')
      } else if (this.Assinatura.gasOpcaoAutenticacao == 99 && (this.Assinatura.gasCodigoExigido == '' || this.Assinatura.gasCodigoExigido == null)) {
        this.$mensagemAviso('Necessário Cadastrar um codigo para uso dessa autenticação.')
      } else {
        if ((this.Assinatura.gasToken == '' || this.Assinatura.gasToken == null) && (this.Assinatura.gasIdRepositorio == '' || this.Assinatura.gasIdRepositorio == null) && (this.Assinatura.gasIdUserAsten == '' || this.Assinatura.gasIdUserAsten == null)) {
          const propriedade = String(this.Assinatura.gasPropriedade)
          const _senha = this.generatePassword()
          const _ConfAss = {
            Nome: this.Garantidora.garNomeEmpresa,
            Iniciais: this.initials(this.Garantidora.garNomeEmpresa),
            Email: this.Garantidora.garEmail,
            Senha: _senha,
            Cpf: String(this.Assinatura.gasPropriedade),
            ConfirmacaoSenha: _senha,
            AcessoAPI: 'S',
            Cargo: 'Empresa',
            Empresa: this.Garantidora.garRazaoSocial,
            QtdeEnvelopes: this.Assinatura.gasQtdeMensal
          }

          axios.post('/Telas/Garantidoras/CreateUserWithAllSteps', _ConfAss)
            .then(response => {
              // console.log('response')
              // console.log(response)
              const _result = response.data
              if (_result.code === 1) {
                // Se a resposta da API é OK, segue com a inserção
                this.Assinatura.gasToken = _result.userToken
                this.Assinatura.gasIdUserAsten = _result.userId
                this.Assinatura.gasIdRepositorio = _result.repositoryId
                this.Assinatura.gasPropriedade = String(this.Assinatura.gasPropriedade).replaceAll('.', '').replaceAll('-', '')

                if (this.Assinatura.gasCustoPesExtra !== '' && this.Assinatura.gasCustoPesExtra !== null) {
                  this.Assinatura.gasCustoPesExtra = parseFloat(
                    String(this.Assinatura.gasCustoPesExtra).replace(',', '.')
                  )
                } else {
                  this.Assinatura.gasCustoPesExtra = 0
                }

                if (this.Assinatura.gasOpcaoAutenticacao == 2 || this.Assinatura.gasOpcaoAutenticacao == 3) {
                  if (this.Assinatura.gasAnalisarFaceImagem == 'S' && (this.Assinatura.gasPercentualPrecisaoFace == '' || this.Assinatura.gasPercentualPrecisaoFace == null)) {
                    this.Assinatura.gasPercentualPrecisaoFace = 10
                  }
                } else {
                  this.Assinatura.gasAnalisarFaceImagem = 'N'
                  this.Assinatura.gasPercentualPrecisaoFace = 0
                }
                if (this.Assinatura.gasOpcaoAutenticacao == 99) {
                  this.Assinatura.gasExigirCodigo = 'S'
                } else {
                  this.Assinatura.gasExigirCodigo = 'N'
                  this.Assinatura.gasCodigoExigido = null
                }

                axios.post('/Telas/Garantidoras/AddGarantidoraAssinatura', this.Assinatura)
                  .then(response => {
                    //  console.log("_updateUser:"); // Verifica o status
                    //  console.log(response);
                    if (response.data > 0) {
                      this.Assinatura.gasId = response.data
                      this.EnviaEmailCadastroUsuarioAsten(_senha)
                      // console.log("this.Assinatura:"); // Verifica o status
                      // console.log(this.Assinatura);
                      this.$mensagemAvisoSucesso('Assinatura Incluído')
                    }
                  })
                  .catch(error => {
                    this.$mensagemErro('Erro ao incluir Assinatura na Garantidora: ' + error.message)
                  })
              } else {
                this.$mensagemErro('Erro ao incluir Assinatura na Garantidora: ' + _result.message)
              }
            })
        } else {
          this.Assinatura.gasPropriedade = String(this.Assinatura.gasPropriedade).replaceAll('.', '').replaceAll('-', '')

          if (this.Assinatura.gasCustoPesExtra !== '' && this.Assinatura.gasCustoPesExtra !== null) {
            this.Assinatura.gasCustoPesExtra = parseFloat(
              String(this.Assinatura.gasCustoPesExtra).replace(',', '.')
            )
          } else {
            this.Assinatura.gasCustoPesExtra = 0
          }

          if (this.Assinatura.gasOpcaoAutenticacao == 2 || this.Assinatura.gasOpcaoAutenticacao == 3) {
            if (this.Assinatura.gasAnalisarFaceImagem == 'S' && (this.Assinatura.gasPercentualPrecisaoFace == '' || this.Assinatura.gasPercentualPrecisaoFace == null)) {
              this.Assinatura.gasPercentualPrecisaoFace = 10
            }
          } else {
            this.Assinatura.gasAnalisarFaceImagem = 'N'
            this.Assinatura.gasPercentualPrecisaoFace = 0
          }
          if (this.Assinatura.gasOpcaoAutenticacao == 99) {
            this.Assinatura.gasExigirCodigo = 'S'
          } else {
            this.Assinatura.gasExigirCodigo = 'N'
            this.Assinatura.gasCodigoExigido = null
          }

          axios.post('/Telas/Garantidoras/AddGarantidoraAssinatura', this.Assinatura)
            .then(response => {
              //  console.log("_updateUser:"); // Verifica o status
              //  console.log(response);
              if (response.data > 0) {
                this.Assinatura.gasId = response.data
                // this.EnviaEmailCadastroUsuarioAsten(_senha);
                // console.log("this.Assinatura:"); // Verifica o status
                // console.log(this.Assinatura);
                this.$mensagemAvisoSucesso('Assinatura Incluído')
              }
            })
            .catch(error => {
              this.$mensagemErro('Erro ao incluir Assinatura na Garantidora: ' + error.message)
            })
        }
      }
    },
    AssinaturaPut () {
      if (this.Assinatura.gasPropriedade === '') {
        this.$mensagemAviso('Campo CPF Obrigatório.')
      } else if (this.Assinatura.gasQtdeMensal === '') {
        this.$mensagemAviso('Campo Qtde Mensal Obrigatório.')
      } else if (this.Assinatura.gasCustoExstra === '') {
        this.$mensagemAviso('Campo Custo Extra Obrigatório.')
      } else if (this.Assinatura.gasToken == '' || this.Assinatura.gasToken == null) {
        this.$mensagemAviso('Campo Token Obrigatório.')
      } else if (this.Assinatura.gasIdRepositorio == '' || this.Assinatura.gasIdRepositorio == null) {
        this.$mensagemAviso('Campo Id Repositório Obrigatório.')
      } else if (this.Assinatura.gasIdUserAsten == '' || this.Assinatura.gasIdUserAsten == null) {
        this.$mensagemAviso('Campo Id Usuário Asten Obrigatório.')
      } else if (this.Assinatura.gasOpcaoAutenticacao == 99 && (this.Assinatura.gasCodigoExigido == '' || this.Assinatura.gasCodigoExigido == null)) {
        this.$mensagemAviso('Necessário Cadastrar um codigo para uso dessa autenticação.')
      } else {
        if (this.Assinatura.gasCustoPesExtra !== '' && this.Assinatura.gasCustoPesExtra !== null) {
          this.Assinatura.gasCustoPesExtra = parseFloat(
            String(this.Assinatura.gasCustoPesExtra).replace(',', '.')
          )
        } else {
          this.Assinatura.gasCustoPesExtra = 0
        }
        this.Assinatura.gasPropriedade = String(this.Assinatura.gasPropriedade).replaceAll('.', '').replaceAll('-', '')

        if (this.Assinatura.gasOpcaoAutenticacao == 2 || this.Assinatura.gasOpcaoAutenticacao == 3) {
          if (this.Assinatura.gasAnalisarFaceImagem == 'S' && (this.Assinatura.gasPercentualPrecisaoFace == '' || this.Assinatura.gasPercentualPrecisaoFace == null)) {
            this.Assinatura.gasPercentualPrecisaoFace = 10
          }
        } else {
          this.Assinatura.gasAnalisarFaceImagem = 'N'
          this.Assinatura.gasPercentualPrecisaoFace = 0
        }
        if (this.Assinatura.gasOpcaoAutenticacao == 99) {
          this.Assinatura.gasExigirCodigo = 'S'
        } else {
          this.Assinatura.gasExigirCodigo = 'N'
          this.Assinatura.gasCodigoExigido = null
        }

        axios.put('/Telas/Garantidoras/UpdateGarantidoraAssinatura', this.Assinatura)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Assinatura Alterado.')
              this.CarregaAssinatura(this.Garantidora.garId)
            }
          })
      }
    },
    AssinaturaCancel () {
      /* this.Assinatura.grtId =  0;
            this.Assinatura.cdtId = 0;
            this.Assinatura.gasPropriedade = '';
            this.Assinatura.gasQtdeMensal = '';
            this.Assinatura.gasCustoExstra = null;
            this.Assinatura.gasQtdeGratisMensal = '';
            this.Assinatura.gasIdRepositorio = '';
            this.Assinatura.gasToken = ''; */
      this.$router.go(0)
    },
    initials (value) {
      if (!value) return ''
      const words = value.trim().split(/\s+/)
      return words
        .map(word => word.charAt(0).toUpperCase())
        .join('')
        .slice(0, 2)
    },
    generatePassword () {
      const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const lowercase = 'abcdefghijklmnopqrstuvwxyz'
      const numbers = '0123456789'
      const special = '!'

      // Garante que a senha terá pelo menos um caractere de cada categoria
      const password = [
        uppercase[Math.floor(Math.random() * uppercase.length)],
        lowercase[Math.floor(Math.random() * lowercase.length)],
        numbers[Math.floor(Math.random() * numbers.length)],
        special
      ]

      // Preenche o restante da senha com caracteres aleatórios
      const allCharacters = uppercase + lowercase + numbers + special
      for (let i = password.length; i < 8; i++) {
        password.push(allCharacters[Math.floor(Math.random() * allCharacters.length)])
      }

      // Embaralha os caracteres para garantir uma ordem aleatória
      return password.sort(() => Math.random() - 0.5).join('')
    },
    EnviaEmailCadastroUsuarioAsten (senha) {
      axios.get(`/Telas/Garantidoras/GetByIdMensagemPadrao/8?garId=${this.Garantidora.garId || 0}`)
        .then(async response => {
          this.templateEmail = response.data
          const _dadosEmail = {
            nomeDe: '[NomeSistema]',
            nomePara: this.Garantidora.garNomeEmpresa,
            assunto: 'Cadastro Usuário Assinaturas - Sistema [NomeSistema]',
            destinatario: this.$GarantePayAstenEmail,
            emailResposta: this.$GarantePayEmail,
            textoEmail: this.templateEmail.mpdTexto
              .replace('[NomeUsuario]', this.Garantidora.garNomeEmpresa)
              .replace('[LinkAcesso]', this.$GarantePayLinkAcessoAsten)
              .replace('[UsuarioLogin]', this.Garantidora.garEmail)
              .replace('[SenhaAcesso]', senha),
            listAnexos: null // {nomeAnexo: '', anexo: '', tipoAnexo: ''}
          }
          const emailPersonalizado = await personalizarEmailGarantidora(_dadosEmail, this.Garantidora.garId || this.User.garid || 0, this.$imgURL, this.$GarantePayLinkAcesso, this.$GarantePayEmail).catch(error => {
            this.$mensagemErro(error.message || 'Não foi possível carregar a identificação da garantidora para o e-mail.')
            return null
          })
          if (!emailPersonalizado) return
          axios.post('/Telas/Garantidoras/Enviamail', emailPersonalizado)
        })
    },
    // assinaturas
    // pagamentos
    CarregaPagamentos (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdGarantidoraPagamento/' + _garId)
        .then(response => {
          if (response.data.length > 0) {
            this.Pagamento = response.data[0]
          } else {
            this.Pagamento.garId = _garId
          }
        })
    },
    PagamentoAdd () {
      if (this.Pagamento.gpgEmailAviso === '') {
        this.$mensagemAviso('Campo E-mail Aviso Obrigatório.')
      } else {
        axios.post('/Telas/Garantidoras/AddGarantidoraPagamento', this.Pagamento)
          .then(response => {
            if (response.data > 0) {
              this.Pagamento.gpgId = response.data
              this.$mensagemAvisoSucesso('Pagamento Incluído')
            }
          })
      }
    },
    PagamentoPut () {
      if (this.Pagamento.gpgEmailAviso === '') {
        this.$mensagemAviso('Campo E-mail Aviso Obrigatório.')
      } else {
        axios.put('/Telas/Garantidoras/UpdateGarantidoraPagamento', this.Pagamento)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Pagamento Alterado.')
            }
          })
      }
    },
    PagamentoCancel () {
      this.$router.go(0)
    },
    // pagamentos
    // contratos
    CarregaContratos (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdGarantidoraContrato/' + _garId)
        .then(response => {
          this.ListaMeusContratos = response.data
        })
    },
    async ContratoAdd () {
      if (this.Contrato.cmcId === '') {
        this.$mensagemAviso('Campo Modelo Contrato Obrigatório.')
      } else {
        // chamar a montagem do pdf e gravar
        // dadosContratante = garantidora e dadosContratada = Garantepay
        const _dadosContrato = {
          TipoPessoa: 1,
          CmcId: this.Contrato.cmcId,
          IdContratante: this.Garantidora.garId,
          IdContratada: 0,
          dadosContratacao: null
        }

        const _fileName = await this.Uploadpdf(_dadosContrato)

        this.Contrato.garId = this.Garantidora.garId
        this.Contrato.gctUrlContrato = _fileName
        axios.post('/Telas/Garantidoras/AddGarantidoraContrato', this.Contrato)
          .then(response => {
            if (response.data > 0) {
              this.Contrato.gctId = response.data
              this.CarregaContratos(this.Contrato.garId)
              this.$mensagemAvisoSucesso('Contrato Incluído')
            }
          })
      }
    },
    ContratosPut () {
      if (this.Contrato.cmcId === '') {
        this.$mensagemAviso('Campo Modelo Contrato Obrigatório.')
      } else {
        axios.put('/Telas/Garantidoras/UpdateGarantidoraContrato', this.Contrato)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Contrato Alterado.')
            }
          })
      }
    },
    ExcluirContrato (item) {
      this.$mensagemConfirma('Tem certeza que deseja excluir?')
        .then((result) => {
          if (result.isConfirmed) {
            // console.log('item')
            //  console.log(item)
            // Lógica para excluir o item
            if (item.gctIdEnvelope != '' && item.gctIdEnvelope != null) {
              const _dadosRemove = {
                token: null,
                idEnvelope: item.gctIdEnvelope,
                tpeId: 1,
                reason: 'Arquivo incorreto.'
              }

              axios.post('/Telas/Garantidoras/RemoveEnvelope', _dadosRemove)
                .then(response => {
                  const _result = response.data
                  console.log('_result')
                  console.log(_result)
                  if (_result.code === 1) {
                    this.$mensagemAvisoSucesso('Registro Excluido.')
                    this.CarregaContratos(item.garId)
                  } else {
                    this.$mensagemErro(`Erro ao excluir contrato/assinatura (Status ${_result.code}): ${_result.message}`)
                  }
                })
            } else {
              const param1 = item.gctId
              axios.delete(`/Telas/Garantidoras/DeleteGarantidoraContrato/${param1}`)
                .then(response => {
                  this.$mensagemAvisoSucesso('Registro Excluido.')
                  this.CarregaContratos(item.garId)
                })
            }
          }
        })
    },
    ContratosCancel () {
      this.$router.go(0)
    },
    VisualizarContrato (_contrato) {
      if (_contrato && _contrato.gctUrlContrato) {
        // Abre o PDF em uma nova aba
        this.openInNewTab(_contrato.gctUrlContrato)
      } else {
        console.error('URL do contrato não está disponível.')
      }
    },
    async Uploadpdf (dadosContrato) {
      const uploadResult = await axios.post('/Telas/Garantidoras/uploadContratoPdf', dadosContrato)
      return uploadResult.data.nameFile
    },
    async EnviarAssinatura (item) {
      debugger
      if (this.Endereco.gaeCep == '') {
        this.$mensagemAviso('Campo CEP Obrigatório.')
      } else if (this.Endereco.gaeEndereco === '') {
        this.$mensagemAviso('Campo Endereço Obrigatório.')
      } else if (this.Endereco.gaeNumero === '') {
        this.$mensagemAviso('Campo Número Obrigatório.')
      } else if (this.Endereco.gaeEstado === '') {
        this.$mensagemAviso('Campo Estado Obrigatório.')
      } else if (this.Endereco.gaeCidade === '') {
        this.$mensagemAviso('Campo Cidade Obrigatório.')
      } else if (this.Endereco.gaeBairro === '') {
        this.$mensagemAviso('Campo Bairro Obrigatório.')
      } else {
        const DadosEnvelopeRequest = {
          idContrato: item.gctId,
          tpeId: 1,
          token: null,
          envelopeDescricao: this.ListaContratos.filter(x => x.cmcId == item.cmcId)[0].cmcNome,
          repositorioId: 18,
          listaDocumentos: [{ UrlArquivo: item.gctUrlContrato }],
          listaSignatariosEnvelopes: [{
            Ordem: 1,
            EmailSignatario: this.Garantidora.garEmail,
            NomeSignatario: this.Garantidora.garNomeEmpresa,
            TipoAssinatura: 1
          },
          {
            Ordem: 2,
            EmailSignatario: this.$GarantePayAstenEmail,
            NomeSignatario: this.$GarantePayNome,
            TipoAssinatura: 1
          }]
        }
        axios.post('/Telas/Garantidoras/CreateEnvelopeWithAllSteps', DadosEnvelopeRequest)
          .then(response => {
            const _result = response.data
            if (_result.code === 1) {
              this.CarregaContratos(this.Garantidora.garId)
              this.$mensagemAvisoSucesso('Processando envio da Assinatura')
            } else {
              this.$mensagemErro(`Erro ao enviar assinatura (Status ${_result.code}): ${_result.message}`)
            }
          })
          .catch(error => {
            if (error.response) {
              // Erros retornados pelo servidor
              this.$mensagemErro(
                    `Erro ao enviar assinatura (Status ${error.response.status}): ${error.response.data}`
              )
            } else if (error.request) {
              // O servidor não respondeu
              this.$mensagemErro('Erro: Nenhuma resposta do servidor.', error.request)
            } else {
              // Erro ao configurar a requisição
              this.$mensagemErro('Erro ao configurar requisição:', error.message)
            }
          })
      }
    },
    // contratos
    // Nota Fiscal
    CarregaNota (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdNota/' + _garId)
        .then(response => {
          if (response.data.length > 0) {
            this.Nota = response.data[0]
          } else {
            this.Nota.garId = _garId
          }
        })
    },
    NotaAdd () {
      if (this.Nota.ggnEnviarEmail === '' || this.Nota.ggnEnviarEmail === null) {
        this.$mensagemAviso('Campo enviar E-mail Obrigatório.')
      } else if (this.Nota.ggnIncentivadorCultural === '' || this.Nota.ggnIncentivadorCultural === null) {
        this.$mensagemAviso('Campo Incentivador Cultural Obrigatório.')
      } else if (this.Nota.ggnIncentivoFiscal === '' || this.Nota.ggnIncentivoFiscal === null) {
        this.$mensagemAviso('Campo Incentivo Fiscal Obrigatório.')
      } else if (this.Nota.ggnInscricaoEstadual === '' || this.Nota.ggnInscricaoEstadual === null) {
        this.$mensagemAviso('Campo Inscrição Estadual Obrigatório.')
      } else if (this.Nota.ggnInscricaoMunicipal === '' || this.Nota.ggnInscricaoMunicipal === null) {
        this.$mensagemAviso('Campo Inscrição Municipal Obrigatório.')
      } else if (this.Nota.ggnRegimeTributario === '' || this.Nota.ggnRegimeTributario === null) {
        this.$mensagemAviso('Campo Regime Tributário Obrigatório.')
      } else if (this.Nota.ggnRegimeTributarioEspecial === '' || this.Nota.ggnRegimeTributarioEspecial === null) {
        this.$mensagemAviso('Campo Regime Tributação Especial Obrigatório.')
      } else if (this.Nota.ggnSimplesNacional === '' || this.Nota.ggnSimplesNacional === null) {
        this.$mensagemAviso('Campo Simples Nacional Obrigatório.')
      } else if (this.Nota.ggnToken === '' || this.Nota.ggnToken === null) {
        this.$mensagemAviso('Campo Token Obrigatório.')
      } else {
        axios.post('/Telas/Garantidoras/AddNota', this.Nota)
          .then(response => {
            if (response.data > 0) {
              this.Nota.ggnId = response.data
              this.$mensagemAvisoSucesso('Dados Nota Incluído')
            }
          })
      }
    },
    NotaPut () {
      if (this.Nota.ggnEnviarEmail === '' || this.Nota.ggnEnviarEmail === null) {
        this.$mensagemAviso('Campo enviar E-mail Obrigatório.')
      } else if (this.Nota.ggnIncentivadorCultural === '' || this.Nota.ggnIncentivadorCultural === null) {
        this.$mensagemAviso('Campo Incentivador Cultural Obrigatório.')
      } else if (this.Nota.ggnIncentivoFiscal === '' || this.Nota.ggnIncentivoFiscal === null) {
        this.$mensagemAviso('Campo Incentivo Fiscal Obrigatório.')
      } else if (this.Nota.ggnInscricaoEstadual === '' || this.Nota.ggnInscricaoEstadual === null) {
        this.$mensagemAviso('Campo Inscrição Estadual Obrigatório.')
      } else if (this.Nota.ggnInscricaoMunicipal === '' || this.Nota.ggnInscricaoMunicipal === null) {
        this.$mensagemAviso('Campo Inscrição Municipal Obrigatório.')
      } else if (this.Nota.ggnRegimeTributario === '' || this.Nota.ggnRegimeTributario === null) {
        this.$mensagemAviso('Campo Regime Tributário Obrigatório.')
      } else if (this.Nota.ggnRegimeTributarioEspecial === '' || this.Nota.ggnRegimeTributarioEspecial === null) {
        this.$mensagemAviso('Campo Regime Tributação Especial Obrigatório.')
      } else if (this.Nota.ggnSimplesNacional === '' || this.Nota.ggnSimplesNacional === null) {
        this.$mensagemAviso('Campo Simples Nacional Obrigatório.')
      } else if (this.Nota.ggnToken === '' || this.Nota.ggnToken === null) {
        this.$mensagemAviso('Campo Token Obrigatório.')
      } else {
        axios.put('/Telas/Garantidoras/UpdateNota', this.Nota)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Dados Nota Alterado.')
            }
          })
      }
    },
    NotaCancel () {
      this.$router.go(0)
    },
    // Nota Fiscal
    // Nota Fiscal Serviços
    CarregaNotaServico (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdNotaServico/' + _garId)
        .then(response => {
          if (response.data.length > 0) {
            this.ListGarantidoraNotaServico = response.data
          }
        })
    },
    async AddNotaServicos () {
      if (this.NotaServico.proId == null || this.NotaServico.proId === '') {
        this.$mensagemAviso('Código do serviço obrigatório.')
      } else if (this.ListGarantidoraNotaServico.filter(x => x.proId == this.NotaServico.proId).length > 0) {
        this.$mensagemAviso('Código do serviço já existe.')
      } else if (this.NotaServico.ggsCodServicoFiscal == null || this.NotaServico.ggsCodServicoFiscal === '') {
        this.$mensagemAviso('Serviço Fiscal obrigatório.')
      } else if (this.NotaServico.ggsCodTributacao == null || this.NotaServico.ggsCodTributacao === '') {
        this.$mensagemAviso('Tributação obrigatório.')
      } else if (this.NotaServico.ggsCnae == null || this.NotaServico.ggsCnae === '') {
        this.$mensagemAviso('Cnae obrigatório.')
      } else if (this.NotaServico.ggsIssTipoTributacao == null || this.NotaServico.ggsIssTipoTributacao === '') {
        this.$mensagemAviso('Iss Tipo Tributação obrigatório.')
      } else if (this.NotaServico.ggsIssExigibilidade == null || this.NotaServico.ggsIssExigibilidade === '') {
        this.$mensagemAviso('Iss Exigibilidade obrigatório.')
      } else if (this.NotaServico.ggsIssRetido == null || this.NotaServico.ggsIssRetido === '') {
        this.$mensagemAviso('Iss Retido obrigatório.')
      } else if (this.NotaServico.ggsAliquota == null || this.NotaServico.ggsAliquota === '') {
        this.$mensagemAviso('Aliquota obrigatório.')
      } else {
        // Continuação do processamento
        this.NotaServico.garId = this.Garantidora.garId
        this.NotaServico.proId = parseInt(this.NotaServico.proId, 10)
        this.NotaServico.ggsAliquota = this.NotaServico.ggsAliquota != null ? parseFloat(String(this.NotaServico.ggsAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsPisAliquota = this.NotaServico.ggsPisAliquota != null ? parseFloat(String(this.NotaServico.ggsPisAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsCofinsAliquota = this.NotaServico.ggsCofinsAliquota != null ? parseFloat(String(this.NotaServico.ggsCofinsAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsCsllAliquota = this.NotaServico.ggsCsllAliquota != null ? parseFloat(String(this.NotaServico.ggsCsllAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsInssAliquota = this.NotaServico.ggsInssAliquota != null ? parseFloat(String(this.NotaServico.ggsInssAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsIrrfAliquota = this.NotaServico.ggsIrrfAliquota != null ? parseFloat(String(this.NotaServico.ggsIrrfAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsOutrasRetencoes = this.NotaServico.ggsOutrasRetencoes != null ? parseFloat(String(this.NotaServico.ggsOutrasRetencoes).replaceAll(',', '.')) : null
        this.NotaServico.ggsCppAliquota = this.NotaServico.ggsCppAliquota != null ? parseFloat(String(this.NotaServico.ggsCppAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsTributacaoTotalFederal = String(this.NotaServico.ggsTributacaoTotalFederal).replaceAll(',', '.')
        this.NotaServico.ggsTributacaoTotalEstadual = String(this.NotaServico.ggsTributacaoTotalEstadual).replaceAll(',', '.')
        this.NotaServico.ggsTributacaoTotalMunicipal = String(this.NotaServico.ggsTributacaoTotalMunicipal).replaceAll(',', '.')
        this.NotaServico.ggsCnae = this.NotaServico.ggsCnae.replaceAll('-', '').replaceAll('.', '')

        await axios.post('/Telas/Garantidoras/AddNotaServico', this.NotaServico)
          .then(response => {
            if (response.data > 0) {
              this.NotaServico.ggsId = response.data
              this.$mensagemAvisoSucesso('Serviço Incluído')
              this.NotaServico.ggsId = 0
              this.NotaServico.proId = null
              this.NotaServico.ggsCodServicoFiscal = ''
              this.NotaServico.ggsCodTributacao = ''
              this.NotaServico.ggsCnae = ''
              this.NotaServico.ggsIssTipoTributacao = null
              this.NotaServico.ggsIssExigibilidade = null
              this.NotaServico.ggsIssRetido = null
              this.NotaServico.ggsAliquota = ''
              this.NotaServico.ggsPisAliquota = null
              this.NotaServico.ggsCofinsAliquota = null
              this.NotaServico.ggsCsllAliquota = null
              this.NotaServico.ggsInssAliquota = null
              this.NotaServico.ggsIrrfAliquota = null
              this.NotaServico.ggsOutrasRetencoes = null
              this.NotaServico.ggsCppAliquota = null
              this.NotaServico.ggsTributacaoTotalFederal = null
              this.NotaServico.ggsTributacaoTotalEstadual = null
              this.NotaServico.ggsTributacaoTotalMunicipal = null

              axios.get('/Telas/Garantidoras/GetAllNotaServico')
                .then(response => {
                  this.ListGarantidoraNotaServico = response.data
                })
            }
          })
      }
    },
    EditarServico (value) {
      this.NotaServico = {
        ...value,
        ggsAliquota: value.ggsAliquota != null
          ? value.ggsAliquota.toString().replaceAll('.', ',')
          : ''
      }
    },
    nomeProdutoNota (proId) {
      const produto = this.ListProdutos.find(x => Number(x.proId) === Number(proId))
      return produto?.proNomeProduto || 'Produto não localizado'
    },
    PutNotaServicos () {
      if (this.NotaServico.proId == null || this.NotaServico.proId === '') {
        this.$mensagemAviso('Código do serviço obrigatório.')
      } else if (this.ListGarantidoraNotaServico.filter(x => x.proId == this.NotaServico.proId && x.ggsId != this.NotaServico.ggsId).length > 0) {
        this.$mensagemAviso('Código do serviço já existe.')
      } else if (this.NotaServico.ggsCodServicoFiscal == null || this.NotaServico.ggsCodServicoFiscal === '') {
        this.$mensagemAviso('Serviço Fiscal obrigatório.')
      } else if (this.NotaServico.ggsCodTributacao == null || this.NotaServico.ggsCodTributacao === '') {
        this.$mensagemAviso('Tributação obrigatório.')
      } else if (this.NotaServico.ggsCnae == null || this.NotaServico.ggsCnae === '') {
        this.$mensagemAviso('Cnae obrigatório.')
      } else if (this.NotaServico.ggsIssTipoTributacao == null || this.NotaServico.ggsIssTipoTributacao === '') {
        this.$mensagemAviso('Iss Tipo Tributação obrigatório.')
      } else if (this.NotaServico.ggsIssExigibilidade == null || this.NotaServico.ggsIssExigibilidade === '') {
        this.$mensagemAviso('Iss Exigibilidade obrigatório.')
      } else if (this.NotaServico.ggsIssRetido == null || this.NotaServico.ggsIssRetido === '') {
        this.$mensagemAviso('Iss Retido obrigatório.')
      } else if (this.NotaServico.ggsAliquota == null || this.NotaServico.ggsAliquota === '') {
        this.$mensagemAviso('Aliquota obrigatório.')
      } else {
        // Continuação do processamento
        this.NotaServico.garId = this.Garantidora.garId
        this.NotaServico.proId = parseInt(this.NotaServico.proId, 10)
        this.NotaServico.ggsAliquota = this.NotaServico.ggsAliquota != null ? parseFloat(String(this.NotaServico.ggsAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsPisAliquota = this.NotaServico.ggsPisAliquota != null ? parseFloat(String(this.NotaServico.ggsPisAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsCofinsAliquota = this.NotaServico.ggsCofinsAliquota != null ? parseFloat(String(this.NotaServico.ggsCofinsAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsCsllAliquota = this.NotaServico.ggsCsllAliquota != null ? parseFloat(String(this.NotaServico.ggsCsllAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsInssAliquota = this.NotaServico.ggsInssAliquota != null ? parseFloat(String(this.NotaServico.ggsInssAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsIrrfAliquota = this.NotaServico.ggsIrrfAliquota != null ? parseFloat(String(this.NotaServico.ggsIrrfAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsOutrasRetencoes = this.NotaServico.ggsOutrasRetencoes != null ? parseFloat(String(this.NotaServico.ggsOutrasRetencoes).replaceAll(',', '.')) : null
        this.NotaServico.ggsCppAliquota = this.NotaServico.ggsCppAliquota != null ? parseFloat(String(this.NotaServico.ggsCppAliquota).replaceAll(',', '.')) : null
        this.NotaServico.ggsTributacaoTotalFederal = String(this.NotaServico.ggsTributacaoTotalFederal).replaceAll(',', '.')
        this.NotaServico.ggsTributacaoTotalEstadual = String(this.NotaServico.ggsTributacaoTotalEstadual).replaceAll(',', '.')
        this.NotaServico.ggsTributacaoTotalMunicipal = String(this.NotaServico.ggsTributacaoTotalMunicipal).replaceAll(',', '.')
        this.NotaServico.ggsCnae = this.NotaServico.ggsCnae.replaceAll('-', '').replaceAll('.', '')

        axios.put('/Telas/Garantidoras/UpdateNotaServico', this.NotaServico)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Registro Alterado.')
              this.NotaServico.ggsId = 0
              this.NotaServico.proId = null
              this.NotaServico.ggsCodServicoFiscal = ''
              this.NotaServico.ggsCodTributacao = ''
              this.NotaServico.ggsCnae = ''
              this.NotaServico.ggsIssTipoTributacao = null
              this.NotaServico.ggsIssExigibilidade = null
              this.NotaServico.ggsIssRetido = null
              this.NotaServico.ggsAliquota = ''
              this.NotaServico.ggsPisAliquota = null
              this.NotaServico.ggsCofinsAliquota = null
              this.NotaServico.ggsCsllAliquota = null
              this.NotaServico.ggsInssAliquota = null
              this.NotaServico.ggsIrrfAliquota = null
              this.NotaServico.ggsOutrasRetencoes = null
              this.NotaServico.ggsCppAliquota = null
              this.NotaServico.ggsTributacaoTotalFederal = null
              this.NotaServico.ggsTributacaoTotalEstadual = null
              this.NotaServico.ggsTributacaoTotalMunicipal = null

              axios.get('/Telas/Garantidoras/GetAllNotaServico')
                .then(response => {
                  this.ListGarantidoraNotaServico = response.data
                })
            }
          })
      }
    },
    DeleteServico (item) {
      this.$mensagemConfirma('Tem certeza que deseja excluir?')
        .then((result) => {
          if (result.isConfirmed) {
            // Lógica para excluir o item
            const param1 = item.ggsId
            axios.delete(`/Telas/Garantidoras/DeleteNotaServico/${param1}`)
              .then(response => {
                if (response.status == 200) {
                  this.$mensagemAvisoSucesso('Registro Excluido.')
                  this.NotaServico.ggsId = 0
                  this.NotaServico.proId = null
                  this.NotaServico.ggsCodServicoFiscal = ''
                  this.NotaServico.ggsCodTributacao = ''
                  this.NotaServico.ggsCnae = ''
                  this.NotaServico.ggsIssTipoTributacao = null
                  this.NotaServico.ggsIssExigibilidade = null
                  this.NotaServico.ggsIssRetido = null
                  this.NotaServico.ggsAliquota = ''
                  this.NotaServico.ggsPisAliquota = null
                  this.NotaServico.ggsCofinsAliquota = null
                  this.NotaServico.ggsCsllAliquota = null
                  this.NotaServico.ggsInssAliquota = null
                  this.NotaServico.ggsIrrfAliquota = null
                  this.NotaServico.ggsOutrasRetencoes = null
                  this.NotaServico.ggsCppAliquota = null
                  this.NotaServico.ggsTributacaoTotalFederal = null
                  this.NotaServico.ggsTributacaoTotalEstadual = null
                  this.NotaServico.ggsTributacaoTotalMunicipal = null

                  axios.get('/Telas/Garantidoras/GetAllNotaServico')
                    .then(response => {
                      this.ListGarantidoraNotaServico = response.data
                    })
                }
              })
          }
        })
    },
    EditNotaServicosCancel () {
      this.NotaServico.ggsId = 0
      this.NotaServico.proId = null
      this.NotaServico.ggsCodServicoFiscal = ''
      this.NotaServico.ggsCodTributacao = ''
      this.NotaServico.ggsCnae = ''
      this.NotaServico.ggsIssTipoTributacao = null
      this.NotaServico.ggsIssExigibilidade = null
      this.NotaServico.ggsIssRetido = null
      this.NotaServico.ggsAliquota = ''
      this.NotaServico.ggsPisAliquota = null
      this.NotaServico.ggsCofinsAliquota = null
      this.NotaServico.ggsCsllAliquota = null
      this.NotaServico.ggsInssAliquota = null
      this.NotaServico.ggsIrrfAliquota = null
      this.NotaServico.ggsOutrasRetencoes = null
      this.NotaServico.ggsCppAliquota = null
      this.NotaServico.ggsTributacaoTotalFederal = null
      this.NotaServico.ggsTributacaoTotalEstadual = null
      this.NotaServico.ggsTributacaoTotalMunicipal = null

      axios.get('/Telas/Garantidoras/GetAllNotaServico')
        .then(response => {
          this.ListGarantidoraNotaServico = response.data
        })
    },
    // Nota Fiscal Serviços
    // Faturamento
    async CarregaFaturas(_garId){
            if (Number(this.User.garid) === 0 && this.ModoFinanceiro.enviarAoFinanceiro) {
                this.CarregaSetupFinanceiro(_garId);
                this.CarregaMetodosMensalidade();
            }
            const response = await axios.get(`/Telas/Garantidoras/GetAllByGarIdCobrancaGarantePay/` + _garId);
            const faturas = Array.isArray(response.data) ? response.data : [];
            this.ListaFaturas = faturas
                .filter(x => x.pbgCodigoServicoGarantepay == 1 || x.pbgCodigoServicoGarantepay == 4)
                .sort((a, b) => {
                    const porServico = Number(a.pbgCodigoServicoGarantepay || 0)
                        - Number(b.pbgCodigoServicoGarantepay || 0);
                    if (porServico !== 0) return porServico;

                    const dataA = a.pbgDataVencimento ? new Date(a.pbgDataVencimento).getTime() : 0;
                    const dataB = b.pbgDataVencimento ? new Date(b.pbgDataVencimento).getTime() : 0;
                    if (dataA !== dataB) return dataA - dataB;

                    return Number(a.pbgParcela || 0) - Number(b.pbgParcela || 0);
                });
        },
    async FaturasLocaisAdd () {
      if (!this.ModoFinanceiroCarregado || this.ModoFinanceiro.enviarAoFinanceiro || !this.ModoFinanceiro.gravarCobrancasLocais || this.FaturasLocaisEnviando) return
      this.FaturasLocaisEnviando = true
      try {
      if (this.GarantidoraPlanos.gplValorAdesao === '' || this.GarantidoraPlanos.gplValorAdesao === null) {
        this.$mensagemAviso('Valor Adesão Obrigatório.')
      } else if (this.ParcelamentoSetup === '' || this.ParcelamentoSetup === 0) {
        this.$mensagemAviso('Parcelamento mínimo 1')
      } else if (this.MesSetup === '' || this.MesSetup === 0) {
        this.$mensagemAviso('Mês Obrigatório.')
      } else {
        const qtdParcelas = this.ParcelamentoSetup
        const mesInicial = this.MesSetup // 1–12
        const diaVencimento = this.GarantidoraPlanos.gplVencimento
        const anoAtual = moment().year()
        const valorParcela = this.GarantidoraPlanos.gplValorAdesao / qtdParcelas

        // data da primeira parcela
        const baseMoment = moment({
          year: anoAtual,
          month: mesInicial - 1,
          date: diaVencimento
        })

        // armazena todas as Promises de insert
        const requests = []
        for (let i = 0; i < qtdParcelas; i++) {
          const dataVenc = baseMoment.clone().add(i, 'months').format('YYYY-MM-DD')
          const fatura = {
            GrtId: 0,
            CdtId: 0,
            IdiId: 0,
            GarId: this.Garantidora.garId,
            PbgCodigoServicoGarantepay: 1,
            PbgDescricaoServico: 'Licenciamento de uso de programa de computação (Setup)',
            PbgRemuneracaoNegocio: 100,
            PbgTipoPgto: '',
            PbgFormaPgto: '',
            PbgValorBase: parseFloat(this.GarantidoraPlanos.gplValorAdesao),
            PbgValorGarantepay: valorParcela,
            PbgParcela: i + 1,
            PbgDataVencimento: dataVenc,
            PbgDataPagamento: null
          }
          // empilha a Promise, mas não espera aqui ainda
          requests.push(
            axios.post('/Telas/Garantidoras/AddControleCobrancaGarantePay', fatura)
          )
        }

        try {
          // aguarda todas as inserções
          await Promise.all(requests)
          // só agora recarrega a lista
          await this.CarregaFaturas(this.Garantidora.garId)
          this.$mensagemAvisoSucesso('Faturas geradas com sucesso.')
        } catch (err) {
          console.error('Erro ao gravar faturas:', err)
          await this.CarregaFaturas(this.Garantidora.garId)
          this.$mensagemErro?.(err)
        }
      }
    } finally { this.FaturasLocaisEnviando = false }
      },
    async FaturasMensaisLocaisAdd () {
      if (!this.ModoFinanceiroCarregado || this.ModoFinanceiro.enviarAoFinanceiro || !this.ModoFinanceiro.gravarCobrancasLocais || this.FaturasLocaisEnviando) return
      this.FaturasLocaisEnviando = true
      try {
      if (this.GarantidoraPlanos.gplValor === '' || this.GarantidoraPlanos.gplValor === null) {
        this.$mensagemAviso('Valor Adesão Obrigatório.')
      } else if (this.ParcelamentoMensalidade === '' || this.ParcelamentoMensalidade === 0) {
        this.$mensagemAviso('Parcelamento mínimo 1')
      } else if (this.MesMensalidade === '' || this.MesMensalidade === 0) {
        this.$mensagemAviso('Mês Obrigatório.')
      } else {
        const qtdParcelas = this.ParcelamentoMensalidade
        const mesInicial = this.MesMensalidade // 1–12
        const diaVencimento = this.GarantidoraPlanos.gplVencimento
        const anoAtual = moment().year()
        const valorParcela = this.GarantidoraPlanos.gplValor

        // data da primeira parcela
        const baseMoment = moment({
          year: anoAtual,
          month: mesInicial - 1,
          date: diaVencimento
        })

        // armazena todas as Promises de insert
        const requests = []
        for (let i = 0; i < qtdParcelas; i++) {
          const dataVenc = baseMoment.clone().add(i, 'months').format('YYYY-MM-DD')
          const fatura = {
            GrtId: 0,
            CdtId: 0,
            IdiId: 0,
            GarId: this.Garantidora.garId,
            PbgCodigoServicoGarantepay: 4,
            PbgDescricaoServico: 'Licenciamento de uso de programa de computação (Mensalidade)',
            PbgRemuneracaoNegocio: 100,
            PbgTipoPgto: '',
            PbgFormaPgto: '',
            PbgValorBase: parseFloat(valorParcela),
            PbgValorGarantepay: valorParcela != null ? parseFloat(valorParcela) : 0,
            PbgParcela: i + 1,
            PbgDataVencimento: dataVenc,
            PbgDataPagamento: null
          }
          // empilha a Promise, mas não espera aqui ainda
          requests.push(
            axios.post('/Telas/Garantidoras/AddControleCobrancaGarantePay', fatura)
          )
        }

        try {
          // aguarda todas as inserções
          await Promise.all(requests)
          // só agora recarrega a lista
          await this.CarregaFaturas(this.Garantidora.garId)
          this.$mensagemAvisoSucesso('Faturas geradas com sucesso.')
        } catch (err) {
          console.error('Erro ao gravar faturas:', err)
          await this.CarregaFaturas(this.Garantidora.garId)
          this.$mensagemErro?.(err)
        }
      }
    } finally { this.FaturasLocaisEnviando = false }
      },

    async FaturasAdd() {
            const avisar = mensagem => this.$mensagemErro(mensagem, {
                confirmButtonText: 'OK', showConfirmButton: true, timer: undefined,
                allowOutsideClick: false, allowEscapeKey: false
            });
            if (this.SetupBloqueado) return;
            const synchronizeLegacy = Boolean(this.SetupFinanceiro?.hasLegacyInstallments);
            if (!this.GarantidoraPlanos.gplId) return avisar('Salve o plano antes de gerar o Setup.');
            if (!synchronizeLegacy && (!Number.isInteger(this.ParcelamentoSetup) || this.ParcelamentoSetup < 1 || this.ParcelamentoSetup > 1200)) {
                return avisar('Informe uma quantidade inteira de parcelas entre 1 e 1200.');
            }
            if (!synchronizeLegacy && !moment(this.DataPrimeiroVencimentoSetup, 'YYYY-MM-DD', true).isValid()) {
                return avisar('Informe uma data válida para o primeiro vencimento.');
            }
            const policy = this.SetupCollectionPolicy;
            if (!Array.isArray(policy.allowedPaymentMethodCodes) || !policy.allowedPaymentMethodCodes.length) return avisar('Selecione ao menos um método de pagamento para o Setup.');
            if (![policy.penaltyPercentage, policy.dailyInterestPercentage].every(x => typeof x === 'number' && Number.isFinite(x) && x >= 0 && x <= 100 && Math.abs(x * 1000000 - Math.round(x * 1000000)) < 0.0000001)) {
                return avisar('Multa e juros devem estar entre 0 e 100%, com até seis casas decimais.');
            }
            const garId = this.Garantidora.garId;
            this.SetupEnviando = true;
            try {
                const response = await axios.post('/Telas/Garantidoras/SetupFinanceiro', {
                    garId,
                    gplId: this.GarantidoraPlanos.gplId,
                    synchronizeLegacy,
                    installmentCount: synchronizeLegacy ? 0 : this.ParcelamentoSetup,
                    firstDueDate: synchronizeLegacy ? null : this.DataPrimeiroVencimentoSetup,
                    collectionPolicy: { penaltyPercentage: policy.penaltyPercentage, dailyInterestPercentage: policy.dailyInterestPercentage, chargeTypeCode: 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: [...policy.allowedPaymentMethodCodes] }
                }, { showError: false });
                if (Number(this.Garantidora.garId) === Number(garId)) {
                    this.SetupFinanceiro = response.data;
                    this.ParcelamentoSetup = response.data.installmentCount || 0;
                    this.DataPrimeiroVencimentoSetup = response.data.firstDueDate
                        ? moment(response.data.firstDueDate).format('YYYY-MM-DD') : '';
                    this.$mensagemAvisoSucesso(response.data.status === 'PROCESSED'
                        ? 'Setup registrado no Financeiro. A emissão dos links segue a política de cobrança.' : 'Setup registrado para envio ao Financeiro.');
                }
            } catch (err) {
                if (Number(this.Garantidora.garId) === Number(garId)) {
                    await avisar(err.response?.data?.message || err.response?.data?.Message || 'Não foi possível confirmar o registro do Setup. Atualize a situação antes de tentar novamente.');
                    await this.CarregaSetupFinanceiro(garId);
                }
            } finally {
                this.SetupEnviando = false;
            }
        },
    async CarregaMetodosMensalidade () {
      try {
        const response = await axios.get('/Telas/Garantidoras/MetodosPagamentoMensalidade')
        this.MensalidadeMetodos = Array.isArray(response.data) ? response.data : []
      } catch (err) { this.$mensagemErro('Não foi possível carregar os métodos de pagamento dos serviços extras.') }
    },
    NovoCicloMensalidade () {
      this.MensalidadeEnviando = false
      this.MensalidadeRequestVersion++
      this.MensalidadeCarregando = false
      this.MensalidadeInicioCiclo = ''
      this.MensalidadeValorPadrao = null
      this.MensalidadeDiaVencimento = 10
      this.MensalidadeFinanceiro = null
      this.MensalidadeErro = ''
      this.MensalidadeCollectionPolicy = { ...novaPoliticaSetup(), automaticChargeEnabled: true, chargeTypeCode: 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: ['CC', 'PIX', 'BB'] }
    },
    AplicaMensalidadeFinanceiro (state) {
      if (!state || Array.isArray(state)) throw new Error('Retorno da recorrência inválido.')
      this.MensalidadeFinanceiro = state
      if (!state.payload) return
      const saved = JSON.parse(state.payload)
      this.MensalidadeInicioCiclo = saved.serviceStartDate
      this.MensalidadeValorPadrao = saved.items[0].unitAmount
      this.MensalidadeDiaVencimento = saved.dueDay
      this.MensalidadeCollectionPolicy = { ...saved.collectionPolicy, chargeTypeCode: saved.collectionPolicy?.chargeTypeCode ?? 'LINK_PAGAMENTO_AUTRA', allowedPaymentMethodCodes: saved.collectionPolicy?.allowedPaymentMethodCodes ?? ['CC', 'PIX', 'BB'] }
    },
    async CarregaMensalidadeFinanceiro () {
      if (!this.ModoFinanceiroCarregado || !this.ModoFinanceiro.enviarAoFinanceiro) return
      const garId = this.Garantidora.garId
      const gplId = this.GarantidoraPlanos.gplId
      this.MensalidadeFinanceiro = null
      this.MensalidadeErro = ''
      if (!garId || !gplId) return
      this.MensalidadeCarregando = true
      const version = ++this.MensalidadeRequestVersion
      const current = () => Number(this.Garantidora.garId) === Number(garId) && Number(this.GarantidoraPlanos.gplId) === Number(gplId) && version === this.MensalidadeRequestVersion
      try {
        const response = await axios.get(`/Telas/Garantidoras/MensalidadeRecorrencia/${garId}`, { showError: false })
        if (current()) this.AplicaMensalidadeFinanceiro(response.data)
      } catch (err) {
        if (current()) this.MensalidadeErro = err.response?.data?.message || 'Não foi possível consultar a recorrência. Atualize a situação antes de enviar.'
      } finally {
        if (current()) this.MensalidadeCarregando = false
      }
    },
    async FaturasMensaisAdd () {
      if (this.MensalidadeBloqueada) return
      const avisar = mensagem => this.$mensagemErro(mensagem, { confirmButtonText: 'OK', allowOutsideClick: false, allowEscapeKey: false })
      if (!Array.isArray(this.MensalidadeCollectionPolicy.allowedPaymentMethodCodes) || !this.MensalidadeCollectionPolicy.allowedPaymentMethodCodes.length) return avisar('Selecione ao menos um método de pagamento para a mensalidade.')
      if (!moment(this.MensalidadeInicioCiclo, 'YYYY-MM-DD', true).isValid()) return avisar('Informe o início real do serviço.')
      if (!Number.isFinite(this.MensalidadeValorPadrao) || this.MensalidadeValorPadrao <= 0 || this.MensalidadeValorPadrao > 999999999) return avisar('Informe um valor mensal válido.')
      if (!Number.isInteger(this.MensalidadeDiaVencimento) || this.MensalidadeDiaVencimento < 1 || this.MensalidadeDiaVencimento > 31) return avisar('Informe o dia de vencimento entre 1 e 31.')
      const garId = this.Garantidora.garId
      const gplId = this.GarantidoraPlanos.gplId
      const version = this.MensalidadeRequestVersion
      this.MensalidadeEnviando = true
      const current = () => Number(this.Garantidora.garId) === Number(garId) && Number(this.GarantidoraPlanos.gplId) === Number(gplId) && version === this.MensalidadeRequestVersion
      try {
        const response = await axios.post('/Telas/Garantidoras/MensalidadeRecorrencia', {
          garId, gplId, serviceStartDate: this.MensalidadeInicioCiclo,
          amount: this.MensalidadeValorPadrao, dueDay: this.MensalidadeDiaVencimento,
          collectionPolicy: {
            chargeTypeCode: 'LINK_PAGAMENTO_AUTRA',
            allowedPaymentMethodCodes: [...this.MensalidadeCollectionPolicy.allowedPaymentMethodCodes],
            penaltyPercentage: this.MensalidadeCollectionPolicy.penaltyPercentage,
            dailyInterestPercentage: this.MensalidadeCollectionPolicy.dailyInterestPercentage,
            igpmEnabled: this.MensalidadeCollectionPolicy.igpmEnabled,
            notifyEmail: this.MensalidadeCollectionPolicy.notifyEmail
          }
        }, { showError: false })
        if (current()) this.AplicaMensalidadeFinanceiro(response.data)
      } catch (err) {
        if (current()) {
          await avisar(err.response?.data?.message || err.response?.data?.Message || 'Não foi possível confirmar o registro da recorrência.')
          if (current()) await this.CarregaMensalidadeFinanceiro()
        }
      } finally {
        if (current()) this.MensalidadeEnviando = false
      }
    },
    // Faturamento
    // Sinistro
    CarregaSinistro (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdSinistroConfiguracao/' + _garId)
        .then(response => {
          if (response.data.length > 0) {
            const cfg = response.data[0]

            const raw = cfg.gscEmailDiasCobranca // pode vir "1,2,3" ou já array
            cfg.gscEmailDiasCobranca = Array.isArray(raw)
              ? raw
              : (raw
                  ? String(raw)
                    .split(',')
                    .map(s => s.trim())
                    .filter(Boolean)
                    .map(n => Number(n)) // <- se seus item-value são números
                  : [])

            this.SinistroConfig = cfg
          }
        })
    },
    CarregaDocumentosSinistrosDisponiveis () {
      axios.get('/Telas/Garantidoras/GetDocumentosSinistros')
        .then(response => {
          const documentos = response.data || []
          this.ListaDocumentosSinistroDisponiveis = documentos.filter(x => x.docTipo == 1)
          this.ListaDocumentosDebitoSinistroDisponiveis = documentos.filter(x => x.docTipo == 2)
        })
    },
    CarregaTiposSinistro () {
      axios.get('/Telas/Garantidoras/GetTiposSinistro')
        .then(response => {
          this.ListaTiposSinistro = response.data || []
        })
    },
    CarregaSinistroDocumentos (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdSinistroDocumentos/' + _garId)
        .then(response => {
          this.ListaSinistroDocumentos = response.data || []
        })
    },
    CarregaSinistroDebitoDocumentos (_garId) {
      axios.get('/Telas/Garantidoras/GetByGarIdSinistroDebitosDocumentos/' + _garId)
        .then(response => {
          this.ListaSinistroDebitoDocumentos = response.data || []
        })
    },
    SinistroDocumentoIncluir () {
      if (this.DocumentoSinistro.docId === null || this.DocumentoSinistro.docId === '') {
        this.$mensagemAviso('Documento Obrigatorio.')
        return
      }
      if (this.ListaSinistroDocumentos.some(x => x.docId == this.DocumentoSinistro.docId)) {
        this.$mensagemAviso('Documento ja incluido.')
        return
      }

      const tipoSinistro = this.DocumentoSinistro.tsnId == null
        ? { tsnId: null, tsnNome: 'Todos' }
        : this.ListaTiposSinistro.find(x => x.tsnId == this.DocumentoSinistro.tsnId)
      const documento = this.ListaDocumentosSinistroDisponiveis.find(x => x.docId == this.DocumentoSinistro.docId)
      if (!tipoSinistro || !documento) return

      this.ListaSinistroDocumentos.push({
        garId: this.Garantidora.garId,
        garNome: this.Garantidora.garNomeEmpresa,
        tsnId: tipoSinistro.tsnId,
        tsnNome: tipoSinistro.tsnNome,
        docId: documento.docId,
        docNome: documento.docNome
      })
      this.DocumentoSinistro.tsnId = null
      this.DocumentoSinistro.docId = null
    },
    SinistroDocumentoRemover (index) {
      this.ListaSinistroDocumentos.splice(index, 1)
    },
    async SinistroDocumentosSalvar () {
      if (this.Garantidora.garId === 0 || this.Garantidora.garId === null) {
        this.$mensagemAviso('Garantidora Obrigatoria.')
        return
      }

      await axios.delete('/Telas/Garantidoras/DeleteSinistroDocumentos/' + this.Garantidora.garId)
      const requests = this.ListaSinistroDocumentos.map(item => axios.post('/Telas/Garantidoras/AddSinistroDocumentos', {
        garId: this.Garantidora.garId,
        garNome: this.Garantidora.garNomeEmpresa,
        tsnId: item.tsnId,
        tsnNome: item.tsnNome,
        docId: item.docId,
        docNome: item.docNome
      }))

      await Promise.all(requests)
      this.CarregaSinistroDocumentos(this.Garantidora.garId)
      this.$mensagemAvisoSucesso('Documentos Sinistros Salvos.')
    },
    SinistroDebitoDocumentoIncluir () {
      if (this.DocumentoDebitoSinistro.docId === null || this.DocumentoDebitoSinistro.docId === '') {
        this.$mensagemAviso('Documento Obrigatorio.')
        return
      }
      if (this.ListaSinistroDebitoDocumentos.some(x => x.docId == this.DocumentoDebitoSinistro.docId)) {
        this.$mensagemAviso('Documento ja incluido.')
        return
      }

      const documento = this.ListaDocumentosDebitoSinistroDisponiveis.find(x => x.docId == this.DocumentoDebitoSinistro.docId)
      if (!documento) return

      this.ListaSinistroDebitoDocumentos.push({
        garId: this.Garantidora.garId,
        garNome: this.Garantidora.garNomeEmpresa,
        docId: documento.docId,
        docNome: documento.docNome,
        possuiJuros: this.DocumentoDebitoSinistro.possuiJuros
      })
      this.DocumentoDebitoSinistro.docId = null
      this.DocumentoDebitoSinistro.possuiJuros = false
    },
    SinistroDebitoDocumentoRemover (index) {
      this.ListaSinistroDebitoDocumentos.splice(index, 1)
    },
    async SinistroDebitoDocumentosSalvar () {
      if (this.Garantidora.garId === 0 || this.Garantidora.garId === null) {
        this.$mensagemAviso('Garantidora Obrigatoria.')
        return
      }

      await axios.delete('/Telas/Garantidoras/DeleteSinistroDebitoDocumentos/' + this.Garantidora.garId)
      const requests = this.ListaSinistroDebitoDocumentos.map(item => axios.post('/Telas/Garantidoras/AddSinistroDebitoDocumentos', {
        garId: this.Garantidora.garId,
        garNome: this.Garantidora.garNomeEmpresa,
        docId: item.docId,
        docNome: item.docNome,
        possuiJuros: item.possuiJuros
      }))

      await Promise.all(requests)
      this.CarregaSinistroDebitoDocumentos(this.Garantidora.garId)
      this.$mensagemAvisoSucesso('Documentos Debitos Sinistros Salvos.')
    },
    async SinistroAdd () {
      if (this.SinistroConfig.gscEmailAprovacao === '' || this.SinistroConfig.gscEmailAprovacao === null) {
        this.$mensagemAviso('E-mail Aprovação Obrigatório.')
      } else if (this.SinistroConfig.gscEmailPagamento === '' || this.SinistroConfig.gscEmailPagamento === null) {
        this.$mensagemAviso('E-mail Pagamento Obrigatório.')
      } else if (this.SinistroConfig.gscEmailCobranca === '' || this.SinistroConfig.gscEmailCobranca === null) {
        this.$mensagemAviso('E-mail Cobrança Obrigatório.')
      } else if (this.SinistroConfig.gscEmailFinanceiro === '' || this.SinistroConfig.gscEmailFinanceiro === null) {
        this.$mensagemAviso('E-mail Financeiro Obrigatório.')
      } else if (this.SinistroConfig.gscEmailJuridico === '' || this.SinistroConfig.gscEmailJuridico === null) {
        this.$mensagemAviso('E-mail Jurírico Obrigatório.')
      } else if (this.SinistroConfig.gscMulta === '' || this.SinistroConfig.gscMulta === null) {
        this.$mensagemAviso('Multa Obrigatório.')
      } else if (this.SinistroConfig.gscJuroDiario === '' || this.SinistroConfig.gscJuroDiario === null) {
        this.$mensagemAviso('Juro Diário Obrigatório.')
      } else {
        this.SinistroConfig.garId = this.Garantidora.garId
        this.SinistroConfig.gscMulta = parseFloat(String(this.SinistroConfig.gscMulta).replaceAll(',', '.'))
        this.SinistroConfig.gscJuroDiario = parseFloat(String(this.SinistroConfig.gscJuroDiario).replaceAll(',', '.'))
        this.SinistroConfig.gscEmailDiasCobranca = (this.SinistroConfig.gscEmailDiasCobranca || []).join(',')
        // console.log('this.SinistroConfig')
        // console.log(this.SinistroConfig)
        axios.post('/Telas/Garantidoras/AddGarantidoraSinistroConfiguracao', this.SinistroConfig)
          .then(response => {
            if (response.data > 0) {
              this.SinistroConfig.garId = response.data
              this.CarregaSinistro(this.SinistroConfig.garId)
              this.$mensagemAvisoSucesso('Configuração Sinistro Incluída')
            }
          })
      }
    },
    async SinistroPut () {
      if (this.SinistroConfig.gscEmailAprovacao === '' || this.SinistroConfig.gscEmailAprovacao === null) {
        this.$mensagemAviso('E-mail Aprovação Obrigatório.')
      } else if (this.SinistroConfig.gscEmailPagamento === '' || this.SinistroConfig.gscEmailPagamento === null) {
        this.$mensagemAviso('E-mail Pagamento Obrigatório.')
      } else if (this.SinistroConfig.gscEmailCobranca === '' || this.SinistroConfig.gscEmailCobranca === null) {
        this.$mensagemAviso('E-mail Cobrança Obrigatório.')
      } else if (this.SinistroConfig.gscEmailFinanceiro === '' || this.SinistroConfig.gscEmailFinanceiro === null) {
        this.$mensagemAviso('E-mail Financeiro Obrigatório.')
      } else if (this.SinistroConfig.gscEmailJuridico === '' || this.SinistroConfig.gscEmailJuridico === null) {
        this.$mensagemAviso('E-mail Jurírico Obrigatório.')
      } else if (this.SinistroConfig.gscMulta === '' || this.SinistroConfig.gscMulta === null) {
        this.$mensagemAviso('Multa Obrigatório.')
      } else if (this.SinistroConfig.gscJuroDiario === '' || this.SinistroConfig.gscJuroDiario === null) {
        this.$mensagemAviso('Juro Diário Obrigatório.')
      } else {
        this.SinistroConfig.garId = this.Garantidora.garId
        this.SinistroConfig.gscMulta = parseFloat(String(this.SinistroConfig.gscMulta).replaceAll(',', '.'))
        this.SinistroConfig.gscJuroDiario = parseFloat(String(this.SinistroConfig.gscJuroDiario).replaceAll(',', '.'))
        this.SinistroConfig.gscEmailDiasCobranca = (this.SinistroConfig.gscEmailDiasCobranca || []).join(',')
        axios.put('/Telas/Garantidoras/UpdateGarantidoraSinistroConfiguracao', this.SinistroConfig)
          .then(response => {
            this.CarregaSinistro(this.SinistroConfig.garId)
            this.$mensagemAvisoSucesso('Configuração Sinistro Alterada')
          })
      }
    },
    // Sinistro
    exportCSV () {
      if (this.ListGarantidoras.length === 0) {
        alert('Não há dados para exportar.')
        return
      }

      const csvHeader = this.headers
        .map(h => h.text)
        .join(';') + '\n'

      // 2) Liste as chaves dinamicamente (aqui já só as que sobraram após slice)
      const keys = this.headers
        .map(h => h.value)

      const csvRows = this.ListGarantidoras
        .map(item => {
          return keys
            .map(key => {
              // para os demais campos, pega direto do item
              return item[key] != null ? item[key] : ''
            })
            .join(';')
        })
        .join('\n')

      // Concatena os filtros, o cabeçalho e as linhas de dados
      const csvContent = 'data:text/csv;charset=utf-8,\uFEFF' + csvHeader + csvRows

      // Cria o link de download
      const encodedUri = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'RelatorioListaGarantidoras.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    exportXLSX_Garantidoras () {
      if (!this.ListGarantidoras || this.ListGarantidoras.length === 0) {
        alert('Não há dados para exportar.')
        return
      }
      if (!this.headers || this.headers.length === 0) {
        alert('Sem colunas para exportar.')
        return
      }

      // Cabeçalhos e chaves
      const headers = this.headers.map(h => String(h.text || ''))
      const keys = this.headers.map(h => String(h.value || ''))

      // Helpers de inferência
      const isDocField = (label) => /(^|\b)(cpf|cnpj|documento|rg|ie|cep|telefone|celular|whats|conta|agencia|pix|codigo|código)\b/i.test(label)
      const isCurrency = (label) => /(valor|preço|preco|taxa|tarifa|total|subtotal|receita|custo|despesa)/i.test(label)
      const isInteger = (label) => /(id|qtd|quantidade|número|numero|ano)/i.test(label)
      const isISODate = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}([ T]\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:?\d{2})?)?$/.test(v)
      const parseBRNumber = (v) => {
        if (typeof v === 'number') return v
        if (v == null || v === '') return null
        const s = String(v).trim().replace(/\./g, '').replace(',', '.')
        const n = parseFloat(s)
        return isNaN(n) ? null : n
      }

      // Mapeia colunas para tipos pretendidos
      const colMeta = headers.map((h, i) => {
        const key = keys[i] || ''
        const label = `${h} ${key}`
        return {
          i,
          header: h,
          key,
          forceText: isDocField(label),
          currency: isCurrency(label),
          integer: isInteger(label)
        }
      })

      // Constrói linhas com rótulos = cabeçalhos
      const rows = this.ListGarantidoras.map(item => {
        const row = {}
        colMeta.forEach(({ header, key, forceText, currency, integer }) => {
          const val = item?.[key]

          if (forceText) {
            // Garante texto para preservar zeros à esquerda
            row[header] = (val == null) ? '' : String(val)
            return
          }

          // Datas
          if (isISODate(val)) {
            const d = new Date(val)
            row[header] = isNaN(d.getTime()) ? (val ?? '') : d
            return
          }

          // Números (moeda ou inteiros)
          if (currency) {
            const n = parseBRNumber(val)
            row[header] = (n == null) ? null : n
            return
          }
          if (integer) {
            const n = parseBRNumber(val)
            row[header] = (n == null) ? null : Math.trunc(n)
            return
          }

          // Default
          row[header] = (val == null) ? '' : val
        })
        return row
      })

      // Cria a planilha
      const ws = XLSX.utils.json_to_sheet(rows, { header: headers, skipHeader: false })

      // Formata células por coluna (número, moeda, data)
      if (ws['!ref']) {
        const range = XLSX.utils.decode_range(ws['!ref'])
        const headerRow = range.s.r // 0
        const dataStart = headerRow + 1

        colMeta.forEach(({ i, currency, integer }) => {
          for (let r = dataStart; r <= range.e.r; r++) {
            const addr = XLSX.utils.encode_cell({ c: i, r })
            const cell = ws[addr]
            if (!cell) continue

            // Datas (quando json_to_sheet detecta Date, já vem t='n' com serial; reforçamos formato)
            // Se o valor original era Date, definimos formato
            const isDateObj = rows[r - dataStart] && rows[r - dataStart][headers[i]] instanceof Date

            if (isDateObj) {
              cell.t = 'd'
              cell.z = 'dd/mm/yyyy'
              continue
            }

            // Moeda
            if (currency && (typeof cell.v === 'number')) {
              cell.t = 'n'
              cell.z = '#,##0.00'
              continue
            }

            // Inteiro
            if (integer && (typeof cell.v === 'number')) {
              cell.t = 'n'
              cell.z = '0'
              continue
            }
          }
        })

        // AutoFiltro no cabeçalho
        ws['!autofilter'] = { ref: ws['!ref'] }
      }

      // Larguras de coluna (baseado em cabeçalho + amostra de linhas)
      const sampleCount = Math.min(rows.length, 200)
      ws['!cols'] = headers.map((h, c) => {
        let max = String(h || '').length
        for (let r = 0; r < sampleCount; r++) {
          const v = rows[r]?.[h]
          const s = v instanceof Date ? 'dd/mm/yyyy' : (v == null ? '' : String(v))
          if (s.length > max) max = s.length
        }
        // margem e limite
        const wch = Math.min(Math.max(max + 2, 8), 50)
        return { wch }
      })

      // Gera workbook e salva
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Garantidoras')
      XLSX.writeFile(wb, 'RelatorioListaGarantidoras.xlsx', { compression: true })
    },
    async Get () {
      this.ModoFinanceiroCarregado = false
      const modo = await axios.get('/Telas/Garantidoras/ModoFinanceiro')
      this.ModoFinanceiro = modo.data
      this.ModoFinanceiroCarregado = true
      await axios.get('/Telas/Garantidoras/GetDados')
        .then(response => {
          this.User.garid = response.data.garId
          this.User.tpeid = response.data.tpeId
          this.User.tusid = response.data.tusId
          if (this.User.garid == 0) {
            this.EditView = false
            this.ListGarantidorasGeral = Array.isArray(response.data.garantidoras)
              ? response.data.garantidoras.filter(x => x.garVisivel)
              : []
            this.CarregaLista()
            this.montaGrid()
          } else {
            const _item = { garId: this.User.garid }
            this.EditGrid(_item)
          }

          this.TiposDocumentos = response.data.tipoDocumentos.filter(x => x.tpdAtivo)
          this.ListaPlanos = response.data.planosGarantePay
          this.TipoOperadoras = response.data.tipoOperadoras.filter(x => x.topAtivo)
          this.ListaContratos = response.data.modelosContratos
          this.ListProdutos = response.data.produtos
        })
    }
  },
  created () {
    this.Get()
    this.CarregaDocumentosSinistrosDisponiveis()
    this.CarregaTiposSinistro()
    this.CarregaListaServicoExtra()
  },
  computed: {
        MensalidadeBloqueada () {
            return this.MensalidadeCarregando || this.MensalidadeEnviando || Boolean(this.MensalidadeErro) || !this.MensalidadeFinanceiro || Boolean(this.MensalidadeFinanceiro.status || this.MensalidadeFinanceiro.blockReason)
        },
        MensalidadeTipoMensagem () {
            if (this.MensalidadeErro || this.MensalidadeFinanceiro?.status === 'DEAD_LETTER') return 'error'
            if (this.MensalidadeFinanceiro?.blockReason || this.MensalidadeFinanceiro?.status === 'RETRY') return 'warning'
            return this.MensalidadeFinanceiro?.status === 'PROCESSED' ? 'success' : 'info'
        },
        MensalidadeMensagem () {
            if (this.MensalidadeCarregando) return 'Consultando a recorrência…'
            if (this.MensalidadeErro) return this.MensalidadeErro
            if (this.MensalidadeFinanceiro?.blockReason) return this.MensalidadeFinanceiro.blockReason
            const status = this.MensalidadeFinanceiro?.status
            if (status === 'DEAD_LETTER') return 'O envio da recorrência falhou e precisa de análise. O registro foi preservado para evitar duplicidade.'
            if (status === 'PROCESSED') return 'Recorrência registrada no Financeiro. A geração mensal das obrigações e dos links segue os calendários configurados.'
            if (status) return 'Recorrência registrada para envio. Atualize a situação para acompanhar o processamento.'
            return 'Será enviada uma única recorrência mensal, sem término, com cobrança automática. Não é necessário reenviar a cada mês.'
        },
SetupTipoMensagem() {
            if (this.SetupErroConsulta || this.SetupFinanceiro?.status === 'DEAD_LETTER' || this.SetupFinanceiro?.lastHttpStatus === 409) return 'error';
            if (this.SetupFinanceiro?.hasPaidInstallments || this.SetupFinanceiro?.status === 'RETRY') return 'warning';
            if (this.SetupFinanceiro?.status === 'PROCESSED') return 'success';
            return 'info';
        },
SetupBloqueado() {
            return this.SetupCarregando || this.SetupEnviando || this.SetupCancelando || this.SetupErroConsulta || !this.SetupFinanceiro
                || Boolean(this.SetupFinanceiro.status) || this.SetupFinanceiro.hasPaidInstallments;
        },
SetupMensagem() {
            if (this.SetupCarregando) return 'Consultando situação do Setup...';
            if (this.SetupErroConsulta) return 'Não foi possível consultar o Setup. Atualize a situação para continuar.';
            const status = this.SetupFinanceiro?.status;
            if (this.SetupFinanceiro?.isCancellation) {
                if (status === 'PROCESSED') return 'Cancelamento do Setup confirmado pelo Financeiro.';
                if (this.SetupFinanceiro.lastHttpStatus === 409) return 'Cancelamento com conflito no Financeiro. Necessária análise; não significa que o Setup foi cancelado.';
                if (status === 'DEAD_LETTER') return 'Falha na integração do cancelamento. Necessária análise; o cancelamento não foi confirmado.';
                if (status === 'RETRY') return 'Cancelamento aguardando nova tentativa de envio ao Financeiro.';
                return 'Cancelamento do Setup aguardando confirmação do Financeiro.';
            }
            if (status === 'PROCESSED') return 'Setup sincronizado com o Financeiro.';
            if (status === 'DEAD_LETTER') return 'Setup com falha na integração. Necessária análise; o envio permanece bloqueado.';
            if (status === 'RETRY') return 'Setup aguardando nova tentativa de sincronização com o Financeiro.';
            if (status) return 'Setup aguardando sincronização com o Financeiro.';
            if (this.SetupFinanceiro?.hasPaidInstallments) return 'Setup com parcelas pagas. Sincronização indisponível nesta etapa.';
            if (this.SetupFinanceiro?.hasLegacyInstallments) return 'As parcelas existentes serão preservadas e enviadas ao Financeiro.';
            return '';
        },

    documentoMask () {
      return this.Garantidora.tpdId === 1 ? '###.###.###-##' : 'XX.XXX.XXX/XXXX-##'
    }
  }
}
</script>

<style scoped>
.gp-billing-cards { display: grid; gap: 20px; padding: 4px 0 12px; }
.gp-billing-card { overflow: hidden; border: 1px solid #e6ddd0; border-radius: 14px; background: #fff; }
.gp-billing-card-header { display: flex; align-items: center; gap: 12px; padding: 20px 24px; background: #fcfaf7; border-bottom: 1px solid #eee7dd; }
.gp-billing-icon { display: grid; place-items: center; width: 42px; height: 42px; border-radius: 12px; background: #fff0dc; color: #d77a00; }
.gp-billing-card-header h3 { margin: 0 0 4px; color: #173452; font-size: 16px; font-weight: 700; }
.gp-billing-card-header p, .gp-billing-policy p { margin: 0; color: #667589; font-size: 12px; line-height: 1.6; }
.gp-billing-card-body { padding: 24px; }
.gp-billing-fields, .gp-billing-policy-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px; }
.gp-billing-fields label, .gp-billing-policy-field label { display: block; color: #34465b; font-size: 12px; font-weight: 600; }
.gp-billing-card .form-control { width: 100%; min-height: 40px; margin-top: 7px; border-radius: 8px; font-size: 13px; }
.gp-billing-policy { margin-top: 26px; padding-top: 22px; border-top: 1px solid #eee7dd; }
.gp-billing-policy fieldset { min-width: 0; }
.gp-billing-policy-title { font-size: 13px; font-weight: 700; color: #34465b; }
.gp-billing-policy-grid { margin: 18px 0; align-items: end; }
.gp-billing-policy input[type="checkbox"] { width: 16px; height: 16px; margin-right: 7px; vertical-align: middle; accent-color: #ed8500; }
.gp-monthly-bulk { margin-top: 22px; padding: 18px; background: #f8fafc; border: 1px solid #e5eaf0; border-radius: 10px; }
.gp-monthly-bulk h4 { font-size: 13px; font-weight: 700; color: #34465b; margin: 0 0 14px; }
.gp-monthly-bulk-actions { display: flex; justify-content: flex-end; gap: 10px; flex-wrap: wrap; margin-top: 16px; }
.gp-monthly-bulk-actions .btn { font-size: 12px; }
.gp-monthly-table-wrap { overflow-x: auto; margin-top: 22px; border: 1px solid #e5eaf0; border-radius: 10px; }
.gp-monthly-table { width: 100%; min-width: 800px; border-collapse: collapse; font-size: 12px; }
.gp-monthly-table th { padding: 12px; text-align: left; color: #596478; background: #f8fafc; }
.gp-monthly-table td { padding: 10px 12px; border-top: 1px solid #e5eaf0; }
.gp-monthly-table .form-control { margin: 0; min-width: 110px; }
.gp-monthly-table select.form-control { min-width: 150px; }
.gp-monthly-status { color: #596478; white-space: nowrap; }
.gp-monthly-generation { display: block; max-width: 260px; margin-top: 20px; font-size: 12px; font-weight: 600; }
.gp-billing-help { margin: 16px 0 0; color: #667589; font-size: 12px; line-height: 1.6; }
.gp-billing-alert { margin-top: 22px; border-radius: 9px; font-size: 12px; }
.gp-billing-card-actions { display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 10px; padding: 16px 24px; border-top: 1px solid #eee7dd; background: #fcfaf7; }
.gp-billing-card-actions .btn { min-height: 38px; padding: 8px 16px; border-radius: 8px; font-size: 12px; font-weight: 600; }
@media (max-width: 767px) { .gp-billing-fields, .gp-billing-policy-grid { grid-template-columns: 1fr; gap: 14px; } .gp-billing-card-header, .gp-billing-card-body, .gp-billing-card-actions { padding: 16px; } .gp-billing-card-actions .btn { width: 100%; } }

  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
  .gp-guarantor-address { margin: 6px 12px 14px; overflow: hidden; border: 1px solid #e1d9cd; border-radius: 12px; background: #fffdf9; }
  .gp-guarantor-section-header { margin: 8px 12px 0; border: 1px solid #e1d9cd; border-radius: 12px 12px 0 0; background: #fcf8f2; }
  .gp-guarantor-section-header + .v-form { margin: 0 12px 8px; border: 1px solid #e1d9cd; border-top: 0; border-radius: 0 0 12px 12px; background: #fffdf9; }
  .gp-guarantor-address .gp-admin-form-header { border-bottom: 1px solid #e8e1d7; background: #fcf8f2; }
  .gp-guarantor-address :deep(.v-container) { max-width: none; padding: 14px 16px 10px; }
  .gp-guarantor-subsection { display: block; margin: 8px 12px 14px; overflow: hidden; border: 1px solid #e1d9cd; border-radius: 12px; background: #fffdf9; }
  .gp-guarantor-subsection .gp-admin-form-header { border-bottom: 1px solid #e8e1d7; background: #fcf8f2; }
  .gp-guarantor-subsection :deep(.v-container) { max-width: none; padding: 14px 16px 12px; }
  .gp-guarantor-subsection :deep(.v-table) { overflow: hidden; border: 1px solid #e1d9cd; border-radius: 10px; font-size: 10.5px; }
  .gp-guarantor-subsection :deep(.v-table th) { height: 34px; background: #f1ece4; color: #596478; font-size: 9px; font-weight: 800; letter-spacing: .05em; text-transform: uppercase; }
  .gp-guarantor-subsection :deep(.v-table td) { height: 38px; border-color: #ebe5dc; color: #465168; }
  .gp-extra-service-action { padding-top: 27px !important; }
  .gp-cep-action { padding-top: 27px !important; }
  .gp-guarantor-url-config { margin: 4px 0 10px; padding: 12px; border: 1px solid #d9e2f0; border-radius: 11px; background: #f2f6fc; }
  .gp-guarantor-url-config > label { display: block; margin-bottom: 6px; color: #183765; font-size: 11px; font-weight: 750; }
  .gp-guarantor-url-input { display: flex; align-items: stretch; }
  .gp-guarantor-url-input > span { display: flex; align-items: center; max-width: 55%; padding: 0 11px; overflow: hidden; border: 1px solid #ccd6e5; border-right: 0; border-radius: 8px 0 0 8px; background: #e8eef7; color: #52627a; font-size: 11px; white-space: nowrap; text-overflow: ellipsis; }
  .gp-guarantor-url-input > input { min-width: 0; border-radius: 0 8px 8px 0; font-size: 11.5px; }
  .gp-guarantor-url-config > small { display: block; margin-top: 5px; color: #6d788b; font-size: 9.5px; }
  .gp-guarantor-settings { display: grid; grid-template-columns: minmax(180px, .8fr) minmax(260px, 1.2fr) minmax(280px, 1.4fr) auto; align-items: center; gap: 10px; margin: 4px 0 6px; padding: 12px; border: 1px solid #e1d9cd; border-radius: 11px; background: #fcf8f2; }
  .gp-guarantor-setting { min-height: 46px; display: flex; align-items: center; padding: 3px 10px; border-right: 1px solid #e7dfd4; }
  .gp-guarantor-setting :deep(.v-label) { color: #596478; font-size: 11px !important; font-weight: 650; opacity: 1; }
  .gp-guarantor-logo label { display: block; margin-bottom: 5px; color: #4d586d; font-size: 11px; font-weight: 750; }
  .gp-guarantor-logo :deep(.v-field) { min-height: 38px; border-radius: 9px; background: #fff; font-size: 11.5px; }
  .gp-guarantor-logo-preview { display: flex; align-items: center; gap: 7px; padding-left: 4px; }
  .gp-guarantor-logo-preview img { width: 54px; height: 38px; object-fit: contain; border: 1px solid #ded7cc; border-radius: 8px; background: #fff; }
  .gp-guarantor-access-link { display: flex; align-items: center; gap: 9px; padding: 9px 12px; border: 1px solid #d9e2f0; border-radius: 9px; background: #f2f6fc; color: #183765; }
  .gp-guarantor-access-link > span { display: flex; min-width: 0; flex-direction: column; gap: 1px; }
  .gp-guarantor-access-link small { color: #6d788b; font-size: 9.5px; font-weight: 650; }
  .gp-guarantor-access-link strong { font-size: 10.5px; overflow-wrap: anywhere; }
  .gp-guarantor-actions { display: flex !important; align-items: center; justify-content: space-between !important; gap: 14px; }
  .gp-guarantor-actions__left, .gp-guarantor-actions__right { display: flex; align-items: center; gap: 8px; }
  .gp-guarantor-actions .btn { min-height: 34px; display: inline-flex; align-items: center; justify-content: center; gap: 5px; margin: 0; }
  @media (max-width: 1050px) { .gp-guarantor-settings { grid-template-columns: repeat(2, minmax(0, 1fr)); } .gp-guarantor-setting { border-right: 0; } }
  @media (max-width: 767.98px) { .gp-guarantor-address, .gp-guarantor-subsection { margin: 6px 0 12px; } .gp-guarantor-section-header { margin-right: 0; margin-left: 0; } .gp-guarantor-section-header + .v-form { margin-right: 0; margin-left: 0; } .gp-cep-action, .gp-extra-service-action { padding-top: 0 !important; } .gp-cep-action .btn, .gp-extra-service-action .btn { width: 100%; } .gp-guarantor-url-input { flex-direction: column; } .gp-guarantor-url-input > span { max-width: none; min-height: 34px; border-right: 1px solid #ccd6e5; border-bottom: 0; border-radius: 8px 8px 0 0; } .gp-guarantor-url-input > input { border-radius: 0 0 8px 8px; } .gp-guarantor-settings { grid-template-columns: 1fr; } .gp-guarantor-actions { align-items: stretch; flex-direction: column; } .gp-guarantor-actions__left, .gp-guarantor-actions__right { align-items: stretch; flex-direction: column; } .gp-guarantor-actions .btn { width: 100%; } }
</style>
